import React, { useEffect, useRef } from "react";
import axios from "axios";
import cssClasses from "./Profile.module.css";
import action from "../../Redux Store/actions";
import _ from "lodash";
import Dropdown from "../../Subcomponents/DropDown";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button as MUIButton
} from "@mui/material";
import ReraUploadModal from "../Register/ReraUploadModal"; // adjust path
import { parseCertificateText } from "../../Services/SmsService";

//Icons
import SearchIcon from "../../Assets/Images/SearchIcon.svg";
import RejectedIcon from "../Icons/RejectedIcon";
import Dot from "../Icons/Dot";
import Avatar from "../../Assets/Images/Avatar.svg";
import Camera from "../../Assets/Images/Camera.svg";
import AskFirmNameDialog from "../Register/AskFirmNameDialog";
import { toast } from "react-toastify";

import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";
//SubComponents
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import FullScreenLoader from "../Profile/FullScreenLoader";

//MUI
import Paper from "@material-ui/core/Paper";
import Autocomplete from "@mui/material/Autocomplete";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@mui/material/TextField";

import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";

//services
import { supabase } from "../../supabaseClient";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../Redux Store/actions";
import {
  errorTost,
  infoTost,
  offlineToast,
  successTost,
} from "../../Services/Toast";
import debounce from "lodash.debounce";
import {
  authUpDateSignUp,
  getCpBillingName,
  getCpSourceName,
  handleErrors,
  signOut,
} from "../../Services/LoginService";
import {
  checkForUniqueDocs,
  checkPanNumberExists,
  checkReraNumberExists,
  checkGSTNumberExists,
  checkBankDetailsExists,
} from "../../Services/LoginService";
import {
  getPAN_cardDetails,
  getAadharCardDetails,
  getReraDetails,
  getAccountDetails,
  getGSTInfo,
  getGSTNumber,
} from "../../Services/SurepassApi";
import { namesMatch } from "../../Services/nameMatch";
import DropDown from "../../Subcomponents/DropDown";
// ? capacitor network for online/offline status
import { Network } from "@capacitor/network";
import GreenChecked from "../Icons/GreenChecked";
import {
  checkLeadEmailExists,
  checkLeadEmailExistsInCp,
  checkLeadEmailExistsInUsers,
  checkPhoneNumberIsBlackListed,
} from "../../Services/LeadService";
import {
  sendOTPMessage,
  sendOTPMessageMail,
  readReraPdfFile,
} from "../../Services/SmsService";
import CryptoJS from "crypto-js";
import CountdownTimer from "../../Subcomponents/CountDownTimer";

import EditIcon from "@mui/icons-material/Edit";
import { Tooltip } from "@material-ui/core";
import { Navigate, useNavigate } from "react-router-dom";
import store from "../../Redux Store/store";
const useStyles = makeStyles((theme) => ({
  customTextField: {
    "& input::placeholder": {
      fontSize: "1.6rem !important",
    },
  },
  autoCompleteInput: {
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
  },
  stepper: {
    "& .MuiLinearProgress-root": {
      backgroundColor: "rgba(82, 108, 130, 0.1) !important",
      height: "0.8rem !important",
      borderRadius: "5rem !important",
      width: "100% !important",
      "& .MuiLinearProgress-bar": {
        backgroundColor: "#155EEF !important",
      },
    },
  },
}));

const theme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontSize: "1.6rem !important",
          fontFamily: "Inter-Medium !important",
          lineHeight: "2.4rem !important",
          borderRadius: 20,
          borderColor: "#84CAFF !important",
          paddingRight: "3rem !important",
          "& input[text]": {
            color: "#101828 !important",
          },
          "& input[input:-internal-autofill-selected]": {
            background: "#F2F4F7 !important",
          },
          "& input[value]": {
            background: "#FFFFF !important",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "&.Mui-focused": {
            background: "#FFFFFF",
            border: "1px solid #84CAFF !important",
            boxShadow:
              "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& label": {
            fontSize: "1.6rem !important",
          },
        },
      },
    },
  },
});

const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth);
  const classes = useStyles();
  const [CPEDetails, setCPEDetails] = useState("");
  const [isLoadingPan, setIsLoadingPan] = useState(false);
  const [isLoadingRERA, setIsLoadingRERA] = useState(false);
  const [isLoadingAadhar, setIsLoadingAadhar] = useState(false);
  const [isLoadingIfSC, setIsLoadingIfSC] = useState(false);
  const [isLoadingAccount, setIsLoadingAccount] = useState(false);
  const [isGSTAvailableFromPan, setIsGSTAvailableFromPan] = useState(false);
  // const [isReraLoading, setIsReraLoading] = useState(false);
  const [showProprietorshipDialog, setShowProprietorshipDialog] = useState(false);
  const [shopActFile, setShopActFile] = useState(null);
  const [showUpload, setShowUpload] = useState(false);



  // const [gstArray, setGstArray] = useState([]);
const [activeGSTOptions, setActiveGSTOptions] = useState([]);

  const [bankDetails, setBankDetails] = useState({
    holderName: "",
    accountNumber: "",
    ifscCode: "",
    branchName: "",
    bankName: "",
  });
  const [panCategory, setPanCategory] = useState("");
  const [personDetail, setPersonDetail] = useState({
    personaName: "",
    phoneNumber: "",
    email: "",
    password: "",
  });

  const [helperText, setHelperText] = useState({
    isPanValid: "",
    reraVerified: false,
    panVerified: false,
    gstNumberVerified: false,
    bankDetailsIsVerified: false,
    // isGstApplicable: true,
    isGstNumber: "",
    isBillingName: "",
    reraNumber: "",
    reraDocument: "",
    isMemeNumber: "",
    msmeNumber: "",
    salesPersonName: "",
    isPersonName: "",
    isPhoneNumber: "",
    isEmail: "",
    isPassword: "",
    isHolderName: "",
    isAccountNumber: "",
    isIfscCode: "",
    isBranchName: "",
 
  });

  const [gstArray, setGstArray] = useState([]);
  const [fetchedGstFromPan, setFetchedGstFromPan] = useState("");
  const [billingNameDisabled, setBillingNameDisabled] = useState(false);
  const [ledgerName, setLedgerName] = useState("");

  const [isGSTLoading, setIsGSTLoading] = useState(false);

  // const [helperText, setHelperText] = useState({
  //   panNumber: "",
  //   isPanValid: false,
  //   bankAccountHolderName: "",
  //   bankDetailsIsVerified: false,
  //   // add others as needed
  // });

  // const [isLoadingPan, setIsLoadingPan] = useState(false);
  // const [generalDetail, setGeneralDetail] = useState({});
  // const [profileData, setProfileData] = useState({
  //   type: "CP", // or whatever default you want
  //   name: "",
  //   billingName: "",
  //   bankAccountHolderName: ""
  // // });

  // const [personName, setPersonName] = useState("");

  // const [helperText, setHelperText] = useState({
  //   panNumber: "",
  //   bankDetailsIsVerified: false,
  //   isPanValid: false,
  //   aadharNumber: "",
  //   isAadharValid: false,
  //   reraNumber: "",
  //   isReraValid: false,
  //   CPEName: "",
  //   billingName: "",
  //   msmeType: "",
  //   msmeNumber: "",
  //   bankAccountNumber: "",
  //   bankIFSCCode: "",
  //   bankAccountHolderName: "",
  //   bankBranchName: "",
  //   isPhoneNumber: "",
  //   isPersonName: "",
  //   onChangePhoneNumber:false,
  //   disableContactNumber:false,
  //   email:'',
  // isGstNumber: "",
  // gstNumberVerified: false,

  //     // panNumber: "",
  // isPanValid: false,
  // bankAccountHolderName: "",
  // bankDetailsIsVerified: false,
  // })
  const [panNumber, setPanNumber] = useState("");

  const [generalDetail, setGeneralDetail] = useState({
    panNumber: "",
    panName: "",
    panObject: {},
    aadharObject: {},
    aadharName: "",
    aadharNumber: "",
    reraName: "",
    reraNumber: "",
    reraObject: {},
  });
  const [MSMEList, setMSMEList] = useState([
    "Micro",
    "Small",
    "Medium",
    "Not Applicable",
  ]);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [message, setMessage] = useState("");
  const [messageStatus, setMessageStatus] = useState("");
  const [messageIcon, setMessageIcon] = useState("");
  const [getCPENAME, setGetCPEName] = useState([]);
  const [profileData, setProfileData] = useState(loggedInUser.user);
  let profileDataArr = loggedInUser.user;
  // Display name for CP.cpSourceId, resolved from the Users table.
  const [cpSourceName, setCpSourceName] = useState(null);
  const [oldRera, setOldRera] = useState("");
  const [oldPan, setOldPan] = useState("");
  const [oldPhoneNumber, setOldPhoneNumber] = useState("");
  const [newPhoneNumber, setNewPhoneNumber] = useState("");
  const [newEmailId, setEmailId] = useState("");
  const [personName, setPersonName] = useState("");

  const [cpDetails, setCpDetails] = useState({
    panNumber: "",
    panObject: {},
    reraObject: {},
    gstObject: {},
    gstApplicable: "true",
    gstNumber: "",
    billingName: "",
    reraNumber: "",
    reraDocument: "",
    reraDocumentName: "",
    recomendation: "",
    msmeAvalaible: "",
    msmeNumber: "",
    docUrl: "",
    isFlagged: false,
  });

  const [reraStartDate, setReraStartDate] = useState(null);
  const [reraEndDate, setReraEndDate] = useState(null);
  const [agentType, setAgentType] = useState("");
  const [askFirmNameDialog, setAskFirmNameDialog] = useState(false);

  // const [isLoadingAccount, setIsLoadingAccount] = useState(false);
  const [isReraLoading, setIsReraLoading] = useState(false);
  // const [isReraLoading, setIsReraLoading] = useState(false);
  const [reraPopUp, setReraPopUp] = useState(false);

  console.log(CPEDetails);
  // ------------------------Phone number otp
  const [showOtp, setShowOtp] = useState(false);
  const [isInterNational, setIsInterNational] = useState(false);
  const [resendButton, setResendButton] = useState(false);
  const [otptimer, setOtpTimer] = useState(false);
  const [state, setState] = useState({
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
  });
  const [recievedOtp, setRecievedOtp] = useState(null);
  const verifiedPhoneNumber = useRef(false);
  // Email
  // const [verifiedEmail, setVerifiedEmail] = useState(false);
  const verifiedEmail = useRef(false);
  const [otptimerEmail, setOtpTimerEmail] = useState(false);
  const [showEmailOtp, setShowEmailOtp] = useState(false);
  const [emailState, setEmailState] = useState({
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
  });
  const [recievedEmailOtp, setRecievedEmailOtp] = useState(null);
  const [emailLabelText, setEmailLabelText] = useState("");
  const [showAlertForEmailUpdate, setShowAlertForEmailUpdate] = useState(false);
  const [oldGst, setOldGst] = useState("");


//   const handleFirmDialogClose = () => setAskFirmNameDialog(false);

  
// const handleFirmDialogConfirm = (firmName) => {
//   const trimmedFirmName = firmName.trim();
//   if (!trimmedFirmName) {
//     toast.error("Firm name cannot be empty.");
//     return;
//   }

//   // Save firm name in cpDetails
//   setCpDetails((prev) => ({
//     ...prev,
//     proprietorshipName: trimmedFirmName,
//     billingName: prev?.reraExtracted?.agentName || prev.billingName,
//   }));

//   setHelperText((pre) => ({
//     ...pre,
//     isBillingName: "",
//   }));

//   setAskFirmNameDialog(false);
// };



// put this near your component top
const skipFirmCloseValidationRef = useRef(false);

const handleFirmDialogClose = () => {
  // if not coming from a successful submit, enforce validation
  if (!skipFirmCloseValidationRef.current && !cpDetails?.proprietorshipName?.trim()) {
    toast.error("Please enter and save a valid firm name before closing.");
    return;
  }

  // reset the flag and close
  skipFirmCloseValidationRef.current = false;
  setAskFirmNameDialog(false);
};


// const handleFirmDialogConfirm = ({ firmName, shopActUrl }) => {
//   const trimmedFirmName = (firmName || "").trim();
//   if (!trimmedFirmName) {
//     toast.error("Firm name cannot be empty.");
//     return;
//   }

//   setCpDetails((prev) => ({
//     ...prev,
//     proprietorshipName: trimmedFirmName,
//     billingName: prev?.reraExtracted?.agentName || prev.billingName,
//     shopActUrl, // save uploaded document URL too
//   }));

//   setHelperText((pre) => ({
//     ...pre,
//     isBillingName: "",
//   }));

//   skipFirmCloseValidationRef.current = true;
//   setAskFirmNameDialog(false);
// };

const handleFirmDialogConfirm = ({ firmName, shopActFile }) => {
  const trimmedFirmName = (firmName || "").trim();
  if (!trimmedFirmName) {
    toast.error("Firm name cannot be empty.");
    return;
  }

  setCpDetails((prev) => ({
    ...prev,
    proprietorshipName: trimmedFirmName,
    billingName: prev?.reraExtracted?.agentName || prev.billingName,
  }));

  // store file for later upload
  setShopActFile(shopActFile);

  setHelperText((pre) => ({
    ...pre,
    isBillingName: "",
  }));

  skipFirmCloseValidationRef.current = true;
  setAskFirmNameDialog(false);
};



useEffect(() => {
  setBankDetails((prev) => ({
    ...prev,
    accountNumber: prev.accountNumber || profileData.bankAccountNumber || "",
    holderName: prev.holderName || profileData.bankAccountHolderName || "",
    ifscCode: prev.ifscCode || profileData.bankIFSCCode || "",
  }));
}, [
  profileData.bankAccountNumber,
  profileData.bankAccountHolderName,
  profileData.bankIFSCCode
]);

// Resolve CP.cpSourceId (a Users.userId) into the name shown as "CP Sourcing".
// A failed lookup leaves the field showing "-" rather than breaking the page.
useEffect(() => {
  if (!profileData?.cpSourceId) {
    setCpSourceName(null);
    return;
  }
  getCpSourceName(profileData.cpSourceId)
    .then((name) => setCpSourceName(name))
    .catch((err) => {
      console.log("cpSourceName lookup failed", err);
      setCpSourceName(null);
    });
}, [profileData?.cpSourceId]);







// Add this useEffect in your component
useEffect(() => {
  // If GST number exists after updating PAN, mark GST as applicable
  if (cpDetails.gstNumber && cpDetails.gstNumber.trim() !== "") {
    setCpDetails((pre) => ({
      ...pre,
      gstApplicable: true,
    }));
  } else {
    setCpDetails((pre) => ({
      ...pre,
      gstApplicable: false,
    }));
  }
}, [cpDetails.gstNumber, cpDetails.billingName]); // Runs when GST number or PAN changes


















  

  useEffect(() => {
    console.log("loggedInUser.user: ", loggedInUser.user  );

    setProfileData(loggedInUser.user);

    dispatch(actions.activeMenu("profile"));
    console.log("profileData: ", profileData);
    setOldPhoneNumber(loggedInUser.user.contactNumber);
    setEmailId(loggedInUser.user.email);
    setProfileData((pre) => {
      pre.contactNumber = loggedInUser.user.contactNumber;
      return { ...pre };
    });
    setPersonName(profileData.name);

    console.log();
    //Can't add any kind of condition
    setMessages();
    profileData.type === "CP"
      ? getKYCDocsCP(loggedInUser.user.cpId)
      : getKYCDocsFOS(loggedInUser.user.fosId);

    // loggedInUser.user is only ever populated at login (see LoginService's
    // CpContactPerson join) and never re-read from CP during an open session.
    // A CP already logged in when admin sets approvalStatus to "Profile
    // Update" wouldn't see the unlock until they log out and back in
    // without this -- so refresh just this one column on mount.
    if (profileData.type === "CP") {
      supabase
        .from("CP")
        .select("approvalStatus")
        .eq("cpId", loggedInUser.user.cpId)
        .maybeSingle()
        .then(({ data, error }) => {
          if (error) {
            console.error("approvalStatus refresh failed", error);
            return;
          }
          if (data && data.approvalStatus !== loggedInUser.user.approvalStatus) {
            setProfileData((pre) => ({ ...pre, approvalStatus: data.approvalStatus }));
            dispatch(action.authLogin({ ...loggedInUser.user, approvalStatus: data.approvalStatus }));
          }
        });
    }

    if (profileData.type === "FOS") {
      if (profileData.cpData) setCPEDetails(profileData.cpData.billingName);
    }
  }, [loggedInUser]);

  useEffect(() => {
    console.log(profileData.approvalStatus);
  }, [profileData]);

  function validatetTokenForm() {
    console.log(profileData.type);
    var form = true;
    if (profileData.type === "FOS") {
      if (generalDetail.panNumber === "") {
        form = false;
        setHelperText((preValue) => {
          preValue.panNumber = "Please Enter Pan Number";
          return { ...preValue };
        });
        console.log("HIi");
        setProfileData({ ...profileData, billingName: "" });
      }
      if (generalDetail.aadharNumber === "") {
        form = false;
        setHelperText((preValue) => {
          preValue.aadharNumber = "Please Enter Aadhar Number";
          return { ...preValue };
        });
      }
    } else {
      if (generalDetail.panNumber === "") {
        form = false;
        setHelperText((preValue) => {
          preValue.panNumber = "Please Enter Pan Number";
          return { ...preValue };
        });
        setProfileData({ ...profileData, billingName: "" });
        console.log("HIi");
      }
      if (generalDetail.reraNumber === "") {
        form = false;
        setHelperText((preValue) => {
          preValue.reraNumber = "Please Enter RERA Number";
          return { ...preValue };
        });
      }
      if (profileData.msmeType === "") {
        form = false;
        setHelperText((preValue) => {
          preValue.msmeType = "Please Enter MSME Type";
          return { ...preValue };
        });
      }
      if (
        profileData.msmeType !== "Not Applicable" &&
        profileData.msmeNumber === ""
      ) {
        form = false;
        setHelperText((preValue) => {
          preValue.msmeNumber = "Please Enter MSME Number";
          return { ...preValue };
        });
      }
      if (profileData.bankAccountNumber === "") {
        form = false;
        setHelperText((preValue) => {
          preValue.bankAccountNumber = "Please Enter Bank Account Number";
          return { ...preValue };
        });
      }
      if (profileData.bankIFSCCode === "") {
        form = false;
        setHelperText((preValue) => {
          preValue.bankIFSCCode = "Please Enter IFSC Code";
          return { ...preValue };
        });
      }
      if (profileData.bankAccountHolderName === "") {
        form = false;
        setHelperText((preValue) => {
          preValue.bankAccountHolderName =
            "Please Enter Bank Account Holder Name";
          return { ...preValue };
        });
      }
      if (profileData.bankBranchName === "") {
        form = false;
        setHelperText({
          ...helperText,
          bankBranchName: "Please Enter Branch Name",
        });
      }
      if (personName === "") {
        form = false;
        setHelperText({
          ...helperText,
          isPersonName: "Please Enter Person Name",
        });
      }
    }

    return {
      flag: form,
    };
  }





  

  /* Data Functions */
  // async function getKYCDocsCP(cpId) {
  //   const { data, error } = await supabase
  //     .from("KycDocuments")
  //     .select("*")
  //     .eq("cpId", cpId);
  //   if (data) {
  //     console.log("kyc docs", data);
  //     data.filter((each) => {
  //       if (each.docType === "PanCard") {
  //         generalDetail.panNumber = each.docNumber;
  //         setOldPan(each.docNumber);
  //       } else if (each.docType === "Rera") {
  //         generalDetail.reraNumber = each.docNumber;
  //         setOldRera(each.docNumber);
  //       }
  //       setGeneralDetail({ ...generalDetail });
  //     });
  //   } else throw error;
  // }

  async function getKYCDocsCP(cpId) {
  const { data, error } = await supabase
    .from("KycDocuments")
    .select("*")
    .eq("cpId", cpId);

  if (data) {
    console.log("kyc docs", data);
    data.forEach((each) => {
      if (each.docType === "PanCard") {
        generalDetail.panNumber = each.docNumber;
        setOldPan(each.docNumber);
        // PAN is frozen (never re-typed/re-verified in this session), but
        // every downstream Verify gate (RERA, GST, bank) checks
        // cpDetails.billingName / helperText.panVerified as a stand-in for
        // "PAN has been verified" -- those are otherwise only ever set by a
        // live PAN_CardCheck call. Hydrate them from the CP's own persisted
        // record here, since an on-file PAN was verified once already, at
        // registration.
        setCpDetails((prev) => ({
          ...prev,
          billingName: prev.billingName || profileData.billingName || "",
        }));
        setHelperText((prev) => ({
          ...prev,
          panVerified: true,
        }));
      } else if (each.docType === "Rera") {
        generalDetail.reraNumber = each.docNumber;
        setOldRera(each.docNumber);
      } else if (each.docType === "GST") {
        // ✅ Handle GST document
        setCpDetails((prev) => ({
          ...prev,
          gstNumber: each.docNumber,
        }));
        setOldGst(each.docNumber); // if you're tracking the old GST
      }
    });

    // Ensure all updates are reflected
    setGeneralDetail({ ...generalDetail });
  } else {
    throw error;
  }
}


  async function getKYCDocsFOS(fosId) {
    const { data, error } = await supabase
      .from("KycDocuments")
      .select("*")
      .eq("fosId", fosId);
    if (data) {
      console.log("kyc docs", data);
      data.filter((each) => {
        if (each.docType === "AadharCard") {
          generalDetail.aadharNumber = each.docNumber;
        } else if (each.docType === "PanCard") {
          generalDetail.panNumber = each.docNumber;
        }
        setGeneralDetail({ ...generalDetail });
      });
    } else throw error;
  }
  async function addPanCP(cpId, docDetails) {
    const { data, error } = await supabase
      .from("KycDocuments")
      .update({
        docNumber: docDetails.panNumber,
        docHolderName: docDetails.panName,
        otherDetails: docDetails.panObject,
      })
      // .eq("cpId", loggedInUser.user.cpId)
      .eq("cpId", cpId)

      .eq("docType", "PanCard");
    if (data) return data;
    else throw error;
  }

  // async function addRera(cpId, docDetails) {
  //   const { data, error } = await supabase.from("KycDocuments").insert({
  //     cpId: cpId,
  //     docType: "Rera",
  //     docNumber: docDetails.reraNumber,
  //     docHolderName: docDetails.reraName,
  //     otherDetails: docDetails.reraObject,
  //   });
  //   if (data) return data;
  //   else throw error;
  // }









  // async function addRera(cpId, docDetails) {
  //   console.log("🧹 Deleting existing RERA record for cpId:", cpId);

  //   // Step 1: Delete existing RERA record
  //   const { error: deleteError } = await supabase
  //     .from("KycDocuments")
  //     .delete()
  //     .eq("cpId", cpId)
  //     .eq("docType", "Rera");

  //   if (deleteError) {
  //     console.error("❌ Failed to delete existing RERA:", deleteError.message);
  //     throw deleteError;
  //   }

  //   // Step 2: Insert new RERA details
  //   console.log("📥 Inserting new RERA details for cpId:", cpId, docDetails);

  //   const { data, error: insertError } = await supabase
  //     .from("KycDocuments")
  //     .insert({
  //       cpId: cpId,
  //       docType: "Rera",
  //       docNumber: docDetails?.reraObject?.certificate_number,
  //       docHolderName: docDetails.reraName,
  //       otherDetails: docDetails.reraObject,
  //     });

  //   if (insertError) {
  //     console.error("❌ Failed to insert new RERA:", insertError.message);
  //     throw insertError;
  //   }

  //   return data;
  // }





  async function addRera(cpId, docDetails) {
  console.log("🔄 Upserting RERA record for cpId:", cpId);

  // Prepare the new data
  const updateData = {
    docNumber: docDetails?.reraObject?.certificate_number,
    docHolderName: docDetails.reraName,
    otherDetails: docDetails.reraObject,
  };

  // Step 1: Try to update existing RERA record
  const { data: updatedData, error: updateError } = await supabase
    .from("KycDocuments")
    .update(updateData)
    .eq("cpId", cpId)
    .eq("docType", "Rera");

  if (updateError) {
    console.error("❌ Failed to update existing RERA:", updateError.message);
    throw updateError;
  }

  // Step 2: If no rows were updated, insert new record
  if (!updatedData || updatedData.length === 0) {
    console.log("ℹ️ No existing RERA found, inserting new record.");
    const { data: insertData, error: insertError } = await supabase
      .from("KycDocuments")
      .insert({
        cpId: cpId,
        docType: "Rera",
        ...updateData,
      });

    if (insertError) {
      console.error("❌ Failed to insert new RERA:", insertError.message);
      throw insertError;
    }

    return insertData;
  }

  return updatedData;
}






  async function addAadhar(fosId, docDetails) {
    const { data, error } = await supabase
      .from("KycDocuments")
      .update({
        docNumber: docDetails.aadharNumber,
        docHolderName: profileData.name,
        otherDetails: docDetails.aadharObject,
      })
      .eq("fosId", loggedInUser.user.fosId)
      .eq("docType", "AadharCard");
    if (data) return data;
    else throw error;
  }
  async function addPanFOS(fosId, docDetails) {
    const { data, error } = await supabase
      .from("KycDocuments")
      .update({
        docNumber: docDetails.panNumber,
        docHolderName: docDetails.panName,
        otherDetails: docDetails.panObject,
      })
      .eq("fosId", loggedInUser.user.fosId)
      .eq("docType", "PanCard");
    if (data) return data;
    else throw error;
  }
  // Profile fields are editable when either: (a) admin explicitly unlocked
  // via the Partners-module "Profile Update" action, or (b) this is a
  // first-time registration rejection -- a CP that has never been approved
  // (approved_at not yet set) still gets the original reject-to-edit path,
  // unchanged. Once a CP has been approved at least once, only (a) applies;
  // rejecting/suspending them again no longer unlocks self-editing.
  function canEditProfile(u) {
    return Boolean(
      u?.approvalStatus === "Profile Update" ||
        (u?.approvalStatus === "rejected" && !u?.approved_at)
    );
  }
  function getUserStatusChip() {
    if (profileData.approvalStatus === "rejected") {
      return (
        <LeadStatusChip
          style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
          label={loggedInUser.user.approvalStatus}
          icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
        />
      );
    } else if (profileData.approvalStatus === "approved") {
      return (
        <LeadStatusChip
          style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
          label={loggedInUser.user.approvalStatus}
          icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
        />
      );
    } else {
      return (
        <LeadStatusChip
          style={{ color: "#F79009", backgroundColor: "#FFFAEB" }}
          label={profileData.approvalStatus}
          icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
        />
      );
    }
  }

  //   function isAllDataValid() {
  //   return (
  //     helperText.panNumber === "" &&
  //     helperText.reraNumber === "" &&
  //     helperText.msmeType === "" &&
  //     helperText.msmeNumber === "" &&
  //     helperText.bankAccountNumber === "" &&
  //     helperText.bankIFSCCode === "" &&
  //     helperText.bankAccountHolderName === "" &&
  //     helperText.bankBranchName === "" &&
  //     helperText.isPhoneNumber === "" &&
  //     helperText.isPersonName === "" &&
  //     helperText.isBillingName === "" &&
  //     helperText.isHolderName === "" &&
  //     helperText.isIfscCode === "" &&
  //     helperText.isAccountNumber === "" &&
  //     helperText.panVerified === true &&
  //     helperText.reraVerified === true &&
  //     helperText.bankDetailsIsVerified === true
  //   );
  // }

  //   async function updateProfileDataCP(id) {
  //     console.log(profileDataArr);
  //     console.log(oldPan);
  //     console.log(oldRera);
  //     if (
  //       !_.isEqual(profileData, profileDataArr) ||
  //       !_.isEqual(oldPan, generalDetail.panNumber) ||
  //       !_.isEqual(oldRera, generalDetail.reraNumber) ||
  //       !_.isEqual(personName, profileData.name)
  //     ) {
  //       console.log("general detail1", generalDetail);
  //       let flag = validatetTokenForm();
  //       if (
  //         flag.flag &&
  //         helperText.panNumber === "" &&
  //         helperText.reraNumber === "" &&
  //         helperText.msmeType === "" &&
  //         helperText.msmeNumber === "" &&
  //         helperText.bankAccountNumber === "" &&
  //         helperText.bankIFSCCode === "" &&
  //         helperText.bankAccountHolderName === "" &&
  //         helperText.bankBranchName === "" &&
  //         helperText.isPhoneNumber === "" &&
  //         helperText.isPersonName === ""
  //       ) {
  //         if (helperText.onChangePhoneNumber) {
  //           updatePhoneNumberOfCp();
  //         }
  //         profileData.approvalStatus = "resubmitted";
  //         profileData.isFlagged = true;
  //         // let obj = { ...profileData };

  //         let obj = {
  //   ...profileData,
  //   billingName: cpDetails.billingName,
  //   bankAccountHolderName: bankDetails.holderName,
  // };

  //         delete obj.profileImgUrl;
  //         delete obj.email;
  //         delete obj.name;
  //         delete obj.type;
  //         delete obj.cpContactPersonId;
  //         delete obj.cpData;
  //         delete obj.contactNumber;
  //         const { data, error } = await supabase
  //           .from("CP")
  //           .update(obj)
  //           .eq("cpId", id);
  //         if (data) {
  //           updateCpContactPerson();
  //           console.log(data);
  //           setOpenConfirmation(true);
  //           setMessage("Resubmitted successfully, Please wait for approval.");
  //           setMessageStatus("Resubmitted");
  //           setMessageIcon(<GreenChecked width={"4.8rem"} height={"4.8rem"} />);
  //           dispatch(action.authLogin(profileData));
  //         } else {
  //           errorTost(error.message);
  //           console.log(error);
  //         }
  //         if (generalDetail.panName !== "") {
  //           addPanCP(loggedInUser.user.cpId, generalDetail);
  //         }
  //         if (generalDetail.reraName !== "") {
  //           addRera(loggedInUser.user.cpId, generalDetail);
  //         }
  //       }
  //     } else {
  //       updatePhoneNumberOfCp();
  //     }
  //   }

  function isAllDataValid() {
    console.log("🔍 Validating All Data Fields:");

    console.log(
      "panNumber:",
      helperText.panNumber === "",
      helperText.panNumber
    );
    console.log(
      "reraNumber:",
      helperText.reraNumber === "",
      helperText.reraNumber
    );
    // console.log("msmeType:", helperText.msmeType === "", helperText.msmeType);
    console.log(
      "msmeNumber:",
      helperText.msmeNumber === "",
      helperText.msmeNumber
    );
    console.log(
      "bankAccountNumber:",
      helperText.bankAccountNumber === "",
      helperText.bankAccountNumber
    );
    console.log(
      "bankIFSCCode:",
      helperText.bankIFSCCode === "",
      helperText.bankIFSCCode
    );
    console.log(
      "bankAccountHolderName:",
      helperText.bankAccountHolderName === "",
      helperText.bankAccountHolderName
    );
    console.log(
      "bankBranchName:",
      helperText.bankBranchName === "",
      helperText.bankBranchName
    );
    console.log(
      "isPhoneNumber:",
      helperText.isPhoneNumber === "",
      helperText.isPhoneNumber
    );
    console.log(
      "isPersonName:",
      helperText.isPersonName === "",
      helperText.isPersonName
    );
    console.log(
      "isBillingName:",
      helperText.isBillingName === "",
      helperText.isBillingName
    );
    console.log(
      "isHolderName:",
      helperText.isHolderName === "",
      helperText.isHolderName
    );
    console.log(
      "isIfscCode:",
      helperText.isIfscCode === "",
      helperText.isIfscCode
    );
    console.log(
      "isAccountNumber:",
      helperText.isAccountNumber === "",
      helperText.isAccountNumber
    );

    console.log(
      "✅ panVerified:",
      helperText.panVerified === true,
      helperText.panVerified
    );
    console.log(
      "✅ reraVerified:",
      helperText.reraVerified === true,
      helperText.reraVerified
    );
    console.log(
      "✅ bankDetailsIsVerified:",
      helperText.bankDetailsIsVerified === true,
      helperText.bankDetailsIsVerified
    );

    const isValid =
      helperText.panNumber === "" &&
      helperText.reraNumber === "" &&
      // helperText.msmeType === "" &&
      helperText.msmeNumber === "" &&
      helperText.bankAccountNumber === "" &&
      helperText.bankIFSCCode === "" &&
      helperText.bankAccountHolderName === "" &&
      helperText.bankBranchName === "" &&
      helperText.isPhoneNumber === "" &&
      helperText.isPersonName === "" &&
      helperText.isBillingName === "" &&
      helperText.isHolderName === "" &&
      helperText.isIfscCode === "" &&
      helperText.isAccountNumber === "" &&
      helperText.panVerified === true &&
      helperText.reraVerified === true &&
      helperText.bankDetailsIsVerified === true;

    console.log("🔚 Final isAllDataValid:", isValid);
    return isValid;
  }
// async function replaceGSTDoc(cpId, gstNumber, gstObject) {
//   // Step 1: Delete existing GST record for this cpId
//   const { error: deleteError } = await supabase
//     .from("KycDocuments")
//     .delete()
//     .eq("cpId", cpId)
//     .eq("docType", "GST");

//   if (deleteError) {
//     console.error("❌ Failed to delete existing GST record:", deleteError.message);
//     throw deleteError;
//   }

//   // Step 2: Insert the new GST record
//   const { data, error: insertError } = await supabase
//     .from("KycDocuments")
//     .insert({
//       cpId,
//       docType: "GST",
//       docNumber: gstNumber?.toUpperCase(),
//       docHolderName: gstObject?.business_name
//         ?.toUpperCase()
//         ?.replace(/\s\s+/g, " "),
//       docUrl: "",
//       otherDetails: gstObject,
//     });

//   if (insertError) {
//     console.error("❌ Failed to insert new GST record:", insertError.message);
//     throw insertError;
//   }

//   return data;
// }








async function replaceGSTDoc(cpId, gstNumber, gstObject) {
  console.log("🔄 Upserting GST record for cpId:", cpId);

  // Prepare GST data
  const updateData = {
    docNumber: gstNumber?.toUpperCase(),
    docHolderName: gstObject?.business_name
      ?.toUpperCase()
      ?.replace(/\s\s+/g, " "),
    docUrl: "",
    otherDetails: gstObject,
  };

  // Step 1: Try to update existing GST record
  const { data: updatedData, error: updateError } = await supabase
    .from("KycDocuments")
    .update(updateData)
    .eq("cpId", cpId)
    .eq("docType", "GST");

  if (updateError) {
    console.error("❌ Failed to update existing GST record:", updateError.message);
    throw updateError;
  }

  // Step 2: If no rows updated, insert new record
  if (!updatedData || updatedData.length === 0) {
    console.log("ℹ️ No existing GST record found, inserting new record.");
    const { data: insertData, error: insertError } = await supabase
      .from("KycDocuments")
      .insert({
        cpId,
        docType: "GST",
        ...updateData,
      });

    if (insertError) {
      console.error("❌ Failed to insert new GST record:", insertError.message);
      throw insertError;
    }

    return insertData;
  }

  return updatedData;
}



  console.log("bank details=====", bankDetails);
  // console.log("general details",generalDetail);

//   async function updateProfileDataCP(id, oldPan, oldRera) {
//     if (
//       !_.isEqual(profileData, profileDataArr) ||
//       !_.isEqual(oldPan, generalDetail.panNumber) ||
//       !_.isEqual(oldRera, generalDetail.reraNumber) ||
//       !_.isEqual(personName, personName)
//     ) {
//       console.log("RERA NAME ", oldRera, generalDetail.reraNumber);
//       console.log("pan NAME ", oldPan, generalDetail.panNumber);
//       console.log("general details============>>>>>>>>>>>>>>. ", generalDetail);

//       // if (!isAllDataValid()) {
//       //   errorTost("Please fill vaild details.");
//       //   return;
//       // }

//       let flag = validatetTokenForm();
//       if (!flag.flag) {
//         errorTost("Token form validation failed.");
//         return;
//       }

//       if (helperText.onChangePhoneNumber) {
//         await updatePhoneNumberOfCp();
//       }

//       // Prepare object

//       console.log("bank details=====", bankDetails);
//       console.log("profile data=====", profileData);
//       let obj = {
//         ...profileData,
//         billingName: cpDetails.billingName,
//         bankAccountHolderName: bankDetails.holderName,
//         bankAccountNumber: bankDetails.accountNumber,
//         bankIFSCCode: bankDetails.ifscCode,
//       };

//       delete obj.profileImgUrl;
//       delete obj.email;
//       delete obj.name;
//       delete obj.type;
//       delete obj.cpContactPersonId;
//       delete obj.cpData;
//       delete obj.contactNumber;

//       obj.approvalStatus = "resubmitted";
//       obj.isFlagged = true;
//       console.log("Insert data");
//       // Update CP
//       const { data, error } = await supabase
//         .from("CP")
//         .update(obj)
//         .eq("cpId", id);

//       if (data) {
//         await updateCpContactPerson();

//         setOpenConfirmation(true);
//         setMessage("Resubmitted successfully, Please wait for approval.");
//         setMessageStatus("Resubmitted");
//         setMessageIcon(<GreenChecked width={"4.8rem"} height={"4.8rem"} />);
//         dispatch(action.authLogin(profileData));
//       } else {
//         errorTost(error.message);
//         return;
//       }

//       // Add PAN & RERA only if names exist
//       if (generalDetail.panName !== "") {
//         try {
//           await addPanCP(loggedInUser.user.cpId, generalDetail);
//         } catch (err) {
//           errorTost("PAN Update failed");
//         }
//       }

//       if (generalDetail.reraName !== "") {
//         try {
//           await addRera(loggedInUser.user.cpId, generalDetail);
//         } catch (err) {
//           errorTost("RERA Update failed");
//         }
//       }
//  if (
//   cpDetails.gstApplicable === true ||
//   cpDetails.gstApplicable === "true"
// ) {
//   try {
//     await replaceGSTDoc(
//       loggedInUser.user.cpId,
//       cpDetails.gstNumber,
//       cpDetails.gstObject
//     );
//   } catch (err) {
//     errorTost("GST Update failed");
//   }
// }


//     } else {
//       await updatePhoneNumberOfCp();
//     }
//   }















// async function updateProfileDataCP(id, oldPan, oldRera) {
//   const panChanged = !_.isEqual(oldPan, generalDetail.panNumber);
//   const reraChanged = !_.isEqual(oldRera, generalDetail.reraNumber);
//   const profileChanged = !_.isEqual(profileData, profileDataArr);

//   const isPanVerified = helperText.panVerified;
//   const isReraVerified = helperText.reraVerified;
//   const isGstVerified = helperText.gstNumberVerified;
//   const isBankVerified = helperText.bankDetailsIsVerified;

//   // Validation: prevent update if changed but not verified
//   if (panChanged && !isPanVerified) {
//     errorTost("Please verify PAN number before submitting.");
//     return;
//   }
//   if (reraChanged && !isReraVerified) {
//     errorTost("Please verify RERA number before submitting.");
//     return;
//   }
//   if ((cpDetails.gstNumber || cpDetails.gstApplicable) && !isGstVerified) {
//     errorTost("Please verify GST number before submitting.");
//     return;
//   }
//   if ((bankDetails.accountNumber || bankDetails.ifscCode) && !isBankVerified) {
//     errorTost("Please verify bank details before submitting.");
//     return;
//   }

//   // Allow update if any valid/verified change exists
//   if (
//     profileChanged ||
//     panChanged ||
//     reraChanged ||
//     isPanVerified ||
//     isReraVerified ||
//     isGstVerified ||
//     isBankVerified
//   ) {
//     const flag = validatetTokenForm();
//     if (!flag.flag) {
//       errorTost("Token form validation failed.");
//       return;
//     }

//     if (helperText.onChangePhoneNumber) {
//       await updatePhoneNumberOfCp();
//     }

//     let obj = {
//       ...profileData,
//       billingName: cpDetails.billingName,
//       bankAccountHolderName: bankDetails.holderName,
//       bankAccountNumber: bankDetails.accountNumber,
//       bankIFSCCode: bankDetails.ifscCode,
//        cpType: cpDetails.cpType || profileData.cpType,
//          proprietorship_name: cpDetails.proprietorshipName,
//            gstBusinessName: cpDetails?.gstObject?.business_name || null,
//   gstLegalName: cpDetails?.gstObject?.legal_name || null,
//       isGSTApplicable: cpDetails.gstApplicable,
//     };

//     delete obj.profileImgUrl;
//     delete obj.email;
//     delete obj.name;
//     delete obj.type;
//     delete obj.cpContactPersonId;
//     delete obj.cpData;
//     delete obj.contactNumber;

//     obj.approvalStatus = "resubmitted";
//     obj.isFlagged = true;

//     const { data, error } = await supabase
//       .from("CP")
//       .update(obj)
//       .eq("cpId", id);

//     if (data) {
//       await updateCpContactPerson();
//       setOpenConfirmation(true);
//       setMessage("Resubmitted successfully, Please wait for approval.");
//       setMessageStatus("Resubmitted");
//       setMessageIcon(<GreenChecked width={"4.8rem"} height={"4.8rem"} />);
//       dispatch(action.authLogin(profileData));
//     } else {
//       errorTost(error.message);
//       return;
//     }

//     // Add PAN if verified
//     if (isPanVerified && generalDetail.panName !== "") {
//       try {
//         await addPanCP(loggedInUser.user.cpId, generalDetail);
//       } catch (err) {
//         errorTost("PAN Update failed");
//       }
//     }

//     // Add RERA if verified
//     if (isReraVerified && generalDetail.reraName !== "") {
//       try {
//         await addRera(loggedInUser.user.cpId, generalDetail);
//       } catch (err) {
//         errorTost("RERA Update failed");
//       }
//     }

//     // Replace GST if verified
//     if (
//       (cpDetails.gstApplicable === true || cpDetails.gstApplicable === "true") &&
//       isGstVerified
//     ) {
//       try {
//         await replaceGSTDoc(
//           loggedInUser.user.cpId,
//           cpDetails.gstNumber,
//           cpDetails.gstObject
//         );
//       } catch (err) {
//         errorTost("GST Update failed");
//       }
//     }
//   } else {
//     infoTost("No changes detected.");
//   }
  
// }


async function updateProfileDataCP(id, oldPan, oldRera) {
  console.log("updateProfileDataCP called, profileData:", profileData);
  const panChanged = !_.isEqual(oldPan, generalDetail.panNumber);
  const reraChanged = !_.isEqual(oldRera, generalDetail.reraNumber);
  const profileChanged = !_.isEqual(profileData, profileDataArr);

  const isPanVerified = helperText.panVerified;
  const isReraVerified = helperText.reraVerified;
  const isGstVerified = helperText.gstNumberVerified;
  const isBankVerified = helperText.bankDetailsIsVerified;

  // ================= GLOBAL HELPER ERROR BLOCK =================


  // ================= STRICT VALIDATION =================
  if (isPanVerified !== true) {
    errorTost("Please verify PAN number before submitting.");
    return;
  }

  if (
    reraChanged &&
    (isReraVerified !== true || helperText?.isBillingName)
  ) {
    errorTost("Please fix RERA validation errors before submitting.");
    return;
  }

  if (
    (cpDetails.gstNumber || cpDetails.gstApplicable) &&
    isGstVerified !== true
  ) {
    errorTost("Please verify GST number before submitting.");
    return;
  }

  if (
    (bankDetails.accountNumber || bankDetails.ifscCode) &&
    isBankVerified !== true
  ) {
    errorTost("Please verify bank details before submitting.");
    return;
  }

  // ================= FINAL FORM VALIDATION =================
  const isFormValid =
    isPanVerified === true &&
    isReraVerified === true &&
    (cpDetails.gstApplicable ? isGstVerified === true : true) &&
    isBankVerified === true &&
    !helperText?.isBillingName;

  if (!isFormValid) {
    errorTost("Please complete all verifications correctly.");
    return;
  }

  // ================= SHOP ACT UPLOAD =================
  let shopActUrl = cpDetails.shopActUrl || null;

  if (!cpDetails.gstApplicable && shopActFile) {
    try {
      const fileExt = shopActFile.name.split(".").pop();
      const fileName = `cpshopact/${id}_shopact.${fileExt}`;

      const { error: uploadError } = await supabase.storage
        .from("kycdocuments")
        .upload(fileName, shopActFile, { upsert: true });

      if (uploadError) throw uploadError;

      const { data: publicUrlData } = supabase.storage
        .from("kycdocuments")
        .getPublicUrl(fileName);

      shopActUrl = publicUrlData.publicUrl;
    } catch (err) {
      errorTost("ShopAct upload failed: " + err.message);
      return;
    }
  }

  // ================= CHANGE CHECK =================
  if (
    profileChanged ||
    panChanged ||
    reraChanged ||
    isPanVerified ||
    isReraVerified ||
    isGstVerified ||
    isBankVerified ||
    (!cpDetails.gstApplicable && shopActFile)
  ) {
    const flag = validatetTokenForm();
    if (!flag.flag) {
      errorTost("Token form validation failed.");
      return;
    }

    // Commits any already-OTP-verified phone/email change as part of this
    // same resubmit (silent -- "nothing changed" would be wrong noise when
    // neither was touched), so it folds into the same Profile Update log
    // this resubmit closes out. A pending, unverified phone/email edit
    // blocks the whole save -- same as it did back when this was its own
    // separate "Save Changes" button.
    if (helperText.onChangePhoneNumber || profileData.email !== newEmailId) {
      const canProceed = await updatePhoneNumberOfCp({ silent: true });
      if (!canProceed) return;
    }

    let obj = {
      ...profileData,
      billingName: cpDetails.billingName,
      bankAccountHolderName: bankDetails.holderName,
      bankAccountNumber: bankDetails.accountNumber,
      bankIFSCCode: bankDetails.ifscCode,
      BankAccountNumberText: bankDetails.accountNumber != null ? String(bankDetails.accountNumber) : null,
      // Only overwrite bankName when this session actually re-verified the IFSC;
      // otherwise leave the stored value alone rather than blanking it.
      ...(bankDetails.bankName ? { bankName: bankDetails.bankName } : {}),
      cpType: cpDetails.cpType || profileData.cpType,
      proprietorship_name: cpDetails.proprietorshipName,
      gstBusinessName: cpDetails?.gstObject?.business_name || null,
      gstLegalName: cpDetails?.gstObject?.legal_name || null,
      isGSTApplicable: cpDetails.gstApplicable,
      reraStartDate: cpDetails.reraExtracted?.startDate,
      reraEndDate: cpDetails.reraExtracted?.endDate,
    };
    
if (!cpDetails.gstApplicable) {
  try {
    await supabase
      .from("KycDocuments")
      .delete()
      .eq("cpId", id)
      .eq("docType", "GST");
  } catch (err) {
    errorTost("Failed to remove GST document");
  }
}

    delete obj.profileImgUrl;
    delete obj.email;
    delete obj.name;
    delete obj.type;
    delete obj.cpContactPersonId;
    delete obj.cpData;
    delete obj.contactNumber;
    delete obj.gstNumber;

    obj.approvalStatus = "resubmitted";
    obj.isFlagged = true;

    const { data, error } = await supabase
      .from("CP")
      .update(obj)
      .eq("cpId", id);

    if (error) {
      errorTost(error.message);
      return;
    }

    // Close out the open Profile Update cycle (if any) with a changes-only
    // diff. The admin-unlock write (ChannelPartner.js's unlockCpProfileForEdit)
    // stashes the pre-edit CP row as JSON in CpLogs.note as scratch space --
    // no separate snapshot column needed. note (not message) is the "still
    // open" signal: message alone can't be, since a cycle that closes with
    // no actual changes also ends with message null, same as a still-open
    // one would. Phone/email changes made mid-cycle via the OTP flows
    // (logProfileUpdateFieldChange, below) accumulate into that same
    // note.applied list instead of their own log rows -- both are one and
    // the same Profile Update flow, so they close out into one and the same
    // message. Once closed below, note is always cleared; message holds the
    // final plain readable sentence (same convention as LeadLogs.message)
    // when something changed, or stays null when nothing did -- both null
    // together means "closed, no changes," never "still open." Fire-and-
    // forget: this is an audit record, not something that should block the
    // resubmit itself. approvalStatus is excluded from the diff -- it's the
    // mechanical status flip (Profile Update -> resubmitted), not something
    // the CP typed in.
    supabase
      .from("CpLogs")
      .select("cpLogId, note")
      .eq("cpId", id)
      .eq("cpStatus", "Profile Update")
      .not("note", "is", null)
      .order("created_at", { ascending: false })
      .limit(1)
      .then(({ data: openRows, error: openRowsError }) => {
        if (openRowsError) {
          console.error("Profile Update log lookup failed", openRowsError);
          return;
        }
        const openRow = openRows?.[0];
        if (!openRow) return;

        let oldSnapshot;
        let applied = [];
        try {
          const parsed = JSON.parse(openRow.note);
          if (!parsed?.old) return;
          oldSnapshot = parsed.old;
          applied = Array.isArray(parsed.applied) ? parsed.applied : [];
        } catch {
          return;
        }

        const changedParts = applied.map(
          (c) => `${c.field}: ${c.old ?? "—"} → ${c.new ?? "—"}`
        );
        // Only the fields this form actually lets the CP edit -- obj is a
        // full spread of the entire CP row (...profileData), so diffing
        // every one of its keys picked up incidental noise (last_updated_at,
        // created_at, cpSourceId, benefitPlanId, etc.) that the CP never
        // touched, making the log unreadable. BankAccountNumberText is
        // skipped on purpose -- it's a stringified duplicate of
        // bankAccountNumber, not a separate real change.
        const EDITABLE_FIELDS = [
          "billingName",
          "bankAccountHolderName",
          "bankAccountNumber",
          "bankIFSCCode",
          "bankName",
          "bankBranchName",
          "cpType",
          "proprietorship_name",
          "gstBusinessName",
          "gstLegalName",
          "isGSTApplicable",
          "reraStartDate",
          "reraEndDate",
          "msmeType",
          "msmeNumber",
        ];
        EDITABLE_FIELDS.forEach((key) => {
          if (!_.isEqual(oldSnapshot[key], obj[key])) {
            changedParts.push(`${key}: ${oldSnapshot[key] ?? "—"} → ${obj[key] ?? "—"}`);
          }
        });
        // RERA (like PAN before it was frozen) persists to KycDocuments, not
        // the CP row this diff otherwise compares -- obj never carries it, so
        // it's checked separately here against the oldRera snapshot taken on
        // mount. Only counted once the CP has actually re-verified a new one.
        if (isReraVerified && oldRera !== generalDetail.reraNumber) {
          changedParts.push(`reraNumber: ${oldRera ?? "—"} → ${generalDetail.reraNumber ?? "—"}`);
        }
        // GST has the same gap as RERA -- persists to KycDocuments via
        // replaceGSTDoc(), never through obj -- checked here against the
        // oldGst snapshot from mount. Covers exactly the "registered without
        // GST, later got one, re-verified PAN" case: oldGst is "" (no GST
        // document existed yet), cpDetails.gstNumber is the newly-found one.
        if (isGstVerified && oldGst !== cpDetails.gstNumber) {
          changedParts.push(`gstNumber: ${oldGst || "—"} → ${cpDetails.gstNumber ?? "—"}`);
        }
        // Nothing changed -- both columns go null (note's scratch JSON is no
        // longer needed either way; message stays null since there's nothing
        // to report), instead of leaving note stuck with stale JSON forever.
        const finalMessage = changedParts.length
          ? `Profile updated by CP — ${changedParts.join(", ")}`
          : null;

        supabase
          .from("CpLogs")
          .update({ message: finalMessage, note: null })
          .eq("cpLogId", openRow.cpLogId)
          .then(({ error: closeError }) => {
            if (closeError) console.error("Profile Update log close failed", closeError);
          });
      });

    await updateCpContactPerson();

    setOpenConfirmation(true);
    setMessage("Resubmitted successfully, Please wait for approval.");
    setMessageStatus("Resubmitted");
    setMessageIcon(<GreenChecked width={"4.8rem"} height={"4.8rem"} />);
    dispatch(action.authLogin(profileData));

    // ================= POST UPDATES =================

    if (isPanVerified && generalDetail.panName !== "") {
      try {
        await addPanCP(loggedInUser.user.cpId, generalDetail);
      } catch {
        errorTost("PAN Update failed");
      }
    }

    if (isReraVerified && generalDetail.reraName !== "") {
      try {
        await addRera(loggedInUser.user.cpId, generalDetail);
      } catch {
        errorTost("RERA Update failed");
      }
    }

    if (
      (cpDetails.gstApplicable === true ||
        cpDetails.gstApplicable === "true") &&
      isGstVerified
    ) {
      try {
        await replaceGSTDoc(
          loggedInUser.user.cpId,
          cpDetails.gstNumber,
          cpDetails.gstObject
        );
      } catch {
        errorTost("GST Update failed");
      }
    }

    // Update FV ledger bank & GST details
    console.log("Calling updateFVLedger...");
    await updateFVLedger();
  } else {
    infoTost("No changes detected.");
  }
}

async function updateFVLedger() {
  const ledgerId = profileData?.ledgerId;
  if (!ledgerId) return;

  const FV_HEADERS = {
    Authorization: `apikey ${process.env.REACT_APP_FARVISIONCLOUD_API_KEY}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  try {
    const getRes = await axios.get(
      `${process.env.REACT_APP_FARVISIONCLOUD_BASE_URL}/Finance/odata/Ledgers(${ledgerId})`,
      { headers: FV_HEADERS }
    );
    const ledgerData = getRes.data;
    console.log("FV Ledger GET response:", JSON.stringify(ledgerData, null, 2));

    const existingGST = ledgerData.ledgerGSTINs?.[0] || {};
    const existingAddress = ledgerData.addresses?.[0] || {};
    const newGstin = cpDetails.gstNumber || existingGST.gstin || "";
    const gstObj = cpDetails.gstObject || {};
    console.log("cpDetails.gstObject:", JSON.stringify(cpDetails.gstObject, null, 2));
    // address format: "Line1, Area, City, State, Pincode"
    const addressStr = gstObj.address || "";
    const addressParts = addressStr.split(",").map((s) => s.trim()).filter(Boolean);
    const gstZipFromAddr = addressParts.length >= 1 ? addressParts[addressParts.length - 1] : "";
    const gstCityFromAddr = addressParts.length >= 3 ? addressParts[addressParts.length - 3] : "";
    const gstStateCode = newGstin.substring(0, 2) || existingGST.gstStateCode || "";
    const gstStateName = gstObj.state_jurisdiction || existingGST.state || "";
    const gstCity = gstCityFromAddr || existingGST.city || "";
    const gstZip = gstZipFromAddr || existingGST.zipCode || "";
    const gstAddress = addressStr || existingGST.address || "";
    const dateOfRegistration = gstObj.date_of_registration || null;

    // extract clean state name from Surepass jurisdiction string e.g. "State - Haryana,Range - Gurgaon,..."
    const cleanStateName = gstStateName
      ? (gstStateName.match(/State\s*-\s*([^,]+)/i)?.[1]?.trim() || gstStateName.split(",")?.[0]?.trim() || gstStateName)
      : "";

    // fetch FV internal stateCode by searching state name from Surepass
    let fvStateCode = existingGST.stateCode || existingAddress.stateCode || "";
    let fvStateName = cleanStateName || gstStateName;
    let fvGstStateId = gstStateCode;
    let fvStateId = existingGST.stateId;
    if (cleanStateName) {
      console.log("Looking up FV stateCode for state name:", cleanStateName);
      try {
        const stateRes = await axios.post(
          `${process.env.REACT_APP_FARVISIONCLOUD_BASE_URL}/Framework/odata/States/findState`,
          {
            searchField: "description",
            searchText: cleanStateName.substring(0, 6),
            startNo: 0,
            endNo: 50,
            extraCondition: 264,
          },
          { headers: FV_HEADERS }
        );
        const stateList = stateRes.data?.findData || [];
        console.log("FV States API response:", JSON.stringify(stateRes.data, null, 2));
        const matchedState = stateList.find(
          (s) => s.description?.toUpperCase() === cleanStateName.toUpperCase()
        ) || stateList?.[0];
        if (matchedState) {
          fvStateCode = matchedState.code || "";
          fvStateName = matchedState.description || cleanStateName;
          fvGstStateId = matchedState.gststateid || gstStateCode;
          fvStateId = matchedState.id || existingGST.stateId;
          console.log("FV state resolved:", { fvStateId, fvStateCode, fvStateName, fvGstStateId });
        }
      } catch (stateErr) {
        console.warn("FV States lookup failed, keeping existing stateCode:", stateErr.message);
      }
    }

    const putPayload = {
      // ── root ledger fields ──
      id: ledgerData.id,
      objectId: ledgerData.objectId,
      description: ledgerData.description,
      code: ledgerData.code,
      parentId: ledgerData.parentId,
      parentDesc: ledgerData.parentDesc,
      sameAsId: ledgerData.sameAsId || 0,
      typeDescription: ledgerData.typeDescription,
      isDayBook: ledgerData.isDayBook,
      isCash: ledgerData.isCash,
      isControlAc: ledgerData.isControlAc,
      subLedgerType: ledgerData.subLedgerType,
      ledgerGroupId: ledgerData.ledgerGroupId,
      ledgerGroupDescr: ledgerData.ledgerGroupDescr,
      statusId: ledgerData.statusId,
      profitLossYearId: ledgerData.profitLossYearId,
      creditLimit: ledgerData.creditLimit,
      creditDays: ledgerData.creditDays,
      agentId: ledgerData.agentId,
      agentDestinationId: ledgerData.agentDestinationId,
      fundType: ledgerData.fundType,
      splStatusId: ledgerData.splStatusId,
      isSubContractor: ledgerData.isSubContractor,
      coaId: ledgerData.coaId,
      ledgerTypeId: ledgerData.ledgerTypeId,
      isIgst: ledgerData.isIgst,
      isCgst: ledgerData.isCgst,
      isSgst: ledgerData.isSgst,
      isCess: ledgerData.isCess,
      parentSplStatusId: ledgerData.parentSplStatusId,
      isUpdatable: ledgerData.isUpdatable,
      targetParentId: ledgerData.targetParentId,
      oldDesc: ledgerData.oldDesc,
      interco_Br_Descr: ledgerData.interco_Br_Descr,
      isSysGenLedgerEdit: ledgerData.isSysGenLedgerEdit,
      groupTypeId: ledgerData.groupTypeId,
      parentCompanyId: ledgerData.parentCompanyId,
      allowChangeForSystemGenerated: ledgerData.allowChangeForSystemGenerated,
      reasonId: ledgerData.reasonId,
      oldParentGroupId: ledgerData.oldParentGroupId,
      isEntryFromVendorSelfOnboarding: ledgerData.isEntryFromVendorSelfOnboarding,
      provisionalDocType: ledgerData.provisionalDocType,
      approverId: ledgerData.approverId,
      workflowId: ledgerData.workflowId,
      isFinalApproval: ledgerData.isFinalApproval,
      tenantId: ledgerData.tenantId,
      dbId: ledgerData.dbId,
      createdBy: ledgerData.createdBy,
      lastModifiedBy: ledgerData.lastModifiedBy,
      entityName: ledgerData.entityName,
      isDraft: ledgerData.isDraft,
      isChildEntity: ledgerData.isChildEntity,
      importSrlNo: ledgerData.importSrlNo,
      isUserAdmin: ledgerData.isUserAdmin,
      isDataBeingImportFromExcel: ledgerData.isDataBeingImportFromExcel,
      isDataBeingValidateOnly: ledgerData.isDataBeingValidateOnly,
      attachmentId: ledgerData.attachmentId,
      isInApproval: ledgerData.isInApproval,
      // ── required PUT-only fields — not returned in GET, must be hardcoded ──
      tempId: 2,
      appId: 4,
      masterEntryTypeId: 114,
      masterDocumentTypeId: 524,
      prefixType: 524,
      checkAllTemp: true,
      accountHeadType: "SL",
      countryId: 264,
      ledgerGroupType: ledgerData.groupTypeId,
      documentDate: null,
      bankDetail: null,
      bankAccountDeletedRows: [],
      ledgerGSTINDeletedRows: [],
      tradeLicenseDetails: ledgerData.tradeLicenseDetails || [],
      interCompanyBranchList: ledgerData.interCompanyBranchList || [],
      extraInfos: ledgerData.extraInfos || [],
      communications: ledgerData.communications || [],
      buWiseLedgerTag: ledgerData.buWiseLedgerTag || [],
      ledgerTaggingWithTaxNatures: ledgerData.ledgerTaggingWithTaxNatures || [],
      createdOn: ledgerData.createdOn
        ? new Date(ledgerData.createdOn).toISOString().replace(/\.\d+Z$/, ".000Z")
        : null,
      lastModifiedOn: ledgerData.lastModifiedOn
        ? new Date(ledgerData.lastModifiedOn).toISOString().replace(/\.\d+Z$/, ".000Z")
        : null,
      // ── controlAccountInfo ──
      controlAccountInfo: {
        sameAsId: ledgerData.sameAsId || 0,
        subLedgerType: ledgerData.subLedgerType,
      },
      // ── subLedgerInfo ──
      subLedgerInfo: {
        parentId: ledgerData.parentId,
        parentDesc: ledgerData.parentDesc,
        subLedgerType: ledgerData.subLedgerType,
        isSubContractor: ledgerData.isSubContractor,
      },
      // ── subledgerClass ──
      subledgerClass: ledgerData.subledgerClass
        ? {
            ...ledgerData.subledgerClass,
            createdOn: null,
            lastModifiedOn: null,
          }
        : ledgerData.subledgerClass,
      // ── localization ──
      localization: ledgerData.localization
        ? {
            ...ledgerData.localization,
            createdOn: null,
            lastModifiedOn: null,
            tds: ledgerData.localization.tds
              ? { ...ledgerData.localization.tds, createdOn: null, lastModifiedOn: null }
              : ledgerData.localization.tds,
            vat: ledgerData.localization.vat
              ? { ...ledgerData.localization.vat, createdOn: null, lastModifiedOn: null }
              : {},
          }
        : ledgerData.localization,
      // ── beneficiaryBankAccounts ──
      beneficiaryBankAccounts: (() => {
        const existing = (ledgerData.beneficiaryBankAccounts || []).map((b) => ({
          ...b,
          mode: "U",
          createdOn: b.createdOn
            ? new Date(b.createdOn).toISOString().replace(/\.\d+Z$/, ".000Z")
            : null,
          lastModifiedOn: b.lastModifiedOn
            ? new Date(b.lastModifiedOn).toISOString().replace(/\.\d+Z$/, ".000Z")
            : null,
        }));

        const newAccNo = String(bankDetails.accountNumber || "").trim();
        const newIfsc = String(bankDetails.ifscCode || "").trim().toUpperCase();

        const alreadyExists = newAccNo &&
          existing.some(
            (b) =>
              b.bankAccountNo?.trim() === newAccNo &&
              b.ifscCode?.trim().toUpperCase() === newIfsc
          );

        if (newAccNo && !alreadyExists) {
          existing.forEach((b) => { b.isDefault = false; });
          console.log("bankdetails", bankDetails);
          existing.push({
            bankAccountNo: newAccNo,
            beneficiaryName: bankDetails.holderName || "",
            accountName: bankDetails.bankName || "",
            ifscCode: newIfsc,
            ledgerId: ledgerData.id,
            isDefault: true,
            foreignCurrencyId: 0,
            entityName: "BeneficiaryBank",
            parentSplStatusId: 0,
            gatewayTypeId: 0,
            onlyBeneficiary: false,
            allowBeneficiary: false,
            isEditedRow: true,
            entryTypeId: 0,
            id: 0,
            objectId: "000000000000000000000000",
            isFinalApproval: false,
            tenantId: 1,
            dbId: 0,
            createdBy: 0,
            createdOn: null,
            lastModifiedBy: 0,
            lastModifiedOn: null,
            mode: "I",
            isDraft: false,
            isChildEntity: false,
            appId: 0,
            masterEntryTypeId: 0,
            masterDocumentTypeId: 0,
            importSrlNo: 0,
            isUserAdmin: false,
            isDataBeingImportFromExcel: false,
            isDataBeingValidateOnly: false,
            attachmentId: "00000000-0000-0000-0000-000000000000",
            isInApproval: false,
            index: existing.length,
          });
        }

        // ensure only one account has isDefault=true (keep the last one marked true)
        const lastDefaultIdx = existing.map((b) => b.isDefault).lastIndexOf(true);
        if (lastDefaultIdx !== -1) {
          existing.forEach((b, i) => { b.isDefault = i === lastDefaultIdx; });
        }

        return existing;
      })(),
      // ── addresses — update state/city/zip/line1 from GST ──
      addresses: (ledgerData.addresses || []).map((a, idx) => ({
        id: a.id,
        objectId: a.objectId,
        type: a.type,
        isPrimary: a.isPrimary,
        referenceId: a.referenceId,
        serialNo: a.serialNo,
        addressTypeDesc: a.addressTypeDesc,
        countryCode: a.countryCode,
        countryDesc: a.countryDesc,
        code: a.code,
        tenantId: a.tenantId,
        dbId: a.dbId,
        createdBy: a.createdBy,
        lastModifiedBy: a.lastModifiedBy,
        isFinalApproval: a.isFinalApproval,
        isDraft: a.isDraft,
        isChildEntity: a.isChildEntity,
        entityName: a.entityName,
        appId: a.appId,
        masterEntryTypeId: a.masterEntryTypeId,
        masterDocumentTypeId: a.masterDocumentTypeId,
        importSrlNo: a.importSrlNo,
        isUserAdmin: a.isUserAdmin,
        isDataBeingImportFromExcel: a.isDataBeingImportFromExcel,
        isDataBeingValidateOnly: a.isDataBeingValidateOnly,
        attachmentId: a.attachmentId,
        isInApproval: a.isInApproval,
        mode: a.mode,
        stateCode: idx === 0 ? fvStateCode || a.stateCode : a.stateCode,
        cityCode: a.cityCode,
        // fields updated from new GST on primary address
        line1: idx === 0 ? gstAddress || a.line1 : a.line1,
        stateDesc: idx === 0 ? fvStateName || a.stateDesc : a.stateDesc,
        cityDesc: idx === 0 ? gstCity || a.cityDesc : a.cityDesc,
        zipCode: idx === 0 ? gstZip || a.zipCode : a.zipCode,
        createdOn: a.createdOn
          ? new Date(a.createdOn).toISOString().replace(/\.\d+Z$/, ".000Z")
          : null,
        lastModifiedOn: a.lastModifiedOn
          ? new Date(a.lastModifiedOn).toISOString().replace(/\.\d+Z$/, ".000Z")
          : null,
        activeFromLocal: a.activeFromLocal
          ? new Date(a.activeFromLocal).toISOString().replace(/\.\d+Z$/, ".000Z")
          : null,
      })),
      // ── ledgerContacts ──
      ledgerContacts: (ledgerData.ledgerContacts || []).map((c) => ({
        ...c,
        createdOn: c.createdOn
          ? new Date(c.createdOn).toISOString().replace(/\.\d+Z$/, ".000Z")
          : null,
        lastModifiedOn: c.lastModifiedOn
          ? new Date(c.lastModifiedOn).toISOString().replace(/\.\d+Z$/, ".000Z")
          : null,
        activeFrom: c.activeFrom
          ? new Date(c.activeFrom).toISOString().replace(/\.\d+Z$/, ".000Z")
          : null,
      })),
      // ── templateWiseLedgerTag ──
      templateWiseLedgerTag: (ledgerData.templateWiseLedgerTag || []).map((t) => ({
        ...t,
        documentDate: null,
        createdOn: null,
        lastModifiedOn: null,
        ledgerGroup: t.ledgerGroup
          ? { ...t.ledgerGroup, createdOn: null, lastModifiedOn: null }
          : t.ledgerGroup,
      })),
      // ── ledgerGSTINs — keep existing, insert new if not duplicate ──
      ledgerGSTINs: (() => {
        const existingGSTList = (ledgerData.ledgerGSTINs || []).map((g, idx) => ({
          ...g,
          mode: "U",
          isRegistered: false,
          index: g.index !== undefined ? g.index : idx,
          createdOn: g.createdOn
            ? new Date(g.createdOn).toISOString().replace(/\.\d+Z$/, ".000Z")
            : null,
          lastModifiedOn: g.lastModifiedOn
            ? new Date(g.lastModifiedOn).toISOString().replace(/\.\d+Z$/, ".000Z")
            : null,
        }));

        const newGstinTrimmed = String(newGstin || "").trim().toUpperCase();

        const alreadyExists = newGstinTrimmed &&
          existingGSTList.some(
            (g) => g.gstin?.trim().toUpperCase() === newGstinTrimmed
          );

        if (newGstinTrimmed && !alreadyExists) {
          existingGSTList.push({
            id: 0,
            objectId: "000000000000000000000000",
            ledgerId: ledgerData.id,
            stateId: fvStateId || existingGST.stateId || 0,
            stateCode: fvStateCode || existingGST.stateCode || "",
            cityCode: existingGST.cityCode || "",
            countryId: existingGST.countryId || 0,
            countryCode: existingGST.countryCode || "",
            country: existingGST.country || "",
            isRegistered: true,
            isSez: existingGST.isSez ?? false,
            eligibility: existingGST.eligibility ?? false,
            isCompound: existingGST.isCompound ?? false,
            partyType: "Registered",
            // Farvision models partyTypeTaxPurpose as a reference to its PartyTypeTaxPurpose
            // master record (id 6 = "Registered"), not a plain string — sending a string here
            // causes a server-side NullReferenceException on PUT.
            partyTypeTaxPurpose: {
              taxTypeId: 0,
              partyType: "Registered",
              countryId: 264,
              id: 6,
              objectId: "000000000000000000000000",
              code: "Reg",
              isFinalApproval: false,
              tenantId: 1,
              dbId: 0,
              createdBy: 0,
              createdOn: "0001-01-01T00:00:00Z",
              lastModifiedBy: 0,
              lastModifiedOn: "0001-01-01T00:00:00Z",
              mode: "",
              entityName: "PartyTypeTaxPurpose",
              isDraft: false,
              isChildEntity: false,
              appId: 0,
              masterEntryTypeId: 0,
              masterDocumentTypeId: 0,
              importSrlNo: 0,
              isUserAdmin: false,
              isDataBeingImportFromExcel: false,
              isDataBeingValidateOnly: false,
              attachmentId: "00000000-0000-0000-0000-000000000000",
              isInApproval: false,
            },
            parentSplStatusId: existingGST.parentSplStatusId || 0,
            isIntaxApplicable: existingGST.isIntaxApplicable ?? 0,
            isActiveTillUpdateNotRequired: existingGST.isActiveTillUpdateNotRequired ?? false,
            activeFrom: dateOfRegistration || "0001-01-01T00:00:00Z",
            tenantId: existingGST.tenantId || 1,
            dbId: existingGST.dbId || 0,
            createdBy: 0,
            lastModifiedBy: 0,
            isFinalApproval: false,
            isDraft: false,
            isChildEntity: false,
            entityName: "LedgerGSTIN",
            appId: 0,
            masterEntryTypeId: 0,
            masterDocumentTypeId: 0,
            importSrlNo: 0,
            isUserAdmin: false,
            isDataBeingImportFromExcel: false,
            isDataBeingValidateOnly: false,
            attachmentId: "00000000-0000-0000-0000-000000000000",
            isInApproval: false,
            gstin: newGstinTrimmed,
            gstStateCode: fvGstStateId,
            state: fvStateName,
            code: fvStateName,
            city: gstCityFromAddr || "",
            zipCode: gstZipFromAddr || "",
            address: addressStr || "",
            address2: "",
            address3: "",
            mode: "I",
            isEditedRow: true,
            index: existingGSTList.length,
            documentDate: "0001-01-01T00:00:00Z",
            createdOn: null,
            lastModifiedOn: null,
          });
        }

        return existingGSTList;
      })(),
    };

    console.log("FV Ledger PUT payload:", JSON.stringify(putPayload, null, 2));
    await axios.put(
      `${process.env.REACT_APP_FARVISIONCLOUD_BASE_URL}/Finance/odata/Ledgers`,
      putPayload,
      { headers: FV_HEADERS }
    );
  } catch (err) {
    console.error("FV Ledger update failed:", err);
  }
}


  async function updateProfileDataFOS(id) {
    if (
      CPEDetails.value !== profileData.cpId &&
      CPEDetails.value !== undefined
    ) {
      changeCPE(CPEDetails);
    } else {
      console.log("no data cpe has been changed");
      let flag = validatetTokenForm();
      if (
        flag.flag &&
        helperText.aadharNumber === "" &&
        helperText.panNumber === "" &&
        helperText.isPhoneNumber === "" &&
        helperText.bankAccountNumber === "" &&
        helperText.bankIFSCCode === "" &&
        helperText.bankAccountHolderName === "" &&
        helperText.bankBranchName === "" &&
        helperText.bankDetailsIsVerified === true
      ) {
        console.log(oldPhoneNumber, newPhoneNumber);
        const newPhoneNumber2 = parseInt(newPhoneNumber.substring(1));
        if (
          oldPhoneNumber !== newPhoneNumber2 &&
          newPhoneNumber !== undefined &&
          newPhoneNumber !== ""
        ) {
          profileData.approvalStatus = "resubmitted";

          console.log({ profileData });
          let obj = { ...profileData };
          delete obj.profileImgUrl;
          delete obj.email;
          delete obj.type;
          delete obj.billingName;
          delete obj.cpData;
          delete obj.isFlagged;
          obj.BankAccountNumberText = profileData.bankAccountNumber != null && profileData.bankAccountNumber !== "" ? String(profileData.bankAccountNumber) : null;
          console.log(
            helperText.onChangePhoneNumber && verifiedPhoneNumber.current
          );
          if (helperText.onChangePhoneNumber && verifiedPhoneNumber.current) {
            const newPhoneNumber2 = newPhoneNumber.substring(1);
            profileData.contactNumber = newPhoneNumber2;
          } else {
            delete obj.contactNumber;
          }
          verifiedPhoneNumber.current = false;
          setHelperText((pre) => {
            pre.onChangePhoneNumber = false;
            return { ...pre };
          });
          console.log(obj);
          const { data, error } = await supabase
            .from("FOS")
            .update(obj)
            .eq("fosId", id);
          if (data) {
            console.log(data);
            setOpenConfirmation(true);
            setMessage("Resubmitted successfully, Please wait for approval.");
            setMessageStatus("Resubmitted");
            setMessageIcon(<GreenChecked width={"4.8rem"} height={"4.8rem"} />);
            dispatch(action.authLogin(profileData));
          } else {
            errorTost(error.message);
            console.log(error);
          }

          if (generalDetail.panName !== "") {
            addPanFOS(loggedInUser.user.fosId, generalDetail);
          }
          if (generalDetail.aadharName === undefined) {
            addAadhar(loggedInUser.user.fosId, generalDetail);
          }
        } else {
          setProfileData((pre) => {
            pre.bankAccountNumber =
              pre.bankAccountNumber === "" ? null : pre.bankAccountNumber;
            return { ...pre };
          });
          if (newEmailId !== profileData.email && verifiedEmail.current) {
            updateFosEmail();
          } else {
            setEmailLabelText("");
          }
          if (
            profileData?.bankAccountNumber !==
            loggedInUser?.user.bankAccountNumber
          ) {
            //If only bank details changed
            let obj = { ...profileData };
            delete obj.profileImgUrl;
            delete obj.email;
            delete obj.type;
            delete obj.billingName;
            delete obj.cpData;
            delete obj.isFlagged;
            obj.BankAccountNumberText = profileData.bankAccountNumber != null && profileData.bankAccountNumber !== "" ? String(profileData.bankAccountNumber) : null;
            console.log(obj);
            const { data, error } = await supabase
              .from("FOS")
              .update(obj)
              .eq("fosId", id);
            if (data) {
              console.log(data);
              successTost("Information updated successfully");
              dispatch(action.authLogin(profileData));
            } else {
              errorTost(error.message);
              console.log(error);
            }
          } else {
            infoTost("Nothing to update");
          }
        }
      }
    }
  }
  // for name
  async function updateCpContactPerson() {
    const { data, error } = await supabase
      .from("CpContactPerson")
      .update({ name: personName })
      .eq("cpId", profileData.cpId);
    if (data) {
      console.log("cp Contact person updated sucessfully");
      // if (loggedInUser.user.approvalStatus === "approved") {
      // }
      dispatch(
        action.authLogin({
          ...profileData,
          name: personName,
        })
      );
    } else {
      errorTost(error.message);
      console.error(error);
    }
  }
 


 
// const PAN_CardCheck = useRef(
//   debounce((panValue, _apiToken) => {
//     setIsLoadingPan(true);

//     getPAN_cardDetails(panValue, _apiToken)
//       .then((res) => {
//         const panData = res?.data?.data;
//         setIsLoadingPan(false);
//         setPersonName(panData?.full_name);
//         setPersonDetail((prev) => ({
//           ...prev,
//           personaName: panData?.full_name,
//         }));
//         console.log("panValue", panValue);

//         checkPanNumberExists(panValue)
//           .then((PanNumberResp) => {
//             console.log("PanNumberResp", PanNumberResp);

//             const existsForAnotherCP = PanNumberResp.some(
//               (entry) => entry.cpId !== loggedInUser.user.cpId
//             );

//             if (existsForAnotherCP) {
//               // PAN exists for another CP
//               setHelperText((prev) => ({
//                 ...prev,
//                 panNumber: "PAN number already exists",
//                 isPanValid: "PAN number already exists",
//                 panVerified: false,
//               }));

//               setCpDetails((prev) => ({
//                 ...prev,
//                 billingName: "",
//                 panName: "",
//                 panObject: {},
//               }));

//               setGeneralDetail((prev) => ({
//                 ...prev,
//                 panName: "",
//                 panObject: {},
//               }));

//               setBillingNameDisabled(false);
//               return;
//             }

//             if (res?.data?.message_code === "success" && panData) {
//               // Valid PAN and not duplicate (or belongs to this CP)
//               setHelperText((prev) => ({
//                 ...prev,
//                 panNumber: "",
//                 isPanValid: "",
//                 panVerified: true,
//               }));

//               setPanCategory(panData.category);

//               setCpDetails((prev) => ({
//                 ...prev,
//                 billingName: panData.full_name,
//                 panName: panData.full_name,
//                 panObject: panData,
//               }));

//               setBankDetails((prev) => ({
//                 ...prev,
//                 holderName: panData.full_name,
//               }));

//               setGeneralDetail((prev) => ({
//                 ...prev,
//                 panName: panData.full_name,
//                 panObject: panData,
//               }));

//               setPersonDetail((prev) => ({
//                 ...prev,
//                 personaName: panData.full_name,
//               }));

//               setBillingNameDisabled(true);

//               // Fetch GST from PAN
//               getGSTNumber(panValue)
//                 .then((gstRes) => {
//                   const gstList = gstRes?.data?.data?.gstin_list || [];
//                   setGstArray(gstList);

//                   if (gstList.length > 0) {
//                     const firstGst = gstList[0].gstin;

//                     setFetchedGstFromPan(firstGst);
//                     setCpDetails((prev) => ({
//                       ...prev,
//                       gstNumber: firstGst,
//                     }));

//                     setHelperText((prev) => ({
//                       ...prev,
//                       isGstNumber: "",
//                     }));
//                   } else {
//                     setFetchedGstFromPan("");
//                     setGstArray([]);
//                     setCpDetails((prev) => ({
//                       ...prev,
//                       gstApplicable: false,
//                       gstNumber: "",
//                     }));
//                   }
//                 })
//                 .catch((err) => {
//                   setIsLoadingPan(false);
//                   if (err.response?.data?.message === "No GSTIN Found.") {
//                     setFetchedGstFromPan("");
//                     setGstArray([]);
//                     setCpDetails((prev) => ({
//                       ...prev,
//                       gstApplicable: false,
//                       gstNumber: "",
//                     }));
//                   } else {
//                     handleErrors(err, "PAN_CardCheck → getGSTNumber error");
//                   }
//                 });
//             } else {
//               // Invalid PAN or failed response
//               setHelperText((prev) => ({
//                 ...prev,
//                 panNumber: "Invalid PAN data returned",
//                 isPanValid: "Invalid PAN data returned",
//                 panVerified: false,
//               }));

//               setCpDetails((prev) => ({
//                 ...prev,
//                 billingName: "",
//                 panName: "",
//                 panObject: {},
//               }));

//               setGeneralDetail((prev) => ({
//                 ...prev,
//                 panName: "",
//                 panObject: {},
//               }));

//               setBillingNameDisabled(false);
//             }
//           })
//           .catch((err) => {
//             console.error("PAN_CardCheck → checkPanNumberExists error:", err);
//             setHelperText((prev) => ({
//               ...prev,
//               panNumber: "Error checking PAN duplication",
//               isPanValid: "Error checking PAN duplication",
//               panVerified: false,
//             }));
//           });
//       })
//       .catch((err) => {
//         console.error("PAN_CardCheck → getPAN_cardDetails error:", err);
//         setIsLoadingPan(false);

//         setHelperText((prev) => ({
//           ...prev,
//           panNumber: err?.response?.data?.message || "PAN verification failed",
//           isPanValid: err?.response?.data?.message || "PAN verification failed",
//           panVerified: false,
//         }));

//         setCpDetails((prev) => ({
//           ...prev,
//           billingName: "",
//           panName: "",
//           panObject: {},
//         }));

//         setGeneralDetail((prev) => ({
//           ...prev,
//           panName: "",
//           panObject: {},
//         }));

//         setBillingNameDisabled(false);
//       });
//   }, 800)
// ).current;

const PAN_CardCheck = useRef(
  debounce((panValue, _apiToken) => {
    setIsLoadingPan(true);

    getPAN_cardDetails(panValue, _apiToken)
      .then((res) => {
        const panData = res?.data?.data;
        setIsLoadingPan(false);
        setPersonName(panData?.full_name);
        setPersonDetail((prev) => ({
          ...prev,
          personaName: panData?.full_name,
        }));

        checkPanNumberExists(panValue)
          .then((PanNumberResp) => {
            const existsForAnotherCP = PanNumberResp.some(
              (entry) => entry.cpId !== loggedInUser.user.cpId
            );

            if (existsForAnotherCP) {
              setHelperText((prev) => ({
                ...prev,
                panNumber: "PAN number already exists",
                isPanValid: "PAN number already exists",
                panVerified: false,
              }));

              setCpDetails((prev) => ({
                ...prev,
                billingName: "",
                panName: "",
                panObject: {},
              }));

              setGeneralDetail((prev) => ({
                ...prev,
                panName: "",
                panObject: {},
              }));

              setBillingNameDisabled(false);
              return;
            }

            if (res?.data?.message_code === "success" && panData) {
              setHelperText((prev) => ({
                ...prev,
                panNumber: "",
                isPanValid: "",
                panVerified: true,
                // Distinct from panVerified above, which also gets hydrated
                // to true on mount from the CP's existing PAN record (see
                // getKYCDocsCP) -- this one only ever becomes true from an
                // actual completed check in THIS session, so the Verify
                // button can tell "verified at registration" apart from
                // "just re-checked now" and show its green tick only for
                // the latter.
                panReVerifiedThisSession: true,
              }));

              setPanCategory(panData.category);

              setCpDetails((prev) => ({
                ...prev,
                billingName: panData.full_name,
                panName: panData.full_name,
                panObject: panData,
              }));

              setBankDetails((prev) => ({
                ...prev,
                holderName: panData.full_name,
              }));

              setGeneralDetail((prev) => ({
                ...prev,
                panName: panData.full_name,
                panObject: panData,
              }));

              setPersonDetail((prev) => ({
                ...prev,
                personaName: panData.full_name,
              }));

              setBillingNameDisabled(true);

              // ✅ Fetch GST from PAN
              getGSTNumber(panValue)
                .then((gstRes) => {
                  const gstList = gstRes?.data?.data?.gstin_list || [];
                  setGstArray(gstList);

                  if (gstList.length > 0) {
                    const activeGSTs = gstList.filter(
                      (gst) => gst.active_status?.toLowerCase() === "active"
                    );

                    if (activeGSTs.length === 1) {
                      // ✅ One GST → auto-select
                      const firstGst = activeGSTs[0].gstin;
                      setFetchedGstFromPan(firstGst);
                      setCpDetails((prev) => ({
                        ...prev,
                        gstNumber: firstGst,
                        gstApplicable: true,
                      }));
                      // cpDetails.gstApplicable above does NOT control which
                      // form branch renders -- profileData.isGSTApplicable
                      // does (see the ternary further down). Without this,
                      // a CP who registered without GST and is auto-detected
                      // to now have one stays stuck on the non-GST layout,
                      // which has no GST field to ever show it on.
                      setProfileData((prev) => ({
                        ...prev,
                        isGSTApplicable: true,
                      }));
                      setHelperText((prev) => ({
                        ...prev,
                        isGstNumber: "",
                        // Same as the sign-up flow (Register.jsx): a single
                        // active GST found via PAN only autofills the number
                        // here -- it is NOT auto-verified. The GST field's own
                        // "Verify" button (which calls getGSTInfo and checks
                        // the PAN match) is what sets this true, same manual
                        // step required at registration.
                        gstNumberVerified: false,
                      }));
                      setActiveGSTOptions([]);
                    } else if (activeGSTs.length > 1) {
                      // ✅ Multiple GST → show dropdown (force show GST field)
                      setActiveGSTOptions(activeGSTs.map((gst) => gst.gstin));
                      setCpDetails((prev) => ({
                        ...prev,
                        gstNumber: "",
                        gstApplicable: true, // force visible
                      }));
                      // Same as the single-GST branch above -- the dropdown
                      // this sets up has nowhere to render without also
                      // switching profileData.isGSTApplicable, which is what
                      // actually selects the GST-applicable form branch.
                      setProfileData((prev) => ({
                        ...prev,
                        isGSTApplicable: true,
                      }));
                      setHelperText((prev) => ({
                        ...prev,
                        isGstNumber: "Please select GST Number from dropdown",
                      }));
                    } else {
                      // ❌ No active GST
                      setFetchedGstFromPan("");
                      setCpDetails((prev) => ({
                        ...prev,
                        gstApplicable: false,
                        gstNumber: "",
                      }));
                      setActiveGSTOptions([]);
                    }
                  } else {
                    // ❌ No GST
                    setFetchedGstFromPan("");
                    setCpDetails((prev) => ({
                      ...prev,
                      gstApplicable: false,
                      gstNumber: "",
                    }));
                    setActiveGSTOptions([]);
                  }
                })
                .catch((err) => {
                  setIsLoadingPan(false);
                  if (err.response?.data?.message === "No GSTIN Found.") {
                    setFetchedGstFromPan("");
                    setGstArray([]);
                    setCpDetails((prev) => ({
                      ...prev,
                      gstApplicable: false,
                      gstNumber: "",
                    }));
                    setActiveGSTOptions([]);
                  } else {
                    handleErrors(err, "PAN_CardCheck → getGSTNumber error");
                  }
                });
            } else {
              setHelperText((prev) => ({
                ...prev,
                panNumber: "Invalid PAN data returned",
                isPanValid: "Invalid PAN data returned",
                panVerified: false,
              }));

              setCpDetails((prev) => ({
                ...prev,
                billingName: "",
                panName: "",
                panObject: {},
              }));

              setGeneralDetail((prev) => ({
                ...prev,
                panName: "",
                panObject: {},
              }));

              setBillingNameDisabled(false);
            }
          })
          .catch((err) => {
            console.error("PAN_CardCheck → checkPanNumberExists error:", err);
            setHelperText((prev) => ({
              ...prev,
              panNumber: "Error checking PAN duplication",
              isPanValid: "Error checking PAN duplication",
              panVerified: false,
            }));
          });
      })
      .catch((err) => {
        console.error("PAN_CardCheck → getPAN_cardDetails error:", err);
        setIsLoadingPan(false);

        setHelperText((prev) => ({
          ...prev,
          panNumber: err?.response?.data?.message || "PAN verification failed",
          isPanValid: err?.response?.data?.message || "PAN verification failed",
          panVerified: false,
        }));

        setCpDetails((prev) => ({
          ...prev,
          billingName: "",
          panName: "",
          panObject: {},
        }));

        setGeneralDetail((prev) => ({
          ...prev,
          panName: "",
          panObject: {},
        }));

        setBillingNameDisabled(false);
      });
  }, 800)
).current;




  

// const gstInfoApiCall = debounce((e) => {
//   let result = gstArray.filter(({ gstin }) => e === gstin);
//   setIsGSTLoading(true);

//   if (result.length > 0) {
//     getGSTInfo(e)
//       .then((res) => {
//         setIsGSTLoading(false);

//         const gstData = res.data.data;
//         const gstin = e;
//         const extractedPANFromGST = gstin.substring(2, 12);
//         const panFromCp = cpDetails?.panObject?.pan_number;

//         if (!panFromCp) {
//           setHelperText((prev) => ({
//             ...prev,
//             isGstNumber: "PAN details missing. Please verify PAN first.",
//             gstNumberVerified: false,
//           }));
//           errorTost("PAN not available. Please verify PAN first.");
//           return;
//         }

//         if (extractedPANFromGST !== panFromCp) {
//           setHelperText((prev) => ({
//             ...prev,
//             isGstNumber: "PAN and GST Number do not match.",
//             gstNumberVerified: false,
//           }));
//           errorTost("PAN in GST doesn't match the provided PAN.");
//           return;
//         }

//         // ✅ GST verified
//         setHelperText((prev) => ({
//           ...prev,
//           gstNumberVerified: true,
//           isGstNumber: "",
//         }));

//         // Save GST object
//         setCpDetails((prev) => ({
//           ...prev,
//           gstObject: gstData,
//           gstApplicable: true, // keep visible after verification
//         }));
//       })
//       .catch((err) => {
//         errorTost(err.message);
//         setIsGSTLoading(false);
//         setHelperText((prev) => ({
//           ...prev,
//           gstNumberVerified: false,
//         }));
//       });
//   } else {
//     setIsGSTLoading(false);
//     setHelperText((prev) => ({
//       ...prev,
//       isGstNumber: "GST Number is not linked with PAN",
//     }));
//   }
// }, 800);




const gstInfoApiCall = debounce((e) => {
  let result = gstArray.filter(({ gstin }) => e === gstin);
  setIsGSTLoading(true);

  if (result.length > 0) {
    getGSTInfo(e)
      .then(async (res) => {
        setIsGSTLoading(false);

        const gstData = res.data.data;
        const gstin = e;
        const extractedPANFromGST = gstin.substring(2, 12); // GSTIN chars 3–12 = PAN
        const panFromCp = cpDetails?.panObject?.pan_number;

        if (!panFromCp) {
          setHelperText((prev) => ({
            ...prev,
            isGstNumber: "PAN details missing. Please verify PAN first.",
            gstNumberVerified: false,
          }));
          errorTost("PAN not available. Please verify PAN first.");
          return;
        }

        if (extractedPANFromGST !== panFromCp) {
          setHelperText((prev) => ({
            ...prev,
            isGstNumber: "PAN and GST Number do not match.",
            gstNumberVerified: false,
          }));
          errorTost("PAN in GST doesn't match the provided PAN.");
          return;
        }

        // 🔍 Block if this GST number already belongs to another CP
        try {
          const gstExistsResp = await checkGSTNumberExists(gstin);
          const existsForAnotherCP = gstExistsResp.some(
            (entry) => entry.cpId !== loggedInUser.user.cpId
          );
          if (existsForAnotherCP) {
            setHelperText((prev) => ({
              ...prev,
              isGstNumber: "GST number already exists",
              gstNumberVerified: false,
            }));
            return;
          }
        } catch (err) {
          console.error("checkGSTNumberExists", err);
        }

        // ✅ GST verified
        setHelperText((prev) => ({
          ...prev,
          gstNumberVerified: true,
          isGstNumber: "",
        }));

        // --- NEW: If GST is applicable, store constitution_of_business as Proprietorship Name ---
        if (gstData.constitution_of_business) {
          setCpDetails((prev) => ({
            ...prev,
            proprietorshipName: gstData.constitution_of_business, // GST constitution_of_business
            gstObject: gstData,
            gstApplicable: true, // keep GST visible after verification
            billingName: prev?.reraExtracted?.agentName || prev.billingName,
                gstBusinessName: gstData.business_name || "",
          gstLegalName: gstData.legal_name || ""
          }));
        } else {
          setCpDetails((prev) => ({
            ...prev,
            gstObject: gstData,
            gstApplicable: true, // still mark as applicable
          }));
        }
        // --- END NEW ---

        // Optional: check if GST business name differs from current billing name
        if (gstData.business_name && gstData.business_name !== cpDetails.billingName) {
          setLedgerName(gstData.business_name);
          setMessage(
            "GST & PAN Name Not matched! Create Ledger using Proprietorship or Partnership."
          );
          // setOpenConfirmation(true);
        }
      })
      .catch((err) => {
        errorTost(err.message);
        setIsGSTLoading(false);
        setHelperText((prev) => ({
          ...prev,
          gstNumberVerified: false,
        }));
      });
  } else {
    setIsGSTLoading(false);
    setHelperText((prev) => ({
      ...prev,
      isGstNumber: "GST Number is not linked with PAN",
    }));
  }
}, 800);


  const debouncedBankDetailsCall = debounce((e) => {
    checkBankDetails(profileData.bankAccountNumber, profileData.bankIFSCCode);
  }, 800);

  // function checkBankDetails(accountNo, IFSC_Code) {
  //   setIsLoadingIfSC(true);
  //   setIsLoadingAccount(true);
  //   console.log(accountNo, IFSC_Code);
  //   let postBody = {
  //     id_number: accountNo,
  //     ifsc: IFSC_Code,
  //   };
  //   console.log(postBody);
  //   getAccountDetails(postBody)
  //     .then((res) => {
  //       setIsLoadingIfSC(false);
  //       setIsLoadingAccount(false);
  //       console.log(res?.data?.data);
  //       if (res?.data?.data?.account_exists) {
  //         setHelperText((pre) => {
  //           pre.bankAccountNumber = "";
  //           pre.bankAccountHolderName = "";
  //           pre.bankIFSCCode = "";
  //           pre.bankDetailsIsVerified = true;
  //           return { ...pre };
  //         });
  //         setProfileData((pre) => {
  //           pre.bankAccountHolderName = res.data.data.full_name;
  //           return { ...pre };
  //         });
  //         if (profileData.type === "CP") {
  //           if (profileData.billingName.includes(res.data.data.full_name)) {
  //             setHelperText((pre) => {
  //               pre.bankAccountHolderName = "";
  //               pre.bankDetailsIsVerified = true;
  //               return { ...pre };
  //             });
  //           } else {
  //             setHelperText((pre) => {
  //               pre.bankAccountHolderName =
  //                 "Account holder name and Billing name doesn't match";
  //               pre.bankDetailsIsVerified = false;
  //               return { ...pre };
  //             });
  //           }
  //         } else {
  //           if (profileData.name.includes(res.data.data.full_name)) {
  //             setHelperText((pre) => {
  //               pre.bankAccountHolderName = "";
  //               pre.bankDetailsIsVerified = true;
  //               return { ...pre };
  //             });
  //           } else {
  //             setHelperText((pre) => {
  //               pre.bankAccountHolderName =
  //                 "Account holder name and pan name doesn't match";
  //               pre.bankDetailsIsVerified = false;
  //               return { ...pre };
  //             });
  //           }
  //         }

  //         console.log("if");
  //       } else {
  //         console.log("else");
  //         setHelperText((pre) => {
  //           pre.bankAccountNumber = "Something went wrong";
  //           pre.bankIFSCCode = "Something went wrong";
  //           pre.bankDetailsIsVerified = false;
  //           return { ...pre };
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       setIsLoadingIfSC(false);
  //       setIsLoadingAccount(false);
  //       console.log(err);
  //       // console.log(err.response.data);

  //       // errorToast(err.response.data.message_code);
  //       setHelperText((pre) => {
  //         pre.bankAccountNumber = err?.response?.data?.message_code;
  //         // pre.isIfscCode = err?.response?.data?.message_code;
  //         pre.bankDetailsIsVerified = false;
  //         return { ...pre };
  //       });
  //       if (err?.response?.data?.message_code?.includes("invalid_ifsc")) {
  //         setHelperText((pre) => {
  //           pre.bankAccountNumber = "";
  //           pre.bankIFSCCode = err?.response?.data?.message_code;
  //           pre.bankDetailsIsVerified = false;
  //           return { ...pre };
  //         });
  //       }
  //       //! Error Toast
  //       //* err.response.data.message_code
  //     });
  // }

  // const RERACheck = useRef(
  //   debounce((e) => {
  //     // console.log(e);
  //     getReraDetails(e)
  //       .then((res) => {
  //         setIsLoadingRERA(false);
  //         checkForUniqueDocs(e)
  //           .then((resp) => {
  //             console.log(resp);
  //             console.log(resp.length > 0, resp.length);
  //             if (resp.length) {
  //               setHelperText((pre) => {
  //                 pre.reraNumber = "User already exists";
  //                 pre.isReraValid = false;
  //                 return { ...pre };
  //               });
  //             } else {
  //               setHelperText((pre) => {
  //                 pre.reraNumber = "";
  //                 return { ...pre };
  //               });
  //             }
  //           })
  //           .catch((err) => {
  //             console.log(err);
  //           });
  //         console.log(res.data);
  //         if (res?.data?.message_code === "success") {
  //           setHelperText((pre) => {
  //             pre.isReraValid = true;
  //             return { ...pre };
  //           });
  //           console.log("res.data.data.agent_name", res.data.data.agent_name);
  //           setGeneralDetail((pre) => {
  //             pre.reraName = res.data.data.agent_name;
  //             pre.reraObject = res.data.data;
  //             return { ...pre };
  //           });
  //         }
  //       })
  //       .catch((err) => {
  //         setIsLoadingRERA(false);
  //         console.log("err", err);
  //         // console.log(err?.response?.data);
  //         setHelperText((pre) => {
  //           pre.reraNumber = err?.response?.data?.message;
  //           pre.isReraValid = false;
  //           return { ...pre };
  //         });
  //       });
  //   }, 800)
  // ).current;

  // const reraApiCall = useRef(
  //   debounce((reraNumber) => {
  //     console.log("🔍 Starting RERA API Call for:", reraNumber);

  //     getReraDetails(reraNumber)
  //       .then(async (res) => {
  //         const details = res.data.data.details[0];
  //         const certificateUrl = details?.certificate_url;
  //         const applicationUrl = details?.application_url;

  //         console.log("📄 Certificate URL:", certificateUrl);
  //         console.log("📄 Application URL:", applicationUrl);

  //         setGeneralDetail((prev) => {
  //           prev.reraObject = res.data.data;
  //           return { ...prev };
  //         });

  //         setHelperText((pre) => {
  //           pre.reraNumber = "Reading RERA doc...";
  //           return { ...pre };
  //         });

  //         const extractDatesFromCertificate = async (url) => {
  //           try {
  //             const resp = await readReraPdfFile(url);
  //             for (const page of resp?.data?.pdf?.pages || []) {
  //               const pageText = page.texts.map((t) => t.text).join(" ").replace(/\s+/g, ' ').trim();
  //               const match = pageText.match(/commencing from\s+(\d{2}\/\d{2}\/\d{4})\s+and ending with\s+(\d{2}\/\d{2}\/\d{4})/i);
  //               if (match) {
  //                 const [dd1, mm1, yyyy1] = match[1].split("/");
  //                 const [dd2, mm2, yyyy2] = match[2].split("/");
  //                 return {
  //                   startDate: new Date(`${yyyy1}-${mm1}-${dd1}`).getTime(),
  //                   endDate: new Date(`${yyyy2}-${mm2}-${dd2}`).getTime(),
  //                 };
  //               }
  //             }
  //           } catch (err) {
  //             console.error("❌ Error reading certificate for dates:", err);
  //           }
  //           return { startDate: null, endDate: null };
  //         };

  //         const extractAgentData = async (url, isFallback = false) => {
  //           try {
  //             const resp = await readReraPdfFile(url);
  //             const findTextNearHint = (resp, hint) => {
  //               for (const page of resp?.data?.pdf?.pages) {
  //                 const found = page?.texts.find((_, idx) => {
  //                   if (idx === 0) return false;
  //                   return page.texts[idx - 1].text.trim().toLowerCase() === hint.toLowerCase();
  //                 });
  //                 if (found) return found.text.trim();
  //               }
  //               return null;
  //             };

  //             let agentName =
  //               findTextNearHint(resp, "Name of Agent:") ||
  //               findTextNearHint(resp, "Name of Agent") || null;

  //             let typeOfAgent =
  //               findTextNearHint(resp, "Type of Agent:") ||
  //               findTextNearHint(resp, "Type of Agent") || null;

  //             if (isFallback && (!typeOfAgent || typeOfAgent === "")) {
  //               const infoType = resp?.data?.pdf?.pages[0]?.texts.find((t, i, arr) =>
  //                 arr[i - 1]?.text === "Information Type"
  //               )?.text;
  //               if (infoType === "Other Than Individual") typeOfAgent = "Other Than Individual";
  //               else typeOfAgent = "Individual";
  //             }

  //             const cpType = typeOfAgent !== "Individual" ? "Entity" : "Individual";

  //             return { agentName, typeOfAgent, cpType };
  //           } catch (err) {
  //             console.error(`❌ Error reading ${isFallback ? "application URL" : "certificate URL"}:`, err);
  //             return { agentName: null, typeOfAgent: null, cpType: "Individual" };
  //           }
  //         };

  //         const { startDate, endDate } = await extractDatesFromCertificate(certificateUrl);

  //         if (!startDate || !endDate) {
  //           setIsLoadingRERA(false);
  //           setHelperText((pre) => ({
  //             ...pre,
  //             reraVerified: false,
  //             reraNumber: "Start/End date missing in certificate.",
  //           }));
  //           return;
  //         }

  //         let { agentName, typeOfAgent, cpType } = await extractAgentData(certificateUrl);

  //         if ((!agentName || !typeOfAgent) && applicationUrl) {
  //           const fallback = await extractAgentData(applicationUrl, true);
  //           agentName = agentName || fallback.agentName;
  //           typeOfAgent = typeOfAgent || fallback.typeOfAgent;
  //           cpType = cpType || fallback.cpType;
  //         }

  //         console.log("📅 RERA Start Date:", new Date(startDate));
  //         console.log("📅 RERA End Date:", new Date(endDate));
  //         console.log("🧑 Agent Name:", agentName);
  //         console.log("🏢 Type of Agent:", typeOfAgent);
  //         console.log("🔹 CP Type:", cpType);

  //         setReraStartDate(startDate);
  //         setReraEndDate(endDate);
  //         setAgentType(typeOfAgent);

  //         setGeneralDetail((prev) => ({
  //           ...prev,
  //           reraName: details?.agent_name,
  //           reraExtracted: { agentName, typeOfAgent, startDate, endDate, cpType },
  //         }));

  //         setHelperText((pre) => ({
  //           ...pre,
  //           reraNumber: "",
  //           reraVerified: true,
  //         }));

  //         setIsLoadingRERA(false);
  //       })
  //       .catch((err) => {
  //         console.error("❌ RERA fetch failed:", err);
  //         setIsLoadingRERA(false);
  //         setHelperText((pre) => ({
  //           ...pre,
  //           reraVerified: false,
  //           reraNumber: err?.response?.data?.message || "RERA fetch failed",
  //         }));
  //       });
  //   }, 800)
  // ).current;

  function wordsMatch(name1, name2) {
    const a = name1?.split(" ") || [];
    const b = name2?.split(" ") || [];
    const common = a.filter((word) => b.includes(word));
    return common.length >= 2;
  }

// RERA name vs GST business/legal name. Delegates to the shared matcher so it
// agrees with the bank-name comparison below and with signup.
const isPartialMatch = (reraName, gstName) => namesMatch(reraName, gstName);
















//   const reraApiCall = debounce((e) => {
//   console.log("🔍 Starting RERA API Call for:", e);
//   setIsReraLoading(true);

//   getReraDetails(e)
//     .then((res) => {
//       const details = res.data.data.details[0];
//       const certificateUrl = details?.certificate_url;
//       const applicationUrl = details?.application_url;
//       const agentNameFromResponse = details?.agent_name;

//       console.log("📛 RERA agent name from API:", agentNameFromResponse);
//       console.log("📄 Certificate URL:", certificateUrl);
//       console.log("📄 Application URL:", applicationUrl);

//       // ✅ Save RERA details
//       setGeneralDetail((prev) => ({
//         ...prev,
//         reraName: agentNameFromResponse || "",
//         reraNumber: details?.certificate_number,
//         reraObject: details,
//       }));

//       setCpDetails((prev) => ({
//         ...prev,
//         reraObject: res.data.data,
//       }));

//       setHelperText((pre) => ({
//         ...pre,
//         reraNumber: "reading rera doc...",
//       }));

//       // 📌 Extract from Certificate
//       const extractFromCertificate = async (url) => {
//         let startDate = null;
//         let endDate = null;
//         let typeOfAgent = "";
//         let cpType = "";

//         try {
//           const resp = await readReraPdfFile(url);
//           for (const page of resp?.data?.pdf?.pages || []) {
//             const pageText = page.texts
//               .map((t) => t.text)
//               .join(" ")
//               .replace(/\s+/g, " ")
//               .trim();

//             // Dates
//             const match = pageText.match(
//               /commencing from\s+(\d{2}\/\d{2}\/\d{4})\s+and ending with\s+(\d{2}\/\d{2}\/\d{4})/i
//             );
//             if (match) {
//               const toTimestamp = (d) => {
//                 const [dd, mm, yyyy] = d.split("/");
//                 return new Date(`${yyyy}-${mm}-${dd}`).getTime();
//               };
//               startDate = toTimestamp(match[1]);
//               endDate = toTimestamp(match[2]);
//             }

//             // Type of Agent
//             const typeMatch = pageText.match(/type of agent\s*:\s*(.+?)(?:\s|$)/i);
//             if (typeMatch) {
//               typeOfAgent = typeMatch[1].trim();
//             }

//             // cpType from typeOfAgent
//             if (typeOfAgent) {
//               if (/individual/i.test(typeOfAgent)) {
//                 cpType = "Individual";
//               } else {
//                 cpType = "Entity";
//               }
//             } else {
//               // Fallback detection from text
//               if (/individual/i.test(pageText)) {
//                 cpType = "Individual";
//               } else if (/partnership|company|firm|entity/i.test(pageText)) {
//                 cpType = "Entity";
//               }
//             }
//           }
//         } catch (err) {
//           console.error("❌ Error reading certificate:", err);
//         }

//         console.log("📄 Extracted from Certificate:", { startDate, endDate, typeOfAgent, cpType });
//         return { startDate, endDate, typeOfAgent, cpType };
//       };

//       // 📌 Extract cpType from Application
//       const extractCpTypeFromApplication = async (url) => {
//         let detectedType = "Individual";
//         try {
//           const resp = await readReraPdfFile(url);
//           const text = (resp?.data?.pdf?.pages || [])
//             .map((p) => p.texts.map((t) => t.text).join(" "))
//             .join(" ")
//             .replace(/\s+/g, " ")
//             .trim()
//             .toLowerCase();

//           console.log("📄 Application PDF text (first 200 chars):", text.slice(0, 200));

//           if (text.includes("other than individual")) {
//             detectedType = "Entity";
//           } else if (text.includes("individual")) {
//             detectedType = "Individual";
//           }
//         } catch (err) {
//           console.error("❌ Error reading application PDF:", err);
//         }

//         console.log("✅ Detected CP Type from Application:", detectedType);
//         return detectedType;
//       };

//       const handleExtraction = async () => {
//         if (!certificateUrl) {
//           console.error("❌ No certificate URL provided.");
//           return;
//         }

//         // Step 1 → Certificate
//         let { startDate, endDate, typeOfAgent, cpType } = await extractFromCertificate(certificateUrl);

//         if (!startDate || !endDate) {
//           setIsReraLoading(false);
//           setHelperText((pre) => ({
//             ...pre,
//             reraVerified: false,
//             reraNumber: "Start/End date missing in certificate.",
//           }));
//           return;
//         }

//         // Step 2 → If cpType missing, fallback to Application
//         if (!cpType && applicationUrl) {
//           cpType = await extractCpTypeFromApplication(applicationUrl);
//         }

//         // Step 3 → Save extracted RERA info
//         setReraStartDate(startDate);
//         setReraEndDate(endDate);

//         setCpDetails((prev) => ({
//           ...prev,
//           reraExtracted: {
//             agentName: agentNameFromResponse,
//             typeOfAgent: typeOfAgent || "",
//             startDate,
//             endDate,
//             cpType: cpType || "Individual",
//           },


//           cpType: cpType || "Individual",




//         }));

//         setIsReraLoading(false);
//         setHelperText((pre) => ({
//           ...pre,
//           reraNumber: "",
//           reraVerified: true,
//         }));

//         // 📌 NAME MATCHING LOGIC (unchanged from your original)
//         const normalizeName = (name) =>
//           name
//             ?.replace(/PVT\.?\s*LTD\.?/gi, "PRIVATE LIMITED")
//             ?.replace(/[.,]/g, "")
//             ?.replace(/\s+/g, " ")
//             ?.trim()
//             ?.toUpperCase();

//         const gstin = cpDetails?.gstNumber?.trim();
//         const isMaharashtraGST = gstin?.startsWith("27") && cpDetails?.gstApplicable;

//         const agentNameRERA = normalizeName(agentNameFromResponse);
//         const gstBusinessName = normalizeName(cpDetails?.gstObject?.business_name);
//         const gstLegalName = normalizeName(cpDetails?.gstObject?.legal_name);
//         const panName = normalizeName(cpDetails?.panObject?.full_name);

//         console.log("📤 Normalized Names:");
//         console.log("🔹 RERA Agent Name:", agentNameRERA);
//         console.log("🔹 GST Business Name:", gstBusinessName);
//         console.log("🔹 GST Legal Name:", gstLegalName);
//         console.log("🔹 PAN Name:", panName);

//         if (isMaharashtraGST) {
//           const gstMatch =
//             isPartialMatch(agentNameRERA, gstBusinessName) ||
//             isPartialMatch(agentNameRERA, gstLegalName);

//           if (gstMatch) {
//             setCpDetails((prev) => ({
//               ...prev,
//               billingName: agentNameRERA,
//             }));
//             setHelperText((pre) => ({
//               ...pre,
//               isBillingName: "",
//             }));
//           } else {
//             errorTost("❌ RERA Name does not match GST Business or Legal Name.");
//             setHelperText((pre) => ({
//               ...pre,
//               isBillingName: "Mismatch: RERA Name ≠ GST Business/Legal Name",
//             }));
//             setLedgerName(agentNameRERA);
//             setMessage(
//               "RERA Name does not match GST Business/Legal Name! Please verify or create as CP Individual."
//             );
//             setReraPopUp(true);
//           }
//         } else {
//           const namesMatch =
//             panName &&
//             agentNameRERA &&
//             (panName === agentNameRERA ||
//               agentNameRERA.includes(panName) ||
//               panName.includes(agentNameRERA));

//           if (namesMatch) {
//             setCpDetails((prev) => ({
//               ...prev,
//               billingName: agentNameRERA,
//             }));
//             setHelperText((pre) => ({
//               ...pre,
//               isBillingName: "",
//             }));
//           } else {
//             console.warn("⚠️ PAN Name mismatch — asking for firm name.");
//             setLedgerName(agentNameRERA);
//             setMessage(
//               "PAN Name does not match RERA Name! Please enter your Proprietorship/Firm Name."
//             );
//             setHelperText((pre) => ({
//               ...pre,
//               isBillingName: "Firm name is required to proceed",
//             }));
//             setAskFirmNameDialog(true);
//           }
//         }
//       };

//       handleExtraction();
//     })
//     .catch((err) => {
//       console.error("❌ RERA fetch failed:", err);
//       setIsReraLoading(false);
//       setHelperText((pre) => ({
//         ...pre,
//         reraVerified: false,
//         reraNumber: err?.response?.data?.message || "RERA fetch failed",
//       }));
//     });
// }, 800);




const reraApiCall = debounce((e) => {
  console.log("🔍 Starting RERA API Call for:", e);
  setIsReraLoading(true);

  getReraDetails(e)
    .then((res) => {
      const details = res.data.data.details[0];
      const certificateUrl = details?.certificate_url;
      const applicationUrl = details?.application_url;
      const agentNameFromResponse = details?.agent_name;

      console.log("📛 RERA agent name from API:", agentNameFromResponse);
      console.log("📄 Certificate URL:", certificateUrl);
      console.log("📄 Application URL:", applicationUrl);

      // ✅ Save RERA details
      setGeneralDetail((prev) => ({
        ...prev,
        reraName: agentNameFromResponse || "",
        reraNumber: details?.certificate_number,
        reraObject: details,
      }));

      setCpDetails((prev) => ({
        ...prev,
        reraObject: res.data.data,
      }));

      setHelperText((pre) => ({
        ...pre,
        reraNumber: "reading rera doc...",
      }));

      // 📌 Extract from Certificate
      const extractFromCertificate = async (url) => {
        let startDate = null;
        let endDate = null;
        let typeOfAgent = "";
        let cpType = "";

        try {
          const resp = await readReraPdfFile(url);
          for (const page of resp?.data?.pdf?.pages || []) {
            const pageText = page.texts
              .map((t) => t.text)
              .join(" ")
              .replace(/\s+/g, " ")
              .trim();

            // Dates
            const match = pageText.match(
              /commencing from\s+(\d{2}\/\d{2}\/\d{4})\s+and ending with\s+(\d{2}\/\d{2}\/\d{4})/i
            );
            if (match) {
              const toTimestamp = (d) => {
                const [dd, mm, yyyy] = d.split("/");
                return new Date(`${yyyy}-${mm}-${dd}`).getTime();
              };
              startDate = toTimestamp(match[1]);
              endDate = toTimestamp(match[2]);
            }

            // Type of Agent
            const typeMatch = pageText.match(/type of agent\s*:\s*(.+?)(?:\s|$)/i);
            if (typeMatch) {
              typeOfAgent = typeMatch[1].trim();
            }

            // cpType from typeOfAgent
            if (typeOfAgent) {
              if (/individual/i.test(typeOfAgent)) {
                cpType = "Individual";
              } else {
                cpType = "Entity";
              }
            } else {
              // Fallback detection from text
              if (/individual/i.test(pageText)) {
                cpType = "Individual";
              } else if (/partnership|company|firm|entity/i.test(pageText)) {
                cpType = "Entity";
              }
            }
          }
        } catch (err) {
          console.error("❌ Error reading certificate:", err);
        }

        console.log("📄 Extracted from Certificate:", { startDate, endDate, typeOfAgent, cpType });
        return { startDate, endDate, typeOfAgent, cpType };
      };

      // 📌 Extract cpType from Application
      const extractCpTypeFromApplication = async (url) => {
        let detectedType = "Individual";
        try {
          const resp = await readReraPdfFile(url);
          const text = (resp?.data?.pdf?.pages || [])
            .map((p) => p.texts.map((t) => t.text).join(" "))
            .join(" ")
            .replace(/\s+/g, " ")
            .trim()
            .toLowerCase();

          console.log("📄 Application PDF text (first 200 chars):", text.slice(0, 200));

          if (text.includes("other than individual")) {
            detectedType = "Entity";
          } else if (text.includes("individual")) {
            detectedType = "Individual";
          }
        } catch (err) {
          console.error("❌ Error reading application PDF:", err);
        }

        console.log("✅ Detected CP Type from Application:", detectedType);
        return detectedType;
      };

      const handleExtraction = async () => {
        if (!certificateUrl) {
          console.error("❌ No certificate URL provided.");
          setIsReraLoading(false);
          setHelperText((pre) => ({
            ...pre,
            reraVerified: false,
            reraNumber:
              res.data.message ||
              "RERA verification failed. Please upload your certificate manually.",
          }));
          setShowUpload(true);
          return;
        }

        // Step 1 → Certificate
        let { startDate, endDate, typeOfAgent, cpType } = await extractFromCertificate(certificateUrl);

        // if (!startDate || !endDate) {
        //   setIsReraLoading(false);
        //   setHelperText((pre) => ({
        //     ...pre,
        //     reraVerified: false,
        //     reraNumber: "Start/End date missing in certificate.",
        //   }));
        //   return;
        // }


        if (!startDate || !endDate) {
  console.warn("❌ Certificate dates missing. Triggering upload fallback.");
  setIsReraLoading(false);
  setHelperText((pre) => ({
    ...pre,
    reraVerified: false,
    reraNumber: "Dates missing in RERA certificate. Please upload manually.",
  }));
  setShowUpload(true); // ✅ show manual upload
  return { startDate: null, endDate: null, typeOfAgent: "", cpType: "" };
}


        // Step 2 → If cpType missing, fallback to Application
        if (!cpType && applicationUrl) {
          cpType = await extractCpTypeFromApplication(applicationUrl);
        }

        // Step 3 → Save extracted RERA info
        setReraStartDate(startDate);
        setReraEndDate(endDate);

        setCpDetails((prev) => ({
          ...prev,
          reraExtracted: {
            agentName: agentNameFromResponse,
            typeOfAgent: typeOfAgent || "",
            startDate,
            endDate,
            cpType: cpType || "Individual",
          },
          cpType: cpType || "Individual",
        }));

        // 🔍 Block if this RERA number already belongs to another CP
        try {
          const reraExistsResp = await checkReraNumberExists(e);
          const existsForAnotherCP = reraExistsResp.some(
            (entry) => entry.cpId !== loggedInUser.user.cpId
          );
          if (existsForAnotherCP) {
            setIsReraLoading(false);
            setHelperText((pre) => ({
              ...pre,
              reraVerified: false,
              reraNumber: "RERA number already exists",
            }));
            return;
          }
        } catch (err) {
          console.error("checkReraNumberExists", err);
        }

        setIsReraLoading(false);
        setShowUpload(false); // ✅ auto-extraction succeeded, no need for manual fallback
        setHelperText((pre) => ({
          ...pre,
          reraNumber: "",
          reraVerified: true,
        }));

        // 📌 NAME MATCHING LOGIC
        const normalizeName = (name) =>
          name
            ?.replace(/PVT\.?\s*LTD\.?/gi, "PRIVATE LIMITED")
            ?.replace(/[.,]/g, "")
            ?.replace(/\s+/g, " ")
            ?.trim()
            ?.toUpperCase();

        const gstApplicable = cpDetails?.gstApplicable;
        const agentNameRERA = normalizeName(agentNameFromResponse);
        const gstBusinessName = normalizeName(cpDetails?.gstObject?.business_name);
        const gstLegalName = normalizeName(cpDetails?.gstObject?.legal_name);
        const panName = normalizeName(cpDetails?.panObject?.full_name);

        console.log("📤 Normalized Names:");
        console.log("🔹 RERA Agent Name:", agentNameRERA);
        console.log("🔹 GST Business Name:", gstBusinessName);
        console.log("🔹 GST Legal Name:", gstLegalName);
        console.log("🔹 PAN Name:", panName);

        if (gstApplicable) {
          const gstMatch =
            isPartialMatch(agentNameRERA, gstBusinessName) ||
            isPartialMatch(agentNameRERA, gstLegalName);

          if (gstMatch) {
            setCpDetails((prev) => ({
              ...prev,
              billingName: agentNameRERA,
            }));
            setHelperText((pre) => ({
              ...pre,
              isBillingName: "",
            }));
          } else {
            // ❌ GST applicable & mismatch → error only, no firm name dialog
            errorTost("❌ RERA Name does not match GST Business or Legal Name.");
            setHelperText((pre) => ({
              ...pre,
              isBillingName: "Mismatch: RERA Name ≠ GST Business/Legal Name",
            }));
          }
        
        
        
        
        // else {
        //   const namesMatch =
        //     panName &&
        //     agentNameRERA &&
        //     (panName === agentNameRERA ||
        //       agentNameRERA.includes(panName) ||
        //       panName.includes(agentNameRERA));

        //   if (namesMatch) {
        //     setCpDetails((prev) => ({
        //       ...prev,
        //       billingName: agentNameRERA,
        //     }));
        //     setHelperText((pre) => ({
        //       ...pre,
        //       isBillingName: "",
        //     }));
        //   } else {
        //     console.warn("⚠️ PAN Name mismatch — asking for firm name.");
        //     setLedgerName(agentNameRERA);
        //     setMessage(
        //       "PAN Name does not match RERA Name! Please enter your Proprietorship/Firm Name."
        //     );
        //     setHelperText((pre) => ({
        //       ...pre,
        //       isBillingName: "Firm name is required to proceed",
        //     }));
        //     setAskFirmNameDialog(true);
        //   }
        // }


       } else {
  if (
    panName &&
    agentNameRERA &&
    (panName === agentNameRERA ||
      agentNameRERA.includes(panName) ||
      panName.includes(agentNameRERA))
  ) {
    // ✅ Exact or partial match
    setCpDetails((prev) => ({
      ...prev,
      billingName: agentNameRERA,
    }));
    setHelperText((pre) => ({
      ...pre,
      isBillingName: "",
    }));
  } else {
    console.warn("⚠️ PAN Name mismatch — checking proprietorship option.");

    // 🆕 Step 2a: If GST is NOT applicable → Ask proprietorship first
    if (!cpDetails?.gstApplicable) {
      setLedgerName(agentNameRERA);
      setMessage(
        "RERA Name does not fully match PAN Name. Is this a Proprietorship?"
      );
      setShowProprietorshipDialog(true); // <-- Opens Yes/No dialog
      return; // Stop further execution until user responds
    }

    // Step 2b: Original mismatch logic (for GST applicable)
    setCpDetails((prev) => ({
      ...prev,
      billingName: agentNameRERA,
    }));
    setLedgerName(agentNameRERA);
    setMessage(
      "PAN Name does not match RERA Name! Please enter your Proprietorship/Firm Name."
    );
    setHelperText((pre) => ({
      ...pre,
      isBillingName: "",
    }));
    setAskFirmNameDialog(true);
  }
}



      };

      handleExtraction();
    })
    .catch((err) => {
      console.error("❌ RERA fetch failed:", err);
      setIsReraLoading(false);
      setHelperText((pre) => ({
        ...pre,
        reraVerified: false,
        reraNumber:
          err?.response?.data?.message ||
          "RERA verification failed. Please upload your certificate manually.",
      }));
      setShowUpload(true);
    })
       .finally(() => {
      setIsReraLoading(false); // ✅ always stop loader here
    });
}, 800);


  function normalizeName(name) {
    return name
      ?.replace(/PVT\.?\s*LTD\.?/gi, "PRIVATE LIMITED")
      ?.replace(/[.,]/g, "")
      ?.replace(/\s+/g, " ")
      ?.trim()
      ?.toUpperCase();
  }

  

  // Delegates to the shared matcher in Services/nameMatch. This screen and the
  // signup screen previously used different implementations, so the same pair
  // of names could pass in one place and fail in the other.
  function partialWordsMatch(a, b) {
    return namesMatch(a, b);
  }

  








// function checkBankDetails(accountNo, IFSC_Code) {
//   setIsLoadingIfSC(true);
//   setIsLoadingAccount(true);

//   const postBody = {
//     id_number: accountNo,
//     ifsc: IFSC_Code,
//   };

//   getAccountDetails(postBody)
//     .then((res) => {
//       setIsLoadingIfSC(false);
//       setIsLoadingAccount(false);
//       console.log("getAccountDetails", res.data);

//       if (res?.data?.data?.account_exists) {
//         const holderName = res.data.data.full_name;
//         const holderNameNormalized = normalizeName(holderName);

//         const gstBusinessName = normalizeName(cpDetails?.gstObject?.business_name);
//         const reraAgentName = normalizeName(
//           cpDetails?.reraExtracted?.agentName ||
//           cpDetails?.reraObject?.details?.[0]?.agent_name
//         );
//         const proprietorshipName = normalizeName(cpDetails?.proprietorshipName);

//         let isValid = false;

//         if (cpDetails?.gstApplicable === true || cpDetails?.gstApplicable === "true") {
//           // ✅ GST applicable – allow partial match with GST or RERA
//           const matchesGST =
//             gstBusinessName &&
//             (holderNameNormalized.includes(gstBusinessName) ||
//               gstBusinessName.includes(holderNameNormalized) ||
//               wordsMatch(holderNameNormalized, gstBusinessName) ||
//               partialWordsMatch(holderNameNormalized, gstBusinessName));

//           const matchesRERA =
//             reraAgentName &&
//             (holderNameNormalized.includes(reraAgentName) ||
//               reraAgentName.includes(holderNameNormalized) ||
//               wordsMatch(holderNameNormalized, reraAgentName) ||
//               partialWordsMatch(holderNameNormalized, reraAgentName));

//           isValid = matchesGST || matchesRERA;
//         } else {
//           // ✅ GST not applicable – match with RERA first, then Proprietorship
//           let matchesRera =
//             reraAgentName &&
//             (holderNameNormalized.includes(reraAgentName) ||
//               reraAgentName.includes(holderNameNormalized) ||
//               wordsMatch(holderNameNormalized, reraAgentName) ||
//               partialWordsMatch(holderNameNormalized, reraAgentName));

//           let matchesProp = false;

//           if (!matchesRera) {
//             if (proprietorshipName) {
//               matchesProp =
//                 holderNameNormalized.includes(proprietorshipName) ||
//                 proprietorshipName.includes(holderNameNormalized) ||
//                 wordsMatch(holderNameNormalized, proprietorshipName) ||
//                 partialWordsMatch(holderNameNormalized, proprietorshipName);
//             } else {
//               // No proprietorship name — ask for firm name
//               setAskFirmNameDialog(true);
//               // Store holder name so we can check after dialog confirm
//               setBankDetails((pre) => ({
//                 ...pre,
//                 holderName: holderName,
//                 accountNumber: postBody.id_number,
//                 ifscCode: postBody.ifsc,
//                 branchName: profileData?.bankBranchName,
//               }));
//               return; // Stop verification here, will continue in dialog confirm
//             }
//           }

//           isValid = matchesRera || matchesProp;
//         }

//         setBankDetails((pre) => ({
//           ...pre,
//           holderName: res.data.data.full_name,
//           accountNumber: postBody.id_number,
//           ifscCode: postBody.ifsc,
//           branchName: profileData?.bankBranchName,
//         }));

//         console.log("Normalized Holder Name:", holderNameNormalized);
//         console.log("GST Business Name:", gstBusinessName);
//         console.log("RERA Agent Name:", reraAgentName);
//         console.log("Proprietorship Name:", proprietorshipName);

//         if (isValid) {
//           setHelperText((pre) => ({
//             ...pre,
//             isHolderName: "",
//             isAccountNumber: "",
//             isIfscCode: "",
//             bankDetailsIsVerified: true,
//           }));
//         } else {
//           setHelperText((pre) => ({
//             ...pre,
//             isHolderName: cpDetails?.gstApplicable
//               ? "Account holder name doesn't match GST Business Name or RERA Name."
//               : "Account holder name doesn't match RERA or Proprietorship Name.",
//             bankDetailsIsVerified: false,
//           }));
//         }
//       } else {
//         setHelperText((pre) => ({
//           ...pre,
//           isAccountNumber: "Something went wrong",
//           isIfscCode: "Something went wrong",
//           bankDetailsIsVerified: false,
//         }));
//       }
//     })
//     .catch((err) => {
//       setIsLoadingIfSC(false);
//       setIsLoadingAccount(false);
//       console.error("Error:", err);

//       const errorCode = err?.response?.data?.message_code || "Verification failed";

//       setHelperText((pre) => ({
//         ...pre,
//         isAccountNumber: errorCode.includes("invalid_ifsc") ? "" : errorCode,
//         isIfscCode: errorCode.includes("invalid_ifsc") ? errorCode : "",
//         bankDetailsIsVerified: false,
//       }));
//     });
// }



function checkBankDetails(accountNo, IFSC_Code) {
  setIsLoadingIfSC(true);
  setIsLoadingAccount(true);

  const postBody = {
    id_number: accountNo,
    ifsc: IFSC_Code,
    ifsc_details: true,
  };


  getAccountDetails(postBody)
    .then((res) => {
      setIsLoadingIfSC(false);
      setIsLoadingAccount(false);
      console.log("getAccountDetails", res.data);

      if (res?.data?.data?.account_exists) {
        const holderName = res.data.data.full_name;
        const holderNameNormalized = normalizeName(holderName);

        const gstBusinessName = normalizeName(cpDetails?.gstObject?.business_name);
        const reraAgentName = normalizeName(
          cpDetails?.reraExtracted?.agentName ||
          cpDetails?.reraObject?.details?.[0]?.agent_name
        );
        const proprietorshipName = normalizeName(cpDetails?.proprietorshipName);

        let isValid = false;

        if (cpDetails?.gstApplicable === true || cpDetails?.gstApplicable === "true") {
          // ✅ GST applicable – allow partial match with GST or RERA
          const matchesGST =
            gstBusinessName &&
            (holderNameNormalized.includes(gstBusinessName) ||
              gstBusinessName.includes(holderNameNormalized) ||
              wordsMatch(holderNameNormalized, gstBusinessName) ||
              partialWordsMatch(holderNameNormalized, gstBusinessName));

          const matchesRERA =
            reraAgentName &&
            (holderNameNormalized.includes(reraAgentName) ||
              reraAgentName.includes(holderNameNormalized) ||
              wordsMatch(holderNameNormalized, reraAgentName) ||
              partialWordsMatch(holderNameNormalized, reraAgentName));

          isValid = matchesGST || matchesRERA;
        } else {
          // ✅ GST not applicable – match with RERA first, then Proprietorship
          let matchesRera =
            reraAgentName &&
            (holderNameNormalized.includes(reraAgentName) ||
              reraAgentName.includes(holderNameNormalized) ||
              wordsMatch(holderNameNormalized, reraAgentName) ||
              partialWordsMatch(holderNameNormalized, reraAgentName));

          let matchesProp = false;

          if (!matchesRera) {
            if (proprietorshipName) {
              matchesProp =
                holderNameNormalized.includes(proprietorshipName) ||
                proprietorshipName.includes(holderNameNormalized) ||
                wordsMatch(holderNameNormalized, proprietorshipName) ||
                partialWordsMatch(holderNameNormalized, proprietorshipName);
            } else {
              // No proprietorship name — ask for firm name
              setAskFirmNameDialog(true);

              // ✅ Stop loading before returning
              setIsLoadingIfSC(false);
              setIsLoadingAccount(false);

              // ✅ Clear IFSC/account helper text so UI doesn't show "verifying"
              setHelperText((pre) => ({
                ...pre,
                isIfscCode: "",
                isAccountNumber: "",
                isHolderName: "",
              }));

              // Store holder name so we can check after dialog confirm
              setBankDetails((pre) => ({
                ...pre,
                holderName: holderName,
                accountNumber: postBody.id_number,
                ifscCode: postBody.ifsc,
                branchName: profileData?.bankBranchName,
                bankName: res.data.data.ifsc_details?.bank_name || "",
              }));

              return; // Stop verification here, will continue in dialog confirm
            }
          }

          isValid = matchesRera || matchesProp;
        }

        setBankDetails((pre) => ({
          ...pre,
          holderName: res.data.data.full_name,
          accountNumber: postBody.id_number,
          ifscCode: postBody.ifsc,
          branchName: profileData?.bankBranchName,
          bankName: res.data.data.ifsc_details?.bank_name || "",
        }));

        // Bank API is the source of truth for the account holder's name --
        // whatever it returns replaces whatever was on file, even if different.
        setProfileData((pre) => ({
          ...pre,
          bankAccountHolderName: res.data.data.full_name,
        }));

        console.log("Normalized Holder Name:", holderNameNormalized);
        console.log("GST Business Name:", gstBusinessName);
        console.log("RERA Agent Name:", reraAgentName);
        console.log("Proprietorship Name:", proprietorshipName);

        if (isValid) {
          // 🔍 Block if this bank account/IFSC already belongs to another CP
          checkBankDetailsExists(postBody.id_number, postBody.ifsc)
            .then((bankExistsResp) => {
              const existsForAnotherCP = bankExistsResp.some(
                (entry) => entry.cpId !== loggedInUser.user.cpId
              );
              if (existsForAnotherCP) {
                setHelperText((pre) => ({
                  ...pre,
                  isHolderName: "",
                  isAccountNumber: "Bank account details already exist",
                  isIfscCode: "",
                  bankDetailsIsVerified: false,
                }));
              } else {
                setHelperText((pre) => ({
                  ...pre,
                  isHolderName: "",
                  isAccountNumber: "",
                  isIfscCode: "",
                  bankDetailsIsVerified: true,
                }));
              }
            })
            .catch((err) => {
              console.error("checkBankDetailsExists", err);
              setHelperText((pre) => ({
                ...pre,
                isHolderName: "",
                isAccountNumber: "",
                isIfscCode: "",
                bankDetailsIsVerified: true,
              }));
            });
        } else {
          setHelperText((pre) => ({
            ...pre,
            isHolderName: cpDetails?.gstApplicable
              ? "Account holder name doesn't match GST Business Name or RERA Name."
              : "Account holder name doesn't match RERA or Proprietorship Name.",
                 isAccountNumber: "",   // ← clear any lingering "verifying..."
            isIfscCode: "",        // ← clear any lingering "verifying..."
            bankDetailsIsVerified: false,
          }));
        }
      } else {
        setHelperText((pre) => ({
          ...pre,
          isAccountNumber: "Something went wrong",
          isIfscCode: "Something went wrong",
          bankDetailsIsVerified: false,
        }));
      }
    })
    .catch((err) => {
      setIsLoadingIfSC(false);
      setIsLoadingAccount(false);
      console.error("Error:", err);

      const errorCode = err?.response?.data?.message_code || "Verification failed";

      setHelperText((pre) => ({
        ...pre,
        isAccountNumber: errorCode.includes("invalid_ifsc") ? "" : errorCode,
        isIfscCode: errorCode.includes("invalid_ifsc") ? errorCode : "",
        bankDetailsIsVerified: false,
      }));
    });
}



  const aadharCheck = useRef(
    debounce((e) => {
      // console.log(e);
      getAadharCardDetails(e)
        .then((res) => {
          setIsLoadingAadhar(false);
          checkForUniqueDocs(e)
            .then((resp) => {
              console.log(resp);
              console.log(resp.length > 0, resp.length);
              if (resp.length) {
                setHelperText((pre) => {
                  pre.aadharNumber = "User already exists";
                  pre.isAadharValid = false;
                  return { ...pre };
                });
              } else {
                setHelperText((pre) => {
                  pre.aadharNumber = "";
                  return { ...pre };
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
          console.log(res.data);
          if (res?.data?.message_code === "success") {
            setHelperText((pre) => {
              pre.isAadharValid = true;
              return { ...pre };
            });
            console.log("res.data.data.full_name", res.data.data.full_name);
            setGeneralDetail((pre) => {
              pre.aadharName = res.data.data.full_name;
              pre.aadharObject = res.data.data;
              return { ...pre };
            });
          }
        })
        .catch((err) => {
          setIsLoadingAadhar(false);
          console.log("err", err);
          // console.log(err?.response?.data);
          setHelperText((pre) => {
            pre.aadharNumber = err?.response?.data?.message;
            pre.isAadharValid = false;
            return { ...pre };
          });
        });
    }, 800)
  ).current;
  /* Other Functions */
  const getCPEDetails = useRef(
    debounce((e) => {
      console.log(e);
      if (e !== "") {
        Network.getStatus().then((resp) => {
          if (resp.connected) {
            getCpBillingName(e)
              .then((data) => {
                console.log(data);
                if (data.length !== 0) {
                  setGetCPEName(data);
                } else {
                  console.log("Hii");
                  setCPEDetails(null);
                  setGetCPEName([]);
                }
              })
              .catch((err) => {
                handleErrors(err, "getCpBillingName");
              });
          } else {
            offlineToast();
          }
        });
      } else {
        setCPEDetails(null);
        setGetCPEName([]);
      }
    }, 800)
  ).current;
  function setMessages() {
    setOpenConfirmation(false);
    if (loggedInUser.user.approvalStatus === "rejected") {
      setOpenConfirmation(true);
      setMessage(loggedInUser.user.rejectionReason);
      setMessageIcon(<RejectedIcon width={"4.8rem"} height={"4.8rem"} />);
      console.log(
        "loggedInUser.user.rejectionReason: ",
        loggedInUser.user.rejectionReason
      );
      setMessageStatus("Rejected");
    }
  }
  // const IsNumberBlackListed = debounce((e) => {
  //   console.log(e);
  //   checkPhoneNumberIsBlackListed(e)
  //     .then((resp) => {
  //       console.log(resp);
  //       if (resp.length > 0) {
  //         // setVerifiedPhoneNumber(false);
  //         setHelperText((pre) => {
  //           pre.isPhoneNumber = "This number has been blocked";
  //           return { ...pre };
  //         });
  //       } else {
  //         // setVerifiedPhoneNumber(true);
  //         setHelperText((pre) => {
  //           pre.isPhoneNumber = "";
  //           return { ...pre };
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, 800);
  function convertImageFileToWebpFile(file) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
        canvas.getContext("2d").drawImage(image, 0, 0);
        canvas.toBlob((blob) => {
          let myFile = new File([blob], "my-new-group-image.webp", {
            type: blob.type,
          });
          resolve(myFile);
        }, "image/webp");
      };
      image.crossOrigin = "anonymous";
      image.src = URL.createObjectURL(file);
    });
  }

  async function uploadProfileImgCP(name, file) {
    const { data, error } = await supabase.storage
      .from("cp")
      .upload(`${name}.webp`, file, { upsert: true });
    if (data) return data;
    else throw error;
  }
  async function uploadProfileImgFOS(name, file) {
    const { data, error } = await supabase.storage
      .from("fos")
      .upload(`${name}.webp`, file, { upsert: true });
    if (data) return data;
    else throw error;
  }
  async function updateProfileImageUrlFOS(id, url) {
    profileData.profileImgUrl = url;
    const { data, error } = await supabase
      .from("FOS")
      .update({ profileImgUrl: url })
      .eq("fosId", id);
    if (data) {
      dispatch(action.authLogin({ ...profileData, profileImgUrl: url }));
    } else throw error;
  }
  async function updateProfileImageUrlCP(id, url) {
    profileData.profileImgUrl = url;
    console.log(profileData);
    const { data, error } = await supabase
      .from("CpContactPerson")
      .update({ profileImgUrl: url })
      .eq("cpId", id);
    if (data) {
      dispatch(action.authLogin({ ...profileData, profileImgUrl: url }));
    } else throw error;
  }
  async function getNewCPEDetails(newcpId) {
    console.log(newcpId.value);
    const { data, error } = await supabase
      .from("CP")
      .select("*")
      .eq("cpId", newcpId.value);
    if (data) return data;
    else throw error;
  }
  async function updateNewCPEinFos(newcpId, oldCps) {
    const { data, error } = await supabase
      .from("FOS")
      .update({
        cpId: newcpId,
        previousCps: oldCps,
        approvalStatus: "resubmitted",
      })
      .eq("fosId", profileData.fosId);
    console.log({ data });
    if (data) return data;
    else throw error;
  }

  async function changeCPE(newcpId) {
    console.log(newcpId.value);
    let oldCpId = profileData.cpId;
    let newCpDetails;
    if (helperText.isPhoneNumber === "") {
      console.log({ newCpDetails });
      if (newcpId.value !== profileData.cpId && newcpId.value !== undefined) {
        let oldCps = [];
        if (profileData.previousCps !== null) {
          oldCps = [...profileData.previousCps];
        }
        if (profileData.cpId)
          // ! cpId may be null if directly unlinked from db
          oldCps.push(profileData.cpId);
        setProfileData((pre) => {
          pre.previousCps = oldCps;
          pre.cpId = newcpId.value;
          return { ...pre };
        });
        getNewCPEDetails(newcpId).then((newCPEDeatilResp) => {
          console.log({ newCPEDeatilResp });
          setProfileData((pre) => {
            pre.cpData = newCPEDeatilResp[0];
            return { ...pre };
          });
          updateNewCPEinFos(newcpId.value, oldCps)
            .then((resp) => {
              successTost("CPE Updated Successfully, wait for approval!");
              console.log("updated resp", resp);
              console.log({ profileData });

              dispatch(
                action.authLogin({
                  ...profileData,
                  cpData: newCPEDeatilResp[0],
                  previousCps: oldCps,
                  cpId: newcpId.value,
                  approvalStatus: "resubmitted",
                })
              );
              sendFOSLogs();
              sendFOSNotificationAdded();
              sendFOSNotificationLeft(oldCpId);
            })
            .catch((err) => {
              console.log("error while updating status", err);
            });
        });
      } else {
        // infoTost("Current CPE Selected, Please select new CPE to update!");
      }
      const newPhoneNumber2 = parseInt(newPhoneNumber.substring(1));
      console.log(oldPhoneNumber, newPhoneNumber);
      if (
        oldPhoneNumber !== newPhoneNumber2 &&
        newPhoneNumber !== undefined &&
        newPhoneNumber !== ""
      ) {
        if (helperText.onChangePhoneNumber && verifiedPhoneNumber.current) {
          updatePhoneNumber(newPhoneNumber2);
        } else {
          errorTost("Please Verify phone Number First");
        }
        if (newEmailId !== profileData.email && verifiedEmail.current) {
          updateFosEmail();
        } else {
          setEmailLabelText("");
        }
      } else {
        // "phone number are same"
        if (newEmailId !== profileData.email && verifiedEmail.current) {
          updateFosEmail();
        } else {
          setEmailLabelText("");
        }
        if (
          profileData?.bankAccountNumber !==
          loggedInUser?.user.bankAccountNumber
        ) {
          let obj = { ...profileData };
          delete obj.profileImgUrl;
          delete obj.email;
          delete obj.type;
          delete obj.billingName;
          delete obj.cpData;
          delete obj.isFlagged;
          console.log(obj);
          const { data, error } = await supabase
            .from("FOS")
            .update(obj)
            .eq("fosId", profileData.fosId);
          if (data) {
            console.log(data);
            successTost("Information updated successfully");
            dispatch(action.authLogin(profileData));
          } else {
            errorTost(error.message);
            console.log(error);
          }
        } else {
          infoTost("Nothing to update");
        }
      }
    }
  }

  //Fos update phone number query
  async function updatePhoneNumber(newPhoneNumber) {
    profileData.contactNumber = newPhoneNumber;
    verifiedPhoneNumber.current = false;
    setHelperText((pre) => {
      pre.onChangePhoneNumber = false;
      pre.disableContactNumber = false;
      return { ...pre };
    });
    const { data, error } = await supabase
      .from("FOS")
      .update({ contactNumber: newPhoneNumber })
      .eq("fosId", profileData.fosId);
    if (data) {
      console.log(data);
      deleteBlacklistedPhoneNumber(oldPhoneNumber);
      insertBlacklistedPhoneNumber(newPhoneNumber);
      successTost("Information updated Successfully");
      dispatch(
        action.authLogin({
          ...profileData,
          contactNumber: profileData.contactNumber,
        })
      );
    } else {
      errorTost(error.message);
      console.log(error);
    }
  }

  //update phone number for cp
  // function updatePhoneNumberOfCp() {
  //   console.log({ verifiedEmail });
  //   if (profileData.email !== newEmailId && verifiedEmail.current) {
  //     console.log("updating new email");
  //     toUpdateCpEmail();
  //   }
  //   if (helperText.isPhoneNumber === "") {
  //     const newPhoneNumber2 = parseInt(newPhoneNumber.substring(1));
  //     if (
  //       oldPhoneNumber !== newPhoneNumber2 &&
  //       newPhoneNumber !== undefined &&
  //       newPhoneNumber !== ""
  //     ) {
  //       if (verifiedPhoneNumber.current) {
  //         updateCpPhoneNumber(newPhoneNumber2);
  //       } else {
  //         errorTost("Please verify phone number first");
  //       }
  //     } else {
  //       infoTost("No information changed");
  //     }
  //   }
  // }
  // async function updateCpPhoneNumber(newPhoneNumber) {
  //   profileData.contactNumber = newPhoneNumber;
  //   const { data, error } = await supabase
  //     .from("CpContactPerson")
  //     .update({ contactNumber: newPhoneNumber })
  //     .eq("cpId", profileData.cpId);
  //   if (data) {
  //     console.log(data);
  //     verifiedPhoneNumber.current = false;
  //     setHelperText((pre) => {
  //       pre.onChangePhoneNumber = false;
  //       pre.disableContactNumber = false;
  //       return { ...pre };
  //     });
  //     setOtpTimer(false);
  //     // if (loggedInUser.user.approvalStatus === "approved") {
  //     successTost("Information Updated Successfully");
  //     deleteBlacklistedPhoneNumber(oldPhoneNumber);
  //     insertBlacklistedPhoneNumber(newPhoneNumber);
  //     // }
  //     dispatch(
  //       action.authLogin({
  //         ...profileData,
  //         contactNumber: profileData.contactNumber,
  //       })
  //     );
  //   } else {
  //     errorTost(error.message);
  //     console.log(error);
  //   }
  // }


async function updatePhoneNumberOfCp(opts = {}) {
  const { silent = false } = opts;
  let hasChanges = false;

  // ✅ Email change + verification
  if (profileData.email !== newEmailId) {
    if (verifiedEmail.current) {
      console.log("✅ Updating new email...");
      toUpdateCpEmail();
      hasChanges = true;
    } else {
      errorTost("Please verify email before submitting.");
      return false;
    }
  }

  // ✅ Phone number change + verification
  if (helperText.isPhoneNumber === "") {
    const newPhoneNumber2 = parseInt(newPhoneNumber.substring(1));
    if (
      oldPhoneNumber !== newPhoneNumber2 &&
      newPhoneNumber !== undefined &&
      newPhoneNumber !== ""
    ) {
      if (verifiedPhoneNumber.current) {
        await updateCpPhoneNumber(newPhoneNumber2);
        hasChanges = true;
      } else {
        errorTost("Please verify phone number before submitting.");
        return false;
      }
    }
  }

  // ❌ Nothing changed
  if (!hasChanges && !silent) {
    infoTost("No information changed.");
  }
  return true;
}



// Phone/email edits go through their own OTP-verified save (a separate DB
// write from the main "Save Changes" resubmit), but they're still part of
// the same Profile Update flow the CP is editing under -- so this folds the
// change into that same open cycle's CpLogs row instead of logging its own,
// exactly like the changedParts diff computed at resubmit close-out above.
// No open cycle (e.g. a first-time registration's own rejection -> edit,
// which was never admin-unlocked) logs the single field on its own instead.
function logProfileUpdateFieldChange(cpId, field, oldValue, newValue) {
  supabase
    .from("CpLogs")
    .select("cpLogId, note")
    .eq("cpId", cpId)
    .eq("cpStatus", "Profile Update")
    .not("note", "is", null)
    .order("created_at", { ascending: false })
    .limit(1)
    .then(({ data: openRows, error: openRowsError }) => {
      if (openRowsError) {
        console.error("Profile field-change log lookup failed", openRowsError);
        return;
      }
      const openRow = openRows?.[0];

      if (!openRow) {
        supabase
          .from("CpLogs")
          .insert([{
            cpId,
            cpStatus: "Profile Update",
            userId: null,
            message: `Profile updated by CP — ${field}: ${oldValue ?? "—"} → ${newValue ?? "—"}`,
          }])
          .then(({ error: insertError }) => {
            if (insertError) console.error("Profile field-change log failed", insertError);
          });
        return;
      }

      let parsed = {};
      try {
        parsed = JSON.parse(openRow.note) || {};
      } catch {
        parsed = {};
      }
      const applied = (Array.isArray(parsed.applied) ? parsed.applied : []).filter(
        (c) => c.field !== field
      );
      applied.push({ field, old: oldValue, new: newValue });

      supabase
        .from("CpLogs")
        .update({ note: JSON.stringify({ ...parsed, applied }) })
        .eq("cpLogId", openRow.cpLogId)
        .then(({ error: updateError }) => {
          if (updateError) console.error("Profile field-change log failed", updateError);
        });
    });
}

async function updateCpPhoneNumber(newPhoneNumber) {
  profileData.contactNumber = newPhoneNumber;

  const { data, error } = await supabase
    .from("CpContactPerson")
    .update({ contactNumber: newPhoneNumber })
    .eq("cpId", profileData.cpId);

  if (data) {
    console.log("✅ Phone number updated:", data);

    // Reset verification flags
    verifiedPhoneNumber.current = false;

    setHelperText((pre) => ({
      ...pre,
      onChangePhoneNumber: false,
      disableContactNumber: false,
    }));

    setOtpTimer(false);

    successTost("Phone number updated successfully");

    // Sync new login state
    dispatch(
      action.authLogin({
        ...profileData,
        contactNumber: profileData.contactNumber,
      })
    );

    // Folds into the same Profile Update cycle's log -- see
    // logProfileUpdateFieldChange above.
    logProfileUpdateFieldChange(profileData.cpId, "contactNumber", oldPhoneNumber, newPhoneNumber);

    // Handle blacklist logic
    deleteBlacklistedPhoneNumber(oldPhoneNumber);
    insertBlacklistedPhoneNumber(newPhoneNumber);
  } else {
    errorTost(error.message);
    console.error("❌ Error updating phone number:", error);
  }
}






  async function deleteBlacklistedPhoneNumber(oldNumber) {
    const { data, error } = await supabase
      .from("BlacklistNumbers")
      .delete()
      .eq("number", oldNumber);
    if (data) {
      console.log("deleted phone number from blacklist successfully");
    } else {
      errorTost(error.message);
      console.log(error);
    }
  }
  async function insertBlacklistedPhoneNumber(newPhoneNumber) {
    const { data, error } = await supabase.from("BlacklistNumbers").insert([
      {
        cpId: profileData?.cpId,
        number: newPhoneNumber,
        fosId: profileData?.fosId,
      },
    ]);
    if (data) {
      console.log(" phone number added to blacklist successfully");
    } else {
      errorTost(error.message);
      console.log(error);
    }
  }
  async function sendFOSLogs() {
    const { data, error } = await supabase.from("FosLogs").insert({
      fosId: profileData.fosId,
      fosStatus: "Changed CPE",
      cpContactPersonId: null,
    });
    if (data) console.log(data);
    else throw error;
  }

  async function sendFOSNotificationAdded() {
    const { data, error } = await supabase.from("FosNotifications").insert({
      fosId: profileData.fosId,
      action: "New FOS Added",
      cpId: profileData.cpId,
    });
    if (data) console.log(data);
    else throw error;
  }
  async function sendFOSNotificationLeft(oldCpId) {
    const { data, error } = await supabase.from("FosNotifications").insert({
      fosId: profileData.fosId,
      action: "FOS Left",
      cpId: oldCpId,
    });
    if (data) console.log(data);
    else throw error;
  }
  // -------------------------------------------------------------------------------
  const IsNumberBlackListed = useRef(
    debounce((e) => {
      console.log(e);
      checkPhoneNumberIsBlackListed(e)
        .then((resp) => {
          console.log(resp);
          verifiedPhoneNumber.current = false;
          // setVerifiedPhoneNumber(false);
          if (resp.length > 0) {
            setHelperText((pre) => {
              pre.isPhoneNumber = "This number is already in use!";
              // pre.isPhoneNumber = "This number has been blacklisted";
              return { ...pre };
            });
          } else {
            setHelperText((pre) => {
              pre.isPhoneNumber = "";
              pre.onChangePhoneNumber = true;
              return { ...pre };
            });
            // setVerifiedPhoneNumber(true);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }, 800)
  ).current;
  // function smsApiCall() {
  //   setResendButton(false);
  //   // const myTimeout = setTimeout(() => {
  //   //   setResendButton(true);
  //   // }, 180000);
  //   setState((pre) => {
  //     pre.otp1 = "";
  //     pre.otp2 = "";
  //     pre.otp3 = "";
  //     pre.otp4 = "";
  //     return { ...pre };
  //   });
  //   setShowOtp(true);
  //   let body = {
  //     number: newPhoneNumber,
  //     isInterNational: isInterNational,
  //   };
  //   console.log(body);

  //   sendOTPMessage(body)
  //     .then((resp) => {
  //       if (resp.data.success) {
  //         var bytes = CryptoJS.AES.decrypt(resp.data.otp, "hts secret key");
  //         var originalText = bytes.toString(CryptoJS.enc.Utf8);
  //         console.log("FOS Registration OTP", parseInt(originalText));
  //         setRecievedOtp(parseInt(originalText));
  //         // 900000 ;15 min
  //         const myTimeout = setTimeout(smsTimeOut, 900000);
  //       } else {
  //         if (resp?.data?.error?.ErrorMessage) {
  //           errorTost(resp?.data?.error?.ErrorMessage);
  //         } else {
  //           errorTost("Something went wrong");
  //         }
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       console.log(err.message);
  //     });
  // }

  function smsApiCall() {
  setResendButton(false);
  setState((pre) => {
    pre.otp1 = "";
    pre.otp2 = "";
    pre.otp3 = "";
    pre.otp4 = "";
    return { ...pre };
  });
  setShowOtp(true);

  let body = {
    number: newPhoneNumber,
    isInterNational: isInterNational,
  };
  console.log(body);

  sendOTPMessage(body)
    .then((resp) => {
      if (resp.data) {
        console.log("📦 Frontend received safeEncrypted:", resp.data.otp);

        // Step 1: Decode Base64 (OTP is Base64-encoded)
        const encryptedBase64 = resp.data.otp;
        const encrypted = atob(encryptedBase64);  // Decode base64
        console.log("🔒 Frontend ciphertext after atob:", encrypted);

        // Step 2: Decrypt with the same key
        var bytes = CryptoJS.AES.decrypt(encrypted, "hts secret key");
        var originalText = bytes.toString(CryptoJS.enc.Utf8);

        // If decryption fails
        if (!originalText) {
          console.error("Decryption failed! Key or ciphertext mismatch.");
          errorTost("OTP decryption failed, please try again.");
          return;
        }

        // Log the OTP and set it in the state
        console.log("FOS Registration OTP:", parseInt(originalText));
        setRecievedOtp(parseInt(originalText));

        // Set a 15-minute timeout to prevent resending OTP
        setTimeout(smsTimeOut, 900000);
      } else {
        // Handle case where OTP sending failed or data is missing
        if (resp?.data?.error?.ErrorMessage) {
          errorTost(resp?.data?.error?.ErrorMessage);
        } else {
          errorTost("Something went wrong");
        }
      }
    })
    .catch((err) => {
      console.error(err);
      errorTost("An error occurred while sending OTP.");
    });
}

  function smsTimeOut() {
    if (verifiedPhoneNumber.current === false) {
      setHelperText((pre) => {
        pre.isPhoneNumber = "Otp has expired.Please resend otp";
        return { ...pre };
      });
      verifiedPhoneNumber.current = false;
      setShowOtp(true);
      setResendButton(true);
      setOtpTimer(true);
      // setShowEmailOtp(false);
      setState((pre) => {
        pre.otp1 = "";
        pre.otp2 = "";
        pre.otp3 = "";
        pre.otp4 = "";
        return { ...pre };
      });
      setRecievedOtp(null);
    }
  }
  function optChange(value1, event) {
    event.preventDefault();
    setState((pre) => {
      pre[value1] = event.target.value;
      return Object.assign({}, pre);
    });
  }
  function submitOtp() {
    let finalValue = state.otp1 + state.otp2 + state.otp3 + state.otp4;
    console.log(finalValue, "recievedOtp", recievedOtp);
    if (finalValue == recievedOtp) {
      // setVerifiedPhoneNumber(true);
      verifiedPhoneNumber.current = true;
      setShowOtp(false);
      setOtpTimer(false);
      setHelperText((pre) => {
        pre.isPhoneNumber = "";
        return { ...pre };
      });
    } else {
      setState((pre) => {
        pre.otp1 = "";
        pre.otp2 = "";
        pre.otp3 = "";
        pre.otp4 = "";
        return { ...pre };
      });
      errorTost("OTP doesnt match.Please enter valid otp");
    }
  }
  const inputfocus = (elmnt) => {
    if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
      // const next = elmnt.target.tabIndex - 2;
      // if (next > -1) {
      //     // elmnt.target.form.elements[next].focus();
      //     if (elmnt.target.nextSibling)
      //         elmnt.target.nextSibling.focus();
      // }
    } else {
      console.log("next");
      // const next = elmnt.target.tabIndex + 1;
      const next = parseInt(elmnt.target.id.split("-")[1]) + 1;
      if (next < 5) {
        // elmnt.target.form.elements[next].focus();
        if (elmnt.target.nextSibling) elmnt.target.nextSibling.focus();
      }
    }
  };
  // -------------------------------------------------------------------
  //  -----------------------------------------------------------------------------------------------
  // !!Otp
  const checkEmailExists = useRef(
    debounce(async (e) => {
      console.log({ e });
      let emailExists = null;
      // emailExists=false;
      // setHelperText((pre)=>{
      //   pre.email='';
      //   return {...pre}
      // });
      // ??First checked in leads
      await checkLeadEmailExists(e)
        .then((emailCheckResp) => {
          console.log({ emailCheckResp });

          if (emailCheckResp.length > 0) {
            emailExists = true;
            console.log({ emailExists });
          } else {
            console.log({ emailExists });
            emailExists = false;
            setHelperText((pre) => {
              pre.email = "";
              return { ...pre };
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
      // ??Second Check in Users
      if (!emailExists) {
        await checkLeadEmailExistsInUsers(e)
          .then((responseInUser) => {
            if (responseInUser.length > 0) {
              emailExists = true;
              console.log({ emailExists });
            } else {
              emailExists = false;
              console.log({ emailExists });
            }
          })
          .catch((err) => {
            console.log(err.message);
          });
      }
      // ??Third Check in Cp
      if (!emailExists) {
        await checkLeadEmailExistsInCp(e).then((cpRespEmail) => {
          if (cpRespEmail.length > 0) {
            emailExists = true;
          } else {
            emailExists = false;
          }
          console.log({ emailExists });
        });
      }
      if (emailExists) {
        console.log({ emailExists });
        setHelperText((pre) => {
          pre.email = "Email Already exists";
          return { ...pre };
        });
        setEmailLabelText("");
      } else {
        setHelperText((pre) => {
          pre.email = "";
          return { ...pre };
        });
        setEmailLabelText("Send Otp");
      }
    }, 900)
  ).current;
  function sendOtpToVerifyEmail() {
    setHelperText((pre) => {
      pre.email = "";
      return { ...pre };
    });
    setShowEmailOtp(true);
    setOtpTimerEmail(true);
    setEmailLabelText("");
    let body = {
      email: newEmailId,
    };
    sendOTPMessageMail(body).then((resp) => {
      if (resp.data.success) {
        var bytes = CryptoJS.AES.decrypt(resp.data.otp, "hts secret key");
        var originalText = bytes.toString(CryptoJS.enc.Utf8);
        console.log("Email Registration OTP", parseInt(originalText));
        setRecievedEmailOtp(parseInt(originalText));
        // 900000 ;15 min
        const myTimeout = setTimeout(smsTimeOutForEmailVerify, 900000);
      } else {
        if (resp?.data?.error?.ErrorMessage) {
          errorTost(resp?.data?.error?.ErrorMessage);
        } else {
          errorTost("Something went wrong");
        }
      }
    });
  }
  function smsTimeOutForEmailVerify() {
    if (verifiedEmail === false) {
      setHelperText((pre) => {
        pre.email = "Otp has expired.Please resend otp";
        return { ...pre };
      });
      setEmailLabelText("Resend Otp");
      setOtpTimerEmail(false);
      // setVerifiedEmail(false);
      verifiedEmail.current = false;
    } else {
      setShowEmailOtp(true);
      setOtpTimerEmail(true);
      setEmailState((pre) => {
        pre.otp1 = "";
        pre.otp2 = "";
        pre.otp3 = "";
        pre.otp4 = "";
        return { ...pre };
      });
      setRecievedEmailOtp(null);
    }
  }
  // !!Email otp
  function optEmailChange(value1, event) {
    event.preventDefault();
    setEmailState((pre) => {
      pre[value1] = event.target.value;
      return Object.assign({}, pre);
    });
  }

  // !!For Email
  function submitEmailOtp() {
    let finalValue =
      emailState.otp1 + emailState.otp2 + emailState.otp3 + emailState.otp4;
    console.log(finalValue, "recievedEmailOtp", recievedEmailOtp);
    if (finalValue == recievedEmailOtp) {
      // setVerifiedEmail(true);
      verifiedEmail.current = true;
      setShowEmailOtp(false);
      setOtpTimerEmail(false);
      setEmailLabelText("");
      setEmailState((pre) => {
        pre.otp1 = "";
        pre.otp2 = "";
        pre.otp3 = "";
        pre.otp4 = "";
        return { ...pre };
      });
    } else {
      setEmailState((pre) => {
        pre.otp1 = "";
        pre.otp2 = "";
        pre.otp3 = "";
        pre.otp4 = "";
        return { ...pre };
      });
      errorTost("OTP doesnt match.Please enter valid otp");
    }
  }
  // -------------------------------------------------------------------------------
  function toUpdateCpEmail() {
    const UpdateAuthUser = authUpDateSignUp({ email: newEmailId });
    console.log("UpdateAuthUser -->", UpdateAuthUser);
    UpdateAuthUser.then((resp) => {
      console.log({ resp });
      if (resp.user) {
        setShowAlertForEmailUpdate(true);
        updateEmailCpTable();
        setEmailLabelText("");
        verifiedEmail.current = false;
      }
      if (resp?.error?.message) {
        errorTost(resp?.error?.message);
      }
    }).catch((error) => {
      console.log({ error });
    });
  }
  async function updateEmailCpTable() {
    const oldEmail = profileData.email;
    const { data, error } = await supabase
      .from("CpContactPerson")
      .update({ email: newEmailId })
      .eq("cpId", profileData.cpId);
    if (data) {
      console.log(data);
      verifiedEmail.current = false;
      dispatch(
        action.authLogin({
          ...profileData,
          email: newEmailId,
        })
      );

      // Folds into the same Profile Update cycle's log -- see
      // logProfileUpdateFieldChange above.
      logProfileUpdateFieldChange(profileData.cpId, "email", oldEmail, newEmailId);
    } else {
      errorTost(error.message);
      console.log(error);
    }
  }
  function updateFosEmail() {
    const UpdateAuthUser = authUpDateSignUp({ email: newEmailId });
    console.log("UpdateAuthUser -->", UpdateAuthUser);
    UpdateAuthUser.then((resp) => {
      console.log({ resp });
      if (resp.user) {
        setShowAlertForEmailUpdate(true);
        updateEmailFosTable();
        verifiedEmail.current = false;
        setEmailLabelText("");
      }
      if (resp?.error?.message) {
        errorTost(resp?.error?.message);
      }
    }).catch((error) => {
      console.log({ error });
    });
  }
  async function updateEmailFosTable() {
    const { data, error } = await supabase
      .from("FOS")
      .update({ email: newEmailId })
      // .eq("cpId", profileData.cpId)
      .eq("fosId", profileData.fosId);
    if (data) {
      console.log(data);
      verifiedPhoneNumber.current = false;
      setHelperText((pre) => {
        pre.onChangePhoneNumber = false;
        pre.disableContactNumber = false;
        return { ...pre };
      });
      dispatch(
        action.authLogin({
          ...profileData,
          email: newEmailId,
        })
      );
    } else {
      errorTost(error.message);
      console.log(error);
    }
  }
  function logoutUser() {
    signOut()
      .then(({ err }) => {
        if (err) {
          errorTost(err);
        } else {
          store.dispatch(action.authLogout());
          navigate("/");
        }
      })
      .catch((error) => {
        errorTost(error);
      });
  }

// ✅ Add this helper anywhere above your component return (e.g., near other helpers)
const validateCertificateFormat = (text) => {
  if (!text) return false;

  /**
   * COMMON mandatory identifiers (must exist in ALL formats)
   */
  const commonPatterns = [
    /REGISTRATION\s+CERTIFICATE\s+OF\s+REAL\s+ESTATE\s+AGENT/i,
    /FORM\s*['"‘’]?\s*H\s*['"‘’]?/i,
    /Maharashtra\s+Real\s+Estate\s+Regulatory\s+Authority/i,
    /This\s+registration\s+is\s+granted/i
  ];

  /**
   * Signature line variants
   */
  const signaturePatterns = [
    /Signature\s+and\s+seal\s+of\s+the\s+Authorized\s+Officer/i,
    /Signature\s+and\s+seal\s+of\s+Secretary,?\s*Maha\s?RERA/i,
    /Digitally\s+Signed\s+By[\s\S]{0,150}?Secretary,?\s*Maha\s?RERA/i,
    /Digitally\s+Signed\s+By[\s\S]{0,150}?Authorized\s+Officer/i
  ];

  /**
   * Certificate number variants
   * A + 11 or 12 digits (both seen in real certificates)
   */
  const certNoOk = /A\d{11,12}/i.test(text);

  /**
   * Validity line variants
   */
  const validityPatterns = [
    /commencing\s+from\s+\d{2}\/\d{2}\/\d{4}\s+and\s+ending\s+with\s+\d{2}\/\d{2}\/\d{4}/i,
    /valid\s+for\s+a\s+period\s+of\s+.*commencing\s+from\s+\d{2}\/\d{2}\/\d{4}\s+and\s+ending\s+with\s+\d{2}\/\d{2}\/\d{4}/i
  ];

  const hasCommon = commonPatterns.every(rx => rx.test(text));
  const hasSignature = signaturePatterns.some(rx => rx.test(text));
  const hasValidity = validityPatterns.some(rx => rx.test(text));

  return hasCommon && hasSignature && certNoOk && hasValidity;
};



  return (
    <div className={cssClasses.mainWrapper}>









<ReraUploadModal
  open={showUpload}
  onClose={() => setShowUpload(false)}
  onExtractData={async (text) => {

// 🔒 Strict format validation for MahaRERA Agent Certificate (Form 'H')
if (!validateCertificateFormat(text)) {
  console.warn("❌ RERA certificate format check failed. Extracted text:", text);
  setHelperText((pre) => ({
    ...pre,
    reraVerified: false,
    reraNumber:
      "Invalid RERA certificate format. Please upload the official MahaRERA Agent Registration Certificate.",
  }));
  errorTost("Uploaded PDF doesn't match the expected RERA certificate format (Form 'H').");
  setIsReraLoading(false);
  return;
}


    const parsed = parseCertificateText(text);

    // ⛔ Start and End date check
    if (!parsed.startDate || !parsed.endDate) {
      setHelperText((pre) => ({
        ...pre,
        reraVerified: false,
        reraNumber: "Start/End date missing in certificate.",
      }));
      setShowUpload(true);
      return;
    }

    const agentName = parsed.agentName || cpDetails?.reraObject?.details?.[0]?.agent_name || "";
    const certificateNumberFromAPI = cpDetails?.reraObject?.details?.[0]?.certificate_number || "";
    const reraDetailsArray = cpDetails?.reraObject?.details || [];
    const cpType = parsed.cpType || "Individual";

    // ✅ Extract certificate number from PDF
// ✅ Extract certificate number from PDF (supports old + new)
const certificateRegex = /A\d{11,12}/i;
const match = text.match(certificateRegex);
const extractedCertNumber = match ? match[0].trim().toUpperCase() : "";


    const inputCertNumber = generalDetail.reraNumber?.trim().toUpperCase() || "";

    console.log("📜 Extracted Certificate No:", extractedCertNumber);
    console.log("🖊️ Input Certificate No:", inputCertNumber);

    // ❌ Validate extracted certificate number
    if (!extractedCertNumber || inputCertNumber !== extractedCertNumber) {
      setHelperText((pre) => ({
        ...pre,
        reraVerified: false,
        reraNumber: "Certificate number mismatch! Please check input or uploaded PDF.",
      }));
      errorTost("RERA Certificate number does not match the entered number.");
      return;
    }

    // ✅ Set basic extracted data
    setReraStartDate(parsed.startDate);
    setReraEndDate(parsed.endDate);
    setIsReraLoading(false);

    setCpDetails((prev) => ({
      ...prev,
      reraExtracted: {
        agentName,
        typeOfAgent: parsed.typeOfAgent,
        startDate: parsed.startDate,
        endDate: parsed.endDate,
        cpType,
      },
      cpType,
    }));

    setGeneralDetail((prev) => ({
      ...prev,
      reraName: agentName,
      reraStartDate: parsed.startDate,
      reraEndDate: parsed.endDate,
      reraObject: {
        certificate_number: extractedCertNumber,
        details: reraDetailsArray,
      },
    }));

    setHelperText((pre) => ({
      ...pre,
      reraVerified: true,
      reraNumber: "",
    }));

    // ✅ Normalize names
    const normalizeName = (name) =>
      name
        ?.replace(/PVT\.?\s*LTD\.?/gi, "PRIVATE LIMITED")
        ?.replace(/[.,]/g, "")
        ?.replace(/\s+/g, " ")
        ?.trim()
        ?.toUpperCase();

    const gstApplicable = cpDetails?.gstApplicable;

    const agentNameRERA = normalizeName(agentName);
    const gstBusinessName = normalizeName(cpDetails?.gstObject?.business_name);
    const gstLegalName = normalizeName(cpDetails?.gstObject?.legal_name);
    const panName = normalizeName(cpDetails?.panObject?.full_name);

    console.log("📤 Normalized Names:");
    console.log("🔹 RERA Agent Name:", agentNameRERA);
    console.log("🔹 GST Business Name:", gstBusinessName);
    console.log("🔹 GST Legal Name:", gstLegalName);
    console.log("🔹 PAN Name:", panName);

    // ✅ Name matching logic (same as existing auto-verify flow)
    const nameMatches = gstApplicable
      ? isPartialMatch(agentNameRERA, gstBusinessName) ||
        isPartialMatch(agentNameRERA, gstLegalName)
      : !!panName &&
        !!agentNameRERA &&
        (panName === agentNameRERA ||
          agentNameRERA.includes(panName) ||
          panName.includes(agentNameRERA));

    if (nameMatches) {
      setCpDetails((prev) => ({
        ...prev,
        billingName: agentNameRERA,
      }));
      setHelperText((pre) => ({
        ...pre,
        isBillingName: "",
      }));
      setShowProprietorshipDialog(false);
    } else {
      setLedgerName(agentNameRERA);
      setMessage(
        gstApplicable
          ? "RERA Name does not match GST Business/Legal Name. Is this a Proprietorship?"
          : "RERA Name does not fully match PAN Name. Is this a Proprietorship?"
      );
      setShowProprietorshipDialog(true);
    }

    // ✅ Close modal after successful processing
    setShowUpload(false);

    // ✅ Save to Supabase
    // try {
    //   if (agentName) {
    //     await addRera(loggedInUser.user.cpId, {
    //       ...generalDetail,
    //       reraName: agentName,
    //       reraStartDate: parsed.startDate,
    //       reraEndDate: parsed.endDate,
    //       reraObject: {
    //         certificate_number: extractedCertNumber,
    //         details: reraDetailsArray,
    //       },
    //     });
    //     console.log("✅ RERA details saved to Supabase.");
    //     setShowUpload(false); // ✅ Auto-close modal after success
    //   } else {
    //     console.warn("⚠️ Agent name missing; skipping addRera.");
    //   }
    // } catch (err) {
    //   console.error("❌ RERA update to Supabase failed:", err);
    //   errorTost("RERA Update failed");
    // }
  }}
/>




<Dialog
  open={showProprietorshipDialog}
  disableEscapeKeyDown
  maxWidth="md"        // ⬅ increase width (xs | sm | md | lg)
  fullWidth            // ⬅ takes full available width
  onClose={(event, reason) => {
    if (reason === "backdropClick") return;
    setShowProprietorshipDialog(false);
  }}
  PaperProps={{
    sx: {
      borderRadius: 3,
      padding: 1,
    },
  }}
>
  <DialogTitle
    sx={{
      fontSize: "2.4rem",
      fontWeight: 600,
      textAlign: "center",
    }}
  >
    Proprietorship Confirmation
  </DialogTitle>

  <DialogContent
    sx={{
      paddingX: 3,
      paddingY: 2,
    }}
  >
    <DialogContentText
      sx={{
        fontSize: "1.6rem",
        lineHeight: 1.6,
        textAlign: "center",
      }}
    >
      RERA Name does not match with PAN Name.
      <br />
      Is this a <b>Proprietorship</b>?
    </DialogContentText>
  </DialogContent>

  <DialogActions
    sx={{
      justifyContent: "end",
      gap: 2,
      paddingBottom: 2,
    }}
  >
    <MUIButton
      variant="contained"
      size="large"
      onClick={() => {
        setShowProprietorshipDialog(false);
        setAskFirmNameDialog(true);
      }}
    >
      Yes
    </MUIButton>

    <MUIButton
      variant="contained"
      size="large"
      color="error"
      onClick={() => {
        setShowProprietorshipDialog(false);
        setHelperText((pre) => ({
          ...pre,
          isBillingName: "RERA Name does not match PAN Name",
        }));
      }}
    >
      No
    </MUIButton>
  </DialogActions>
</Dialog>




      <AskFirmNameDialog
        open={askFirmNameDialog}
        onClose={handleFirmDialogClose}
        onConfirm={handleFirmDialogConfirm}
      />
       <FullScreenLoader open={isReraLoading} message="RERA verifying..." />
      <ConfirmationAlert
        open={openConfirmation}
        close={() => {
          setOpenConfirmation(false);
        }}
        icon={messageIcon}
        title={messageStatus}
        subTitle={message}
        confirm={(value) => {
          console.log(value);
        }}
        buttonTitle={"Cancel"}
      />
      <div className={cssClasses.profileGeneralDetailsWrapper}>
        <div className={cssClasses.profileImageWrapper}>
          <img
            src={
              profileData.profileImgUrl
                ? process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                  profileData.profileImgUrl +
                  `?${Date.now()}`
                : Avatar
            }
            alt=""
            id="profilePhoto"
            className={cssClasses.profileImage}
          />
          <img
            src={Camera}
            className={cssClasses.camera}
            alt=""
            onClick={() => {
              document.getElementById("imgupload").click();
            }}
          />
          <input
            hidden
            type="file"
            accept="image/jpeg, image/png, image/svg, image/webp, image/gif"
            id="imgupload"
            name=""
            onChange={(e) => {
              const img = new Image();
              img.src = URL.createObjectURL(e.target.files[0]);
              let cond = ["jpeg", "png", "svg", "webp", "gif", "jpg"];
              if (!cond.includes(e.target.value.split(".")[1])) {
                setHelperText({
                  ...helperText,
                  profileImg: "Select jpeg, png, svg, webp, gif images only.",
                });
                errorTost("Select jpeg, png, svg, webp, gif images only.");
              }
              console.log(img.src);
              img.onload = () => {
                if (img.height > 400 || img.width > 400) {
                  setHelperText({
                    ...helperText,
                    profileImg: "Select Smaller Image",
                  });
                  errorTost(
                    "Accepted size is 400px * 400px. Please try again with smaller image"
                  );
                } else {
                  convertImageFileToWebpFile(e.target.files[0]).then((file) => {
                    let oldProfileUrl = profileData.profileImgUrl;
                    profileData.type === "CP"
                      ? uploadProfileImgCP(loggedInUser.user.cpId, file).then(
                          (res) => {
                            console.log(res);
                            updateProfileImageUrlCP(
                              loggedInUser.user.cpId,
                              `cp/${loggedInUser.user.cpId}.webp`
                            );
                            oldProfileUrl === ""
                              ? successTost(
                                  "Profile Image uploaded successfully."
                                )
                              : successTost(
                                  "Profile Image updated successfully."
                                );
                          }
                        )
                      : uploadProfileImgFOS(loggedInUser.user.fosId, file).then(
                          (res) => {
                            console.log(res);
                            updateProfileImageUrlFOS(
                              loggedInUser.user.fosId,
                              `fos/${loggedInUser.user.fosId}.webp`
                            );
                            oldProfileUrl === ""
                              ? successTost(
                                  "Profile Image uploaded successfully."
                                )
                              : successTost(
                                  "Profile Image updated successfully."
                                );
                          }
                        );
                  });
                  setHelperText({
                    ...helperText,
                    profileImg: "",
                  });
                }
              };
            }}
          />
        </div>
        <div className={cssClasses.generalDetails}>
          <div className={cssClasses.name}>{profileData.name}</div>
          <div className={cssClasses.otherDetails}>
            <p>{`${profileData.email} | +${profileData.contactNumber}`}</p>
          </div>
          <div className={cssClasses.otherDetails}>
            <div className={cssClasses.chip}>
              {getUserStatusChip()}
              {profileData?.cpData?.approvalStatus === "rejected" ? (
                <p
                  className={cssClasses.otherDetails}
                  style={{ color: "red", marginTop: "1rem", fontSize: "2rem" }}
                >
                  Your CP has been rejected
                </p>
              ) : profileData?.cpData?.approvalStatus === "resubmitted" ? (
                <p
                  className={cssClasses.otherDetails}
                  style={{ color: "red", marginTop: "1rem", fontSize: "2rem" }}
                >
                  Your CP has been resubmitted
                </p>
              ) : profileData?.approvalStatus === "pending" ||
                profileData?.approvalStatus === "resubmitted" ? (
                <p
                  className={cssClasses.otherDetails}
                  style={{ color: "red", marginTop: "1rem", fontSize: "2rem" }}
                >
                  {profileData?.cpData
                    ? `Waiting for approval from CP ${profileData?.cpData?.billingName}`
                    : `Approval Pending`}
                </p>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={cssClasses.section}>
        <div>
          <p className={cssClasses.userDisplayID}>
            {profileData.type === "CP"
              ? `Welcome ${profileData.name}, your CP ID is CPID${profileData.cpDisplayId}`
              : `Welcome ${profileData.name}, your FOS ID is FOSID${profileData.fosDisplayId}`}
          </p>
        </div>
        <div className={cssClasses.content}>
          <p className={cssClasses.formHeading}>Personal Info</p>
          <div className={cssClasses.textFields}>
            {profileData.type === "CP" ? (
              profileData.isGSTApplicable ||
              loggedInUser.user.approvalStatus === "rejected" ? (
                <>
                  <div
                    className={`${cssClasses.inputFields} ${cssClasses.flexRowVstartHstart}`}
                  >
                    <div
                      className={`${cssClasses.inputField3} ${cssClasses.flexColHstartVstart}`}
                    >
                      <div
                        className={`${cssClasses.inputWithLabel1} ${cssClasses.flexColHstartVstart}`}
                      >
                        <p className={cssClasses.txt584}>PAN Number</p>
                        <div
                          className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
                        >
                          <div
                            className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}
                          >
                            {/* <CustomInput
                              value={generalDetail.panNumber}
                              // label={"PAN Number"}
                              // mandatory={true}
                              handleChange={(newValue) => {
                                newValue = newValue.trim().toUpperCase();
                                const regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;

                                // Update generalDetail
                                setGeneralDetail((prev) => ({
                                  ...prev,
                                  panNumber: newValue,
                                }));

                                if (newValue.length <= 10) {
                                  if (!regex.test(newValue)) {
                                    setHelperText((prev) => ({
                                      ...prev,
                                      panVerified: false,
                                      isPanValid:
                                        "Please enter Valid PAN number.",
                                    }));

                                    setCpDetails((prev) => ({
                                      ...prev,
                                      billingName: "",
                                    }));

                                    setBillingNameDisabled(false);
                                  } else {
                                    setHelperText((prev) => ({
                                      ...prev,
                                      isPanValid: "verifying...",
                                    }));

                                    if (newValue.length === 10) {
                                      setIsLoadingPan(true);
                                      PAN_CardCheck(newValue);
                                    }
                                  }

                                  setCpDetails((prev) => ({
                                    ...prev,
                                    panNumber: newValue,
                                  }));
                                }
                              }}
                              placeholder="Enter PAN Number"
                              inputType="label"
                              helperText={helperText.isPanValid}
                              isLoading={isLoadingPan}
                              greenTick={helperText.panVerified}
                            /> */}

<CustomInput
  value={generalDetail.panNumber}
  inputType="label"
  position="end"
  labelText={
    canEditProfile(profileData) && !helperText.panReVerifiedThisSession
      ? "Verify"
      : ""
  }
  disabled={true}
  greenTick={helperText.panReVerifiedThisSession}
  isLoading={isLoadingPan}
  placeholder="Enter PAN Number"
  helperText={helperText.isPanValid}
  handleChange={(newValue) => {
    newValue = newValue.trim().toUpperCase();
    const regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;

    setHelperText((prev) => ({
      ...prev,
      panVerified: false,
    }));

    setGeneralDetail((prev) => ({
      ...prev,
      panNumber: newValue,
    }));

    if (newValue.length <= 10) {
      if (!regex.test(newValue)) {
        setHelperText((prev) => ({
          ...prev,
          isPanValid: "Please enter Valid PAN number.",
        }));

        setCpDetails((prev) => ({
          ...prev,
          billingName: "",
        }));

        setBillingNameDisabled(false);
      } else {
        setHelperText((prev) => ({
          ...prev,
          isPanValid: "",
        }));
      }

      setCpDetails((prev) => ({
        ...prev,
        panNumber: newValue,
      }));
    }
  }}
  clicked={() => {
    if (!canEditProfile(profileData)) return;

    const regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
    if (!generalDetail.panNumber || !regex.test(generalDetail.panNumber)) {
      errorTost("Please enter a valid PAN number.");
      return;
    }

    setHelperText((prev) => ({
      ...prev,
      isPanValid: "verifying...",
    }));

    setIsLoadingPan(true);
    PAN_CardCheck(generalDetail.panNumber);
  }}
/>


                          </div>
                        </div>
                      </div>
                    </div>
                  

{/* {cpDetails.gstApplicable && (
  <div
    className={`${cssClasses.inputField3} ${cssClasses.flexColHstartVstart}`}
  >
    <div
      className={`${cssClasses.inputWithLabel1} ${cssClasses.flexColHstartVstart}`}
    >
      <p className={cssClasses.txt584}>GST Number</p>
      <div
        className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
      >
        <div
          className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}
        >
          <CustomInput
            value={cpDetails.gstNumber}
            inputType="label"
            position="end"
            labelText={
              canEditProfile(profileData) &&
              !helperText.gstNumberVerified
                ? "Verify"
                : ""
            }
            disabled={
              helperText.gstNumberVerified ||
              !canEditProfile(profileData)
            }
            greenTick={helperText.gstNumberVerified}
            isLoading={isGSTLoading}
            placeholder="Enter GST Number"
            helperText={helperText.isGstNumber}
            handleChange={(newValue) => {
              const validInput = /^[0-9A-Z]*$/;
              newValue = newValue.toUpperCase().trim();

              if (!validInput.test(newValue)) return;

              setCpDetails((pre) => ({
                ...pre,
                gstNumber: newValue,
              }));

              setHelperText((pre) => ({
                ...pre,
                gstNumberVerified: false,
                isGstNumber:
                  newValue === "" ? "Please Enter GST Number" : "",
              }));
            }}
            clicked={() => {
              if (!canEditProfile(profileData)) return;

              if (!cpDetails.billingName) {
                errorTost("Please verify your PAN number first");
                return;
              }
              if (!cpDetails.gstNumber) {
                errorTost("Please Enter GST Number");
                return;
              }

              setHelperText((pre) => ({
                ...pre,
                isGstNumber: "verifying...",
              }));
              setIsGSTLoading(true);
              gstInfoApiCall(cpDetails.gstNumber);
            }}
          />
        </div>
      </div>
    </div>
  </div>
)} */}
{(cpDetails.gstApplicable || activeGSTOptions.length > 1) && (
  <div className={`${cssClasses.inputField3} ${cssClasses.flexColHstartVstart}`}>
    <div className={`${cssClasses.inputWithLabel1} ${cssClasses.flexColHstartVstart}`}>
      <p className={cssClasses.txt584}>
        GST Number <span style={{ color: "red" }}>*</span>
      </p>

      {/* --- Multiple GST numbers case --- */}
      {activeGSTOptions?.length > 1 ? (
        <Dropdown
          list={activeGSTOptions.map((gst) => ({
            label: gst,
            value: gst,
          }))}
          placeHolder="Select GST Number"
          selectedValue={cpDetails.gstNumber}
          style={{ background: "#F2F4F7", color: "rgb(102, 112, 133)",width:100}}
          greenTick={helperText.gstNumberVerified}
          onChangeSelect={(selectedGST) => {
            // 1️⃣ Set GST number
            setCpDetails((pre) => ({
              ...pre,
              gstNumber: selectedGST,
            }));

            // 2️⃣ Reset verification
            setHelperText((pre) => ({
              ...pre,
              gstNumberVerified: false,
              isGstNumber: "verifying...",
            }));

            // 3️⃣ Require PAN first
            if (!cpDetails.billingName) {
              errorTost("Please verify your PAN number first");
              return;
            }

            // 4️⃣ Call GST API
            setIsGSTLoading(true);
            getGSTInfo(selectedGST)
              .then(async (res) => {
                setIsGSTLoading(false);

                const gstData = res.data.data;
                const extractedPANFromGST = selectedGST.substring(2, 12);
                const panFromCp = cpDetails?.panObject?.pan_number;

                if (extractedPANFromGST !== panFromCp) {
                  setHelperText((pre) => ({
                    ...pre,
                    isGstNumber: "PAN and GST Number do not match.",
                    gstNumberVerified: false,
                  }));
                  errorTost("PAN in GST doesn't match the provided PAN.");
                  return;
                }

                // 🔍 Block if this GST number already belongs to another CP
                try {
                  const gstExistsResp = await checkGSTNumberExists(selectedGST);
                  const existsForAnotherCP = gstExistsResp.some(
                    (entry) => entry.cpId !== loggedInUser.user.cpId
                  );
                  if (existsForAnotherCP) {
                    setHelperText((pre) => ({
                      ...pre,
                      isGstNumber: "GST number already exists",
                      gstNumberVerified: false,
                    }));
                    return;
                  }
                } catch (err) {
                  console.error("checkGSTNumberExists", err);
                }

                // ✅ Success
                setHelperText((pre) => ({
                  ...pre,
                  gstNumberVerified: true,
                  isGstNumber: "",
                }));

                setCpDetails((pre) => ({
                  ...pre,
                  gstObject: gstData,
                }));
              })
              .catch((err) => {
                setIsGSTLoading(false);
                setHelperText((pre) => ({
                  ...pre,
                  gstNumberVerified: false,
                  isGstNumber: err.message || "GST verification failed",
                }));
                errorTost(err.message);
              });
          }}
          helperText={helperText.isGstNumber}
        />
      ) : (
        // --- Single GST case ---
        <div
          className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
        >
          <div className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}>
            <CustomInput
              value={cpDetails.gstNumber}
              inputType="label"
              position="end"
              labelText={
                canEditProfile(profileData) &&
                !helperText.gstNumberVerified
                  ? "Verify"
                  : ""
              }
              disabled={
                helperText.gstNumberVerified ||
                !canEditProfile(profileData)
              }
              greenTick={helperText.gstNumberVerified}
              isLoading={isGSTLoading}
              placeholder="Enter GST Number"
              helperText={helperText.isGstNumber}
              handleChange={(newValue) => {
                const validInput = /^[0-9A-Z]*$/;
                newValue = newValue.toUpperCase().trim();

                if (!validInput.test(newValue)) return;

                setCpDetails((pre) => ({
                  ...pre,
                  gstNumber: newValue,
                }));

                setHelperText((pre) => ({
                  ...pre,
                  gstNumberVerified: false,
                  isGstNumber:
                    newValue === "" ? "Please Enter GST Number" : "",
                }));
              }}
              clicked={() => {
                if (!canEditProfile(profileData)) return;

                if (!cpDetails.billingName) {
                  errorTost("Please verify your PAN number first");
                  return;
                }
                if (!cpDetails.gstNumber) {
                  errorTost("Please Enter GST Number");
                  return;
                }

                setHelperText((pre) => ({
                  ...pre,
                  isGstNumber: "verifying...",
                }));
                setIsGSTLoading(true);
                gstInfoApiCall(cpDetails.gstNumber);
              }}
            />
          </div>
        </div>
      )}
    </div>
  </div>
)}


                  </div>
                </>
              ) : (
                <>
                  <div
                    className={`${cssClasses.inputField3} ${cssClasses.flexColHstartVstart}`}
                  >
                    <div
                      className={`${cssClasses.inputWithLabel1} ${cssClasses.flexColHstartVstart}`}
                    >
                      <div
                        className={`${cssClasses.inputWithLabel} ${cssClasses.flexColHstartVstart}`}
                      >
                        <p className={cssClasses.txt584}>Person Contact Name</p>
                        <div
                          className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
                        >
                          <div
                            className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}
                          >
                            <CustomInput
                              value={personName}
                              // mandatory={true}
                              handleChange={(newValue) => {
                                newValue = newValue.trimStart();
                                var alphabet = /^[A-Z*\sa-z]*$/;
                                if (
                                  newValue.match(alphabet) ||
                                  newValue === ""
                                ) {
                                  if (newValue.length <= 40) {
                                    setPersonName(newValue);
                                  }
                                }

                                if (newValue !== "") {
                                  setHelperText((pre) => {
                                    pre.isPersonName = "";
                                    return { ...pre };
                                  });
                                } else {
                                  setHelperText((pre) => {
                                    pre.isPersonName =
                                      "Please Enter Person Name";
                                    return { ...pre };
                                  });
                                }
                              }}
                              placeholder="Enter contact person name"
                              inputType="label"
                              helperText={helperText.isPersonName}
                              disabled={
                                !canEditProfile(loggedInUser.user)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`${cssClasses.inputWithLabel1} ${cssClasses.flexColHstartVstart}`}
                  >
                    <p className={cssClasses.txt584}>PAN Number</p>
                    <div
                      className={`${cssClasses.input5} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
                    >
                      <div
                        className={`${cssClasses.content2} ${cssClasses.flexRowVcenterHstart}`}
                      >
                        {/* <CustomInput
  value={panNumber}
  // label="PAN Number"
  // mandatory={true}
  inputType="label"
  placeholder="Enter PAN Number"
  position="end" // Show button on right inside input
  labelText="Verify" // Button text
  isLoading={isLoadingPan} // Show loader while verifying
  greenTick={helperText.isPanValid} // Show green tick if verified
  disabled={loggedInUser.user.approvalStatus !== "rejected"} // Enable input conditionally
  helperText={helperText.panNumber}
  handleChange={(newValue) => {
    newValue = newValue.trim().toUpperCase();
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    setPanNumber(newValue); // Update PAN state

    if (newValue === "") {
      setHelperText((pre) => ({
        ...pre,
        panNumber: "Please enter PAN number",
        isPanValid: false,
      }));
      return;
    }

    if (!panRegex.test(newValue)) {
      setHelperText((pre) => ({
        ...pre,
        panNumber: "Invalid PAN format (e.g., ABCDE1234F)",
        isPanValid: false,
      }));
      return;
    }

    // PAN format valid, clear error (verification on button click)
    setHelperText((pre) => ({
      ...pre,
      panNumber: "",
    }));
  }}
  clicked={() => {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    if (!panRegex.test(panNumber)) {
      setHelperText((pre) => ({
        ...pre,
        panNumber: "Invalid PAN format (e.g., ABCDE1234F)",
        isPanValid: false,
      }));
      return;
    }

    // Begin verification
    setHelperText((pre) => ({
      ...pre,
      panNumber: "verifying...",
    }));
    setIsLoadingPan(true);
    PAN_CardCheck(panNumber); // Call your PAN verification logic
  }}
/> */}

                        <CustomInput
                          value={generalDetail.panNumber}
                          handleChange={(newValue) => {
                            newValue = newValue.trim();
                            newValue = newValue.toUpperCase();
                            var regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;

                            if (!regex.test(newValue)) {
                              helperText.isPanValid = false;
                              helperText.panNumber =
                                "Please enter Valid PAN number.";
                              // setProfileData({ ...profileData, billingName: "" });
                            } else {
                              helperText.panNumber = "";

                              if (newValue.length === 10) {
                                // if(_isValid.flag) {
                                if (oldPan !== newValue) {
                                  setIsLoadingPan(true);
                                  PAN_CardCheck(newValue.toUpperCase());
                                } else {
                                  console.log(profileDataArr);
                                  setGeneralDetail({
                                    ...generalDetail,
                                    panNumber: oldPan,
                                  });
                                  setProfileData({
                                    ...profileData,
                                    billingName: profileDataArr.billingName,
                                  });
                                  setHelperText((pre) => {
                                    pre.bankAccountHolderName = "";
                                    pre.bankDetailsIsVerified = true;
                                    return { ...pre };
                                  });
                                }
                              }
                            }
                            if (newValue.length <= 10) {
                              setGeneralDetail((pre) => {
                                pre.panNumber = newValue;
                                return Object.assign({}, pre);
                              });
                            }
                          }}
                          helperText={helperText.panNumber}
                          isLoading={isLoadingPan}
                          greenTick={helperText.panReVerifiedThisSession}
                          inputType="label"
                          position="end"
                          labelText={
                            canEditProfile(loggedInUser.user) &&
                            !helperText.panReVerifiedThisSession
                              ? "Verify"
                              : ""
                          }
                          clicked={() => {
                            if (!canEditProfile(loggedInUser.user)) return;
                            // Re-checks the PAN already on file (not a new
                            // value -- the box stays non-editable) so a GST
                            // registered against it after the fact gets
                            // picked up, same as the GST-applicable branch's
                            // own Verify button already does.
                            setIsLoadingPan(true);
                            PAN_CardCheck(generalDetail.panNumber);
                          }}
                          disabled={true}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )
            ) : (
              <>
                <div
                  className={`${cssClasses.inputField3} ${cssClasses.flexColHstartVstart}`}
                >
                  <div
                    className={`${cssClasses.inputWithLabel1} ${cssClasses.flexColHstartVstart}`}
                  >
                    <div
                      className={`${cssClasses.inputWithLabel} ${cssClasses.flexColHstartVstart}`}
                    >
                      <p className={cssClasses.txt584}>PAN Number</p>
                      <div
                        className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
                      >
                        <div
                          className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}
                        >
                          {/* <CustomInput
  value={panNumber}
  // label="PAN Number"
  // mandatory={true}
  inputType="label"
  placeholder="Enter PAN Number"
  position="end" // Show button on right inside input
  labelText="Verify" // Button text
  isLoading={isLoadingPan} // Show loader while verifying
  greenTick={helperText.isPanValid} // Show green tick if verified
  disabled={loggedInUser.user.approvalStatus !== "rejected"} // Enable input conditionally
  helperText={helperText.panNumber}
  handleChange={(newValue) => {
    newValue = newValue.trim().toUpperCase();
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    setPanNumber(newValue); // Update PAN state

    if (newValue === "") {
      setHelperText((pre) => ({
        ...pre,
        panNumber: "Please enter PAN number",
        isPanValid: false,
      }));
      return;
    }

    if (!panRegex.test(newValue)) {
      setHelperText((pre) => ({
        ...pre,
        panNumber: "Invalid PAN format (e.g., ABCDE1234F)",
        isPanValid: false,
      }));
      return;
    }

    // PAN format valid, clear error (verification on button click)
    setHelperText((pre) => ({
      ...pre,
      panNumber: "",
    }));
  }}
  clicked={() => {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    if (!panRegex.test(panNumber)) {
      setHelperText((pre) => ({
        ...pre,
        panNumber: "Invalid PAN format (e.g., ABCDE1234F)",
        isPanValid: false,
      }));
      return;
    }

    // Begin verification
    setHelperText((pre) => ({
      ...pre,
      panNumber: "verifying...",
    }));
    setIsLoadingPan(true);
    PAN_CardCheck(panNumber); // Call your PAN verification logic
  }}
/> */}

                          <CustomInput
                            value={generalDetail.panNumber}
                            handleChange={(newValue) => {
                              newValue = newValue.trim();
                              newValue = newValue.toUpperCase();
                              var regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;

                              if (!regex.test(newValue)) {
                                helperText.isPanValid = false;
                                helperText.panNumber =
                                  "Please enter Valid PAN number.";
                                // setProfileData({
                                //   ...profileData,
                                //   billingName: "",
                                // });
                              } else {
                                helperText.panNumber = "";

                                if (newValue.length === 10) {
                                  // if(_isValid.flag) {
                                  if (oldPan !== newValue) {
                                    setIsLoadingPan(true);
                                    PAN_CardCheck(newValue.toUpperCase());
                                  } else {
                                    console.log(profileDataArr);
                                    setGeneralDetail({
                                      ...generalDetail,
                                      panNumber: oldPan,
                                    });
                                    setProfileData({
                                      ...profileData,
                                      billingName: profileDataArr.billingName,
                                    });
                                    setHelperText((pre) => {
                                      pre.bankAccountHolderName = "";
                                      pre.bankDetailsIsVerified = true;
                                      return { ...pre };
                                    });
                                  }
                                }
                              }
                              if (newValue.length <= 10) {
                                setGeneralDetail((pre) => {
                                  pre.panNumber = newValue;
                                  return Object.assign({}, pre);
                                });
                              }
                            }}
                            helperText={helperText.panNumber}
                            isLoading={isLoadingPan}
                            greenTick={helperText.panReVerifiedThisSession}
                            inputType="label"
                            position="end"
                            labelText={
                              canEditProfile(loggedInUser.user) &&
                              !helperText.panReVerifiedThisSession
                                ? "Verify"
                                : ""
                            }
                            clicked={() => {
                              if (!canEditProfile(loggedInUser.user)) return;
                              // Re-checks the PAN already on file (not a new
                              // value -- the box stays non-editable) so a GST
                              // registered against it after the fact gets
                              // picked up, same as the GST-applicable
                              // branch's own Verify button already does.
                              setIsLoadingPan(true);
                              PAN_CardCheck(generalDetail.panNumber);
                            }}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`${cssClasses.inputField3} ${cssClasses.flexColHstartVstart}`}
                >
                  <div
                    className={`${cssClasses.inputWithLabel1} ${cssClasses.flexColHstartVstart}`}
                  >
                    <div
                      className={`${cssClasses.inputWithLabel} ${cssClasses.flexColHstartVstart}`}
                    >
                      <p className={cssClasses.txt584}>Aadhar Number</p>
                      <div
                        className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
                      >
                        <div
                          className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}
                        >
                          <CustomInput
                            value={generalDetail.aadharNumber}
                            handleChange={(newValue) => {
                              newValue = newValue.trim();
                              newValue = newValue.toUpperCase();
                              var regex = /([0-9]){12}$/;

                              if (!regex.test(newValue)) {
                                helperText.isAadharValid = false;
                                helperText.aadharNumber =
                                  "Please enter Valid Aadhar number.";
                              } else {
                                helperText.aadharNumber = "";

                                if (newValue.length === 12) {
                                  // if(_isValid.flag) {
                                  setIsLoadingAadhar(true);
                                  aadharCheck(newValue);
                                }
                              }
                              if (newValue.length <= 12) {
                                setGeneralDetail((pre) => {
                                  pre.aadharNumber = newValue;
                                  return Object.assign({}, pre);
                                });
                              }
                            }}
                            helperText={helperText.aadharNumber}
                            isLoading={isLoadingAadhar}
                            inputType="label"
                            disabled={
                              !canEditProfile(loggedInUser.user)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`${cssClasses.inputFields} ${cssClasses.flexRowVstartHstart}`}
                >
                  <div
                    className={`${cssClasses.inputField} ${cssClasses.flexColHstartVstart}`}
                  >
                    <div
                      className={`${cssClasses.inputWithLabel} ${cssClasses.flexColHstartVstart}`}
                    >
                     <p className={cssClasses.txt584}>Bank Account Number</p>
                      <div
                        className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
                      >
                        <div
                          className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}
                        >
                          <CustomInput
                            value={profileData.bankAccountNumber}
                            // label={"Account Number"}
                            // mandatory={true}
                                 disabled={
                              !canEditProfile(loggedInUser.user)
                            }
                            handleChange={(newValue) => {
                              var numbers = /^[0-9]*$/;
                              if (newValue.match(numbers) || newValue === "") {
                                if (newValue.length <= 18) {
                                  setBankDetails((pre) => {
                                    return { ...pre, accountNumber: newValue };
                                  });
                                  if (bankDetails.ifscCode !== "") {
                                    helperText.bankDetailsIsVerified = false;
                                    helperText.isAccountNumber = "verifying...";
                                    debouncedBankDetailsCall();
                                  } else {
                                    helperText.bankDetailsIsVerified = false;
                                    helperText.isAccountNumber =
                                      "Please Enter Valid Ifsc code";
                                  }
                                }
                              }
                              if (newValue === "") {
                                helperText.isAccountNumber =
                                  "Please Enter Account Number";
                              } else {
                                helperText.isAccountNumber = "";
                              }
                            }}
                            placeholder="Account Number"
                            inputType="label"
                            isLoading={isLoadingAccount}
                            helperText={helperText.isAccountNumber}
                            greenTick={helperText.bankDetailsIsVerified}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`${cssClasses.inputField1} ${cssClasses.flexColHstartVstart}`}
                  >
                    <div
                      className={`${cssClasses.inputWithLabel} ${cssClasses.flexColHstartVstart}`}
                    >
                      <p className={cssClasses.txt584}>IFSC Code</p>
                      <div
                        className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
                      >
                        <div
                          className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}
                        >
                          <CustomInput
                            value={profileData.bankIFSCCode}
                            // label={"IFSC Code"}
                                 disabled={
                              !canEditProfile(loggedInUser.user)
                            }
                            
                          //  mandatory={true}
                            handleChange={(newValue) => {
                              let code = "^[A-Z]{4}0[A-Z0-9]{6}$";
                              newValue = newValue.trimStart();
                              if (newValue === "") {
                                helperText.isIfscCode =
                                  "Please Enter IFSC Code";
                              } else {
                                helperText.isIfscCode = "";
                              }
                              if (
                                newValue.length >= 0 &&
                                newValue.length <= 11
                              ) {
                                setBankDetails((pre) => {
                                  pre.ifscCode = newValue;
                                  return Object.assign({}, pre);
                                });
                                if (
                                  newValue.length === 11 &&
                                  newValue.match(code)
                                ) {
                                  helperText.isIfscCode = "verifying...";
                                  checkBankDetails(
                                    bankDetails.accountNumber,
                                    newValue
                                  );
                                } else {
                                  helperText.bankDetailsIsVerified = false;
                                  helperText.isIfscCode =
                                    "Please Enter Valid Ifsc code";
                                }
                              }
                            }}
                            placeholder="IFSC Code"
                            inputType="label"
                            isLoading={isLoadingIfSC}
                            helperText={helperText.isIfscCode}
                            greenTick={helperText.bankDetailsIsVerified}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`${cssClasses.inputFields} ${cssClasses.flexRowVstartHstart}`}
                >
                  <div
                    className={`${cssClasses.inputField} ${cssClasses.flexColHstartVstart}`}
                  >
                    <div
                      className={`${cssClasses.inputWithLabel} ${cssClasses.flexColHstartVstart}`}
                    >
                      <p className={cssClasses.txt584}>
                        Bank Account Holder Name
                      </p>
                      <div
                        className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
                      >
                        <div
                          className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}
                        >
                          {/* <CustomInput
                            value={profileData.holderName}
                            label={"Account Holder Name"}
                            mandatory={true}
                            handleChange={(newValue) => {
                              newValue = newValue.trimStart();
                              var alphabet = /^[A-Z*\sa-z]*$/;
                              if (newValue.match(alphabet) || newValue === "") {
                                if (newValue.length <= 40) {
                                  setBankDetails((pre) => {
                                    pre.holderName = newValue;
                                    return Object.assign({}, pre);
                                  });
                                }
                              }

                              // if (newValue === "") {
                              //   helperText.isHolderName = "Please Enter Holder Name";
                              // } else {
                              //   helperText.isHolderName = "";
                              // }
                            }}
                            placeholder="Account Holder Name"
                            inputType="label"
                            helperText={helperText.isHolderName}
                            disabled={true}
                          /> */}


                          <CustomInput
  value={profileData.bankAccountHolderName || ""} // ✅ bind to editable/verified value
  placeholder="Account Holder Name"
  inputType="label"
  helperText={helperText.isHolderName}
    disabled={
                              !canEditProfile(loggedInUser.user)
                            }
  handleChange={(newValue) => {
    newValue = newValue.trimStart();
    const alphabet = /^[A-Z*\sa-z]*$/;
    if (newValue.match(alphabet) || newValue === "") {
      if (newValue.length <= 40) {
        setBankDetails((pre) => ({
          ...pre,
          holderName: newValue,
        }));
      }
    }
  }}
/>

                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`${cssClasses.inputField1} ${cssClasses.flexColHstartVstart}`}
                  >
                    <div
                      className={`${cssClasses.inputWithLabel} ${cssClasses.flexColHstartVstart}`}
                    >
                      <p className={cssClasses.txt584}>Bank Branch</p>
                      <div
                        className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
                      >
                        <div
                          className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}
                        >
                          <CustomInput
                            value={profileData.bankBranchName}
                       
                            handleChange={(newValue) => {
                              // if (newValue === "") {
                              //   setHelperText({
                              //     ...helperText,
                              //     bankBranchName: "Please Enter Branch Name",
                              //   });
                              // } else {
                              //   setHelperText({
                              //     ...helperText,
                              //     bankBranchName: "",
                              //   });
                              // }
                              
                              setProfileData({
                                ...profileData,
                                bankBranchName: newValue,
                              });
                            }}
                            inputType="label"
                            disabled={!canEditProfile(loggedInUser.user)}
                            helperText={helperText.bankBranchName}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Fos Phone Number */}
                <div
                  className={`${cssClasses.inputField3} ${cssClasses.flexColHstartVstart}`}
                >
                  <div
                    className={`${cssClasses.inputWithLabel1} ${cssClasses.flexColHstartVstart}`}
                  >
                    <div
                      className={`${cssClasses.inputWithLabel} ${cssClasses.flexColHstartVstart}`}
                    >
                      <p className={cssClasses.txt584}>
                        Phone Number <span style={{ color: "red" }}> *</span>
                      </p>
                      <div
                        className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
                      >
                        <div
                          style={{ position: "relative", top: "0rem" }}
                          className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}
                        >
                          <PhoneInput
                            // style={{
                            //   width: '50%'
                            // }}
                            defaultCountry="IN"
                            value={
                              loggedInUser?.user?.contactNumber?.toString()
                                .length === 10
                                ? "+91" + loggedInUser.user.contactNumber
                                : "+" + loggedInUser.user.contactNumber
                            }
                            placeholder="Enter phone number"
                            disabled={
                              showOtp ||
                              resendButton ||
                              (!helperText.disableContactNumber &&
                              loggedInUser.user.approvalStatus !== "resubmitted"
                                ? false
                                : true)
                            }
                            onChange={(phone) => {
                              // console.log(phone);
                              if (phone !== undefined) {
                                // setVerifiedPhoneNumber(false);
                                if (phone.length >= 1) {
                                  if (isValidPhoneNumber(phone) === false) {
                                    // setVerifiedPhoneNumber(false);
                                    setHelperText((pre) => {
                                      pre.isPhoneNumber =
                                        "Please Enter valid Phone Number";
                                      return { ...pre };
                                    });
                                    // setShowOtp(false);
                                  } else {
                                    setHelperText((pre) => {
                                      pre.isPhoneNumber = "verifying...";
                                      return { ...pre };
                                    });
                                    const newPhoneNumber2 = parseInt(
                                      phone.substring(1)
                                    );
                                    console.log(
                                      oldPhoneNumber,
                                      newPhoneNumber2
                                    );
                                    if (oldPhoneNumber !== newPhoneNumber2) {
                                      IsNumberBlackListed(phone);
                                    } else {
                                      setHelperText((pre) => {
                                        pre.isPhoneNumber = "";
                                        return { ...pre };
                                      });
                                    }
                                    // if (
                                    //   personDetail.phoneNumber.substring(0, 3) === "+91"
                                    // ) {
                                    //   setIsInterNational(false);
                                    // } else {
                                    //   setIsInterNational(true);
                                    // }
                                  }
                                }
                              } else {
                                setHelperText((pre) => {
                                  pre.isPhoneNumber =
                                    "Please Enter  Phone Number";
                                  return { ...pre };
                                });

                                // setShowOtp(false);
                              }
                              console.log(phone);
                              setNewPhoneNumber(phone);
                            }}
                          />
                          {/* <p
                style={{ color: "red", fontSize: "1.4rem", lineHeight: "1.66" }}
              >
                {helperText.isPhoneNumber}
              </p> */}
                          {helperText.isPhoneNumber === "" &&
                            verifiedPhoneNumber.current === false &&
                            otptimer === false &&
                            showOtp === false &&
                            profileData.contactNumber !== "" &&
                            !helperText.disableContactNumber &&
                            helperText.onChangePhoneNumber && (
                              <div
                                className={cssClasses.verifyOtp}
                                onClick={() => {
                                  smsApiCall();
                                }}
                              >
                                Verify Otp
                              </div>
                            )}

                          {verifiedPhoneNumber.current === false &&
                            showOtp === true &&
                            resendButton === true && (
                              <div
                                className={cssClasses.verifyOtp}
                                onClick={() => {
                                  setHelperText((pre) => {
                                    pre.isPhoneNumber = "";
                                    return { ...pre };
                                  });
                                  if (resendButton) {
                                    smsApiCall();
                                    // successTost("Otp has been sent");
                                  } else {
                                    console.log("Please wait for 3 min");
                                  }
                                }}
                              >
                                Resend Otp
                              </div>
                            )}
                          {verifiedPhoneNumber.current === false &&
                            showOtp === true &&
                            resendButton === false && (
                              <div className={cssClasses.resendOtp}>
                                {" "}
                                Resend Otp in{" "}
                                {/* <Countdown date={startDate.current+ 180000} renderer={renderer} /> */}
                                <CountdownTimer
                                  startFrom={180}
                                  onComplete={() => {
                                    setResendButton(true);
                                  }}
                                  timeFormatter={(time) => {
                                    return (
                                      <span>
                                        {`0${Math.floor(time / 60)}`.slice(-2)}:
                                        {`0${time % 60}`.slice(-2)}
                                      </span>
                                    );
                                  }}
                                />
                              </div>
                            )}
                          {helperText.isPhoneNumber === "" &&
                            verifiedPhoneNumber.current === true &&
                            otptimer === false && (
                              <div className={cssClasses.verifyOtp}>
                                <CheckCircleSharpIcon
                                  style={{
                                    fontSize: "2.5rem",
                                    marginRight: "1rem",
                                  }}
                                  color={"success"}
                                />
                              </div>
                            )}
                          {showOtp && (
                            <div className={cssClasses.otpContainer}>
                              <input
                                className={cssClasses.otpInput}
                                name="otp1"
                                type="text"
                                autoComplete="off"
                                value={state.otp1}
                                // onKeyPress={keyPressed}
                                onChange={(e) => optChange("otp1", e)}
                                tabIndex="1"
                                maxLength="1"
                                onKeyUp={(e) => inputfocus(e)}
                                id="opt-0"
                              />
                              <input
                                name="otp2"
                                type="text"
                                autoComplete="off"
                                className={cssClasses.otpInput}
                                value={state.otp2}
                                onChange={(e) => optChange("otp2", e)}
                                tabIndex="2"
                                maxLength="1"
                                onKeyUp={(e) => inputfocus(e)}
                                id="opt-1"
                              />
                              <input
                                name="otp3"
                                type="text"
                                autoComplete="off"
                                className={cssClasses.otpInput}
                                value={state.otp3}
                                onChange={(e) => optChange("otp3", e)}
                                tabIndex="3"
                                maxLength="1"
                                onKeyUp={(e) => inputfocus(e)}
                                id="opt-2"
                              />
                              <input
                                name="otp4"
                                type="text"
                                autoComplete="off"
                                className={cssClasses.otpInput}
                                value={state.otp4}
                                onChange={(e) => optChange("otp4", e)}
                                tabIndex="4"
                                maxLength="1"
                                onKeyUp={(e) => inputfocus(e)}
                                id="opt-3"
                              />

                              <div>
                                <Button
                                  tabIndex={5}
                                  style={{
                                    color: "#ffffff",
                                    backgroundColor: "#155EEF",
                                    fontSize: "1.4rem",
                                    lineHeight: "2rem",
                                  }}
                                  btnName={"Submit OTP"}
                                  clicked={submitOtp}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <p
                        style={{
                          color: "red",
                          fontSize: "1.4rem",
                          lineHeight: "1.66",
                        }}
                      >
                        {helperText.isPhoneNumber}
                      </p>
                    </div>
                  </div>
                </div>
                {/* FOS Email */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    justifyContent: "space-between",
                    marginBottom: "3rem",
                  }}
                >
                  <div className={cssClasses.wrapperEmail}>
                    <div style={{ width: "100%", textAlign: "left" }}>
                      <CustomInput
                        value={newEmailId}
                        label={"Email"}
                        mandatory={true}
                        inputType={"label"}
                        position={"end"}
                        greenTick={verifiedEmail.current === true}
                        labelText={emailLabelText}
                        disabled={
                          showEmailOtp ||
                          helperText.disableEmail ||
                          profileData.approvalStatus !== "approved"
                        }
                        clicked={(e) => {
                          console.log(e);
                          if (e === "Send Otp") {
                            sendOtpToVerifyEmail(e);
                          } else if (e === "Resend Otp") {
                            sendOtpToVerifyEmail(e);
                          }
                        }}
                        handleChange={(newValue) => {
                          console.log({ newValue });
                          verifiedEmail.current = false;
                          setEmailLabelText("");
                          newValue = newValue.trimStart();
                          const emailIDCond = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                          if (!newValue.trim()) {
                            setEmailLabelText("");
                            helperText.email = "Please Enter Email Id";
                          } else if (!newValue.match(emailIDCond)) {
                            setEmailLabelText("");
                            helperText.email =
                              "Please Enter Email in Proper Format";
                          } else {
                            setEmailLabelText("");
                            helperText.email = "verifying...";
                            console.log(profileData.email, newValue);
                            if (
                              newValue !== "" &&
                              profileData.email !== newValue
                            ) {
                              setEmailLabelText("");
                              checkEmailExists(newValue);
                            } else if (newValue === "") {
                              console.log("hii");
                              setEmailLabelText("");
                            } else {
                              helperText.email = "";
                              setEmailLabelText("");
                            }
                          }
                          if (newValue.length <= 100) {
                            setEmailId(newValue);
                          }
                        }}
                        placeholder="Enter contact person Email"
                        helperText={helperText.email}
                        // isLoading={isLoadingEmail}
                      />
                    </div>
                    {otptimerEmail && (
                      <div
                        className={cssClasses.resendOtp}
                        style={{ width: "100%" }}
                      >
                        {" "}
                        Resend Otp in{" "}
                        <CountdownTimer
                          startFrom={180}
                          onComplete={() => {
                            setEmailLabelText("Resend Otp");
                            setOtpTimerEmail(false);
                          }}
                          timeFormatter={(time) => {
                            return (
                              <span>
                                {`0${Math.floor(time / 60)}`.slice(-2)}:
                                {`0${time % 60}`.slice(-2)}
                              </span>
                            );
                          }}
                        />
                      </div>
                    )}
                    {showEmailOtp && (
                      <div className={cssClasses.otpContainer}>
                        <input
                          className={cssClasses.otpInputEmail}
                          name="otp1"
                          type="text"
                          autoComplete="off"
                          value={emailState.otp1}
                          // onKeyPress={keyPressed}
                          onChange={(e) => optEmailChange("otp1", e)}
                          tabIndex="1"
                          maxLength="1"
                          onKeyUp={(e) => inputfocus(e)}
                          id="opt-0"
                        />
                        <input
                          name="otp2"
                          type="text"
                          autoComplete="off"
                          className={cssClasses.otpInputEmail}
                          value={emailState.otp2}
                          onChange={(e) => optEmailChange("otp2", e)}
                          tabIndex="2"
                          maxLength="1"
                          onKeyUp={(e) => inputfocus(e)}
                          id="opt-1"
                        />
                        <input
                          name="otp3"
                          type="text"
                          autoComplete="off"
                          className={cssClasses.otpInputEmail}
                          value={emailState.otp3}
                          onChange={(e) => optEmailChange("otp3", e)}
                          tabIndex="3"
                          maxLength="1"
                          onKeyUp={(e) => inputfocus(e)}
                          id="opt-2"
                        />
                        <input
                          name="otp4"
                          type="text"
                          autoComplete="off"
                          className={cssClasses.otpInputEmail}
                          value={emailState.otp4}
                          onChange={(e) => optEmailChange("otp4", e)}
                          tabIndex="4"
                          maxLength="1"
                          onKeyUp={(e) => inputfocus(e)}
                          id="opt-3"
                        />

                        <div>
                          <Button
                            tabIndex={5}
                            style={{
                              color: "#ffffff",
                              backgroundColor: "#155EEF",
                              fontSize: "1.4rem",
                              lineHeight: "2rem",
                            }}
                            btnName={"Submit OTP"}
                            clicked={submitEmailOtp}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
            {profileData.type === "FOS" ? (
              <>
                <p className={cssClasses.txt584}>Change CP</p>
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                  }}
                >
                  <ThemeProvider theme={theme}>
                    <Autocomplete
                      id="free-solo-2-demo"
                      sx={{
                        fontSize: "1.6rem !important",
                        fontFamily: "Inter-Medium !important",
                        lineHeight: "2.4rem !important",
                        borderColor: "none !important",
                        ".MuiOutlinedInput-root": {
                          background: "#F2F4F7",
                          borderRadius: "8px",
                          "&.Mui-focused": {
                            background: "#FFFFFF",
                            border: "1px solid #84CAFF !important",
                            boxShadow:
                              "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF;",
                          },
                        },
                        "& .MuiSvgIcon-root ": {
                          display: "none !important",
                        },
                      }}
                      value={CPEDetails}
                      options={getCPENAME.map((option) => {
                        return {
                          label: option.billingName,
                          value: option.cpId,
                        };
                      })}
                      PaperComponent={({ children }) => (
                        <Paper
                          style={{
                            fontFamily: "Inter-Medium",
                            fontSize: "1.6rem",
                          }}
                        >
                          {children}
                        </Paper>
                      )}
                      onChange={(event, newValue) => {
                        console.log(newValue);
                        setCPEDetails(newValue);
                        if (newValue !== null) {
                          //calling for update and check
                          // changeCPE(newValue);
                        }
                      }}
                      //  inputValue={CPDetails}
                      onInputChange={(event, newInputValue) => {
                        // setCPDetails(null);
                        if (newInputValue !== "") {
                          console.log(newInputValue);
                          getCPEDetails(newInputValue);
                        }
                      }}
                      disabled={
                        profileData.approvalStatus === "resubmitted"
                          ? true
                          : false
                      }
                      renderInput={(params) => (
                        <TextField
                          classes={{ root: classes.customTextField }}
                          sx={{
                            fontSize: "1.6rem !important",
                            fontFamily: "Inter-Medium !important",
                            lineHeight: "2.4rem !important",
                            " .MuiFormHelperText-root ": {
                              fontSize: "1.4rem !important",
                              fontFamily: "Inter-Medium",
                              lineHeight: "2rem",
                              marginLeft: "0rem !important",
                            },
                          }}
                          placeholder="Search CPE Name *"
                          {...params}
                          InputProps={{
                            ...params.InputProps,
                            type: "search",
                            style: { fontSize: "3rem" },
                          }}
                          onChange={(e, v) => {
                            getCPEDetails(e.target.value);
                          }}
                          helperText={helperText.CPEName}
                          error={helperText.CPEName !== ""}
                          disabled={
                            profileData.approvalStatus === "resubmitted"
                              ? true
                              : false
                          }
                        />
                      )}
                    />
                  </ThemeProvider>
                  {CPEDetails === null && (
                    <div
                      style={{
                        width: "2rem",
                        position: "absolute",
                        top: "2rem",
                        right: "1rem",
                      }}
                    >
                      <img src={SearchIcon} alt={"SearchIcon"} />
                    </div>
                  )}
                </div>

                {(profileData.approvalStatus === "approved" ||
                  profileData.approvalStatus === "pending") && (
                  <div style={{ marginTop: "1rem", textAlign: "right" }}>
                    <Button
                      style={{
                        color: "#ffffff",
                        backgroundColor: "#155EEF",
                        width: "auto",
                        fontSize: "1.4rem",
                        lineHeight: "2rem",
                      }}
                      clicked={() => {
                        console.log(CPEDetails);
                        if (CPEDetails !== null) {
                          changeCPE(CPEDetails);
                        } else {
                          errorTost("Please select CPE");
                          setEmailLabelText("");
                        }
                      }}
                      btnName={"Save Changes"}
                      loaderColor={"#fff"}
                    />
                  </div>
                )}
              </>
            ) : (
              <>
                <div
                  className={`${cssClasses.inputFields} ${cssClasses.flexRowVstartHstart}`}
                >
                  <div
                    className={`${cssClasses.inputField} ${cssClasses.flexColHstartVstart}`}
                  >
                    <div
                      className={`${cssClasses.inputWithLabel} ${cssClasses.flexColHstartVstart}`}
                    >
                      <p className={cssClasses.txt584}>RERA Number</p>
                      <div
                        className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
                      >
                        <div
                          className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}
                        >
                        <CustomInput
  value={generalDetail.reraNumber}
  inputType="label"
  position="end"
  labelText={
    canEditProfile(profileData) && !helperText.reraVerified
      ? "Verify"
      : ""
  }
  disabled={
    helperText.reraVerified || !canEditProfile(profileData)
  }
  greenTick={helperText.reraVerified}
  isLoading={isReraLoading}
  placeholder="Enter RERA Number"
  helperText={helperText.reraNumber}
  handleChange={(newValue) => {
    newValue = newValue.trim();
    var numbers = /^[a-zA-Z0-9]*$/;

    setHelperText((prev) => ({
      ...prev,
      reraVerified: false,
    }));

    setGeneralDetail((prev) => ({
      ...prev,
      reraNumber: newValue,
    }));

    if (
      (cpDetails?.gstApplicable === true || cpDetails?.gstApplicable === "true") &&
      !helperText.gstNumberVerified
    ) {
      errorTost("Please verify GST Number");
      return;
    }

    if (
      cpDetails.billingName.trim() !== "" &&
      newValue.length <= 13 &&
      numbers.test(newValue)
    ) {
      setHelperText((pre) => ({
        ...pre,
        reraVerified: false,
      }));

      setCpDetails((pre) => ({
        ...pre,
        reraNumber: newValue,
      }));
    }

    if (cpDetails.billingName === "") {
      errorTost("Please verify your PAN number first");
    }
  }}
  clicked={() => {
    const newValue = generalDetail.reraNumber?.trim()?.toUpperCase();
    const numbers = /^[a-zA-Z0-9]*$/;

    if (!newValue || newValue.length < 12 || !numbers.test(newValue)) {
      errorTost("Please enter a valid RERA number.");
      return;
    }

    if (
      (cpDetails?.gstApplicable === true || cpDetails?.gstApplicable === "true") &&
      !helperText.gstNumberVerified
    ) {
      errorTost("Please verify GST Number first.");
      return;
    }

    if (!cpDetails.billingName) {
      errorTost("Please verify your PAN number first");
      return;
    }

    setHelperText((pre) => ({
      ...pre,
      reraNumber: "verifying...",
    }));
    setIsReraLoading(true);
    reraApiCall(newValue);
  }}
/>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`${cssClasses.inputField1} ${cssClasses.flexColHstartVstart}`}
                  >
                    <div
                      className={`${cssClasses.inputWithLabel} ${cssClasses.flexColHstartVstart}`}
                    >
                      <p className={cssClasses.txt584}>Billing Name</p>
                      <div
                        className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
                      >
                        <div
                          className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}
                        >
                          {/* <CustomInput
                            value={cpDetails.billingName}
                            // label={"Billing Name"}
                            // mandatory={true}

                            handleChange={(newValue) => {
                              newValue = newValue.trimStart();
                              var alphabet = /^[A-Z*\sa-z]*$/;
                              if (newValue.match(alphabet) || newValue === "") {
                                if (newValue.length <= 40) {
                                  setCpDetails((pre) => {
                                    pre.billingName = newValue;
                                    return Object.assign({}, pre);
                                  });
                                }
                              }
                              // if (newValue !== "") {
                              //   setHelperText((pre) => {
                              //     pre.isBillingName = "";
                              //     return { ...pre };
                              //   });
                              // }
                            }}
                            placeholder="Billing Name"
                            inputType="label"
                            helperText={helperText.isBillingName}
                            disabled={true}
                          /> */}


                          <CustomInput
  value={
    cpDetails.billingName && helperText.reraVerified
      ? cpDetails.billingName // ✅ Show updated name after RERA verification
      : profileData.billingName || "" // ✅ Show saved name on initial load
  }
  handleChange={(newValue) => {
    newValue = newValue.trimStart();
    const alphabet = /^[A-Z*\sa-z]*$/;

    if (newValue.match(alphabet) || newValue === "") {
      if (newValue.length <= 40) {
        setCpDetails((pre) => ({
          ...pre,
          billingName: newValue,
        }));
      }
    }
  }}
  placeholder="Billing Name"
  inputType="label"
  helperText={helperText.isBillingName}
  disabled={true} // remains read-only unless you enable later
/>


                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* CP Sourcing - read-only name behind CP.cpSourceId, resolved
                    from Users. Shows "-" when no sourcing user is set. */}
                <div
                  className={`${cssClasses.inputFields} ${cssClasses.flexRowVstartHstart}`}
                >
                  <div
                    className={`${cssClasses.inputField} ${cssClasses.flexColHstartVstart}`}
                  >
                    <div
                      className={`${cssClasses.inputWithLabel} ${cssClasses.flexColHstartVstart}`}
                    >
                      <p className={cssClasses.txt584}>CP Sourcing</p>
                      <div
                        className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
                      >
                        <div
                          className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}
                        >
                          <CustomInput
                            value={cpSourceName || "-"}
                            inputType="label"
                            placeholder="CP Sourcing"
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`${cssClasses.inputFields} ${cssClasses.flexRowVstartHstart}`}
                >
                  <div
                    className={`${cssClasses.inputField} ${cssClasses.flexColHstartVstart}`}
                  >
                    <div
                      className={`${cssClasses.inputWithLabel} ${cssClasses.flexColHstartVstart}`}
                    >
                      <p className={cssClasses.txt584}>MSME Type</p>
                      <div
                        className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
                      >
                        <div
                          className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}
                        >
                          <DropDown
                            list={MSMEList}
                            selectedValue={profileData.msmeType}
                            style={{
                              background: "#F2F4F7",
                              color: "rgb(102, 112, 133)",
                              width: "50%!important",
                            }}
                            onChangeSelect={(_value) => {
                              profileData.msmeNumber = "";
                              setProfileData((pre) => {
                                pre["msmeType"] = _value;
                                return Object.assign({}, pre);
                              });
                              setHelperText((pre) => {
                                pre.isMemeNumber = "";
                                return Object.assign({}, pre);
                              });
                            }}
                            helperText={helperText.isMemeNumber}
                            disable={
                              !canEditProfile(loggedInUser.user)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {profileData.msmeType !== "Not Applicable" &&
                    profileData.msmeType !== "" && (
                      <div
                        className={`${cssClasses.inputField1} ${cssClasses.flexColHstartVstart}`}
                      >
                        <div
                          className={`${cssClasses.inputWithLabel} ${cssClasses.flexColHstartVstart}`}
                        >
                          <p className={cssClasses.txt584}>MSME Number</p>
                          <div
                            className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
                          >
                            <div
                              className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}
                            >
                              <CustomInput
                                value={profileData.msmeNumber}
                                handleChange={(newValue) => {
                                  var alphaNumeric = /^[a-zA-Z0-9]*$/;
                                  if (
                                    newValue.match(alphaNumeric) ||
                                    newValue === ""
                                  ) {
                                    if (newValue.length <= 20) {
                                      setProfileData({
                                        ...profileData,
                                        msmeNumber: newValue,
                                      });
                                    }
                                  }

                                  if (newValue !== "") {
                                    setHelperText((pre) => {
                                      pre.msmeNumber = "";
                                      return { ...pre };
                                    });
                                  } else {
                                    setHelperText((pre) => {
                                      pre.msmeNumber =
                                        "Please Enter MSME Number";
                                      return { ...pre };
                                    });
                                  }
                                }}
                                placeholder="MSME Number"
                                inputType="label"
                                helperText={helperText.msmeNumber}
                                disabled={
                                  !canEditProfile(loggedInUser.user)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                </div>
                <div
                  className={`${cssClasses.inputFields} ${cssClasses.flexRowVstartHstart}`}
                >
                  <div
                    className={`${cssClasses.inputField} ${cssClasses.flexColHstartVstart}`}
                  >
                    <div
                      className={`${cssClasses.inputWithLabel} ${cssClasses.flexColHstartVstart}`}
                    >
                      <p className={cssClasses.txt584}>Bank Account Number</p>
                      <div
                        className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
                      >
                        <div
                          className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}
                        >
                     
                

{/* 
<CustomInput
  value={bankDetails.accountNumber || ""}
  // label={"Account Number"}
  // mandatory={true}
  disabled={helperText.bankDetailsIsVerified || profileData.approvalStatus !== "rejected"} // ✅ same pattern as RERA
  greenTick={helperText.bankDetailsIsVerified}
  isLoading={isLoadingAccount}
  placeholder="Account Number"
  helperText={helperText.isAccountNumber}
  handleChange={(newValue) => {
    const numbers = /^[0-9]*$/;
    if (newValue.match(numbers) || newValue === "") {
      if (newValue.length <= 18) {
        setBankDetails((pre) => ({
          ...pre,
          accountNumber: newValue,
        }));


      

    // ✅ Additional verification checks before allowing bank verification
    if (
      (cpDetails?.gstApplicable === true || cpDetails?.gstApplicable === "true") &&
      !helperText.gstNumberVerified
    ) {
      errorTost("Please verify GST Number");
      return;
    }
    if (!helperText.reraVerified) {
      errorTost("Please verify RERA Number");
      return;
    }
    if (!helperText.panVerified) {
      errorTost("Please verify PAN Number");
      return;
    }







        if (bankDetails.ifscCode !== "") {
          helperText.bankDetailsIsVerified = false;
          helperText.isAccountNumber = "verifying...";
          debouncedBankDetailsCall();
        } else {
          helperText.bankDetailsIsVerified = false;
          helperText.isAccountNumber = "Please Enter Valid Ifsc code";
        }
      }
    }

    if (newValue === "") {
      helperText.isAccountNumber = "Please Enter Account Number";
    } else {
      helperText.isAccountNumber = "";
    }
  }}
/> */}


{/* <CustomInput
  value={bankDetails.accountNumber || ""}
  // label={"Account Number"}
  // mandatory={true}
  disabled={helperText.bankDetailsIsVerified || profileData.approvalStatus !== "rejected"} // ✅ same pattern as RERA
  greenTick={helperText.bankDetailsIsVerified}
  isLoading={isLoadingAccount}
  placeholder="Account Number"
  helperText={helperText.isAccountNumber}
  handleChange={(newValue) => {
    const numbers = /^[0-9]*$/;
    if (newValue.match(numbers) || newValue === "") {
      if (newValue.length <= 18) {
        setBankDetails((pre) => ({
          ...pre,
          accountNumber: newValue,
        }));

        // ✅ Additional verification checks before allowing bank verification
        if (
          (cpDetails?.gstApplicable === true || cpDetails?.gstApplicable === "true") &&
          !helperText.gstNumberVerified
        ) {
          errorTost("Please verify GST Number");
          return;
        }
        if (!helperText.reraVerified) {
          errorTost("Please verify RERA Number");
          return;
        }
        if (!helperText.panVerified) {
          errorTost("Please verify PAN Number");
          return;
        }

        if (bankDetails.ifscCode !== "") {
          helperText.bankDetailsIsVerified = false;
          helperText.isAccountNumber = "verifying...";
          debouncedBankDetailsCall();
        } else {
          helperText.bankDetailsIsVerified = false;
          helperText.isAccountNumber = "Please Enter Valid Ifsc code";
        }
      }
    }

    if (newValue === "") {
      helperText.isAccountNumber = "Please Enter Account Number";
    } else {
      helperText.isAccountNumber = "";
    }
  }}
/> */}



<CustomInput
  value={bankDetails.accountNumber || ""}
  // label={"Account Number"}
  // mandatory={true}
  disabled={helperText.bankDetailsIsVerified || !canEditProfile(profileData)} // ✅ same pattern as RERA
  greenTick={helperText.bankDetailsIsVerified}
  isLoading={isLoadingAccount}
  placeholder="Account Number"
  helperText={helperText.isAccountNumber}
  handleChange={(newValue) => {
    const numbers = /^[0-9]*$/;
    if (newValue.match(numbers) || newValue === "") {
      if (newValue.length <= 18) {
        setBankDetails((pre) => ({
          ...pre,
          accountNumber: newValue,
        }));

        // ✅ keep your pre-checks (unchanged)
        if (
          (cpDetails?.gstApplicable === true || cpDetails?.gstApplicable === "true") &&
          !helperText.gstNumberVerified
        ) {
          errorTost("Please verify GST Number");
          return;
        }
        if (!helperText.reraVerified) {
          errorTost("Please verify RERA Number");
          return;
        }
        if (!helperText.panVerified) {
          errorTost("Please verify PAN Number");
          return;
        }

        // 🧹 removed auto-verify (no debouncedBankDetailsCall, no "verifying..." here)
        // still show guidance if IFSC missing
        if (!bankDetails.ifscCode) {
          helperText.bankDetailsIsVerified = false;
          helperText.isAccountNumber = "Please Enter Valid Ifsc code";
        } else {
          helperText.bankDetailsIsVerified = false;
          helperText.isAccountNumber = "";
        }
      }
    }

    if (newValue === "") {
      helperText.isAccountNumber = "Please Enter Account Number";
    } else if (newValue.length > 0) {
      // keep clean state while typing
      helperText.isAccountNumber = "";
    }
  }}
/>















                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`${cssClasses.inputField1} ${cssClasses.flexColHstartVstart}`}
                  >
                    <div
                      className={`${cssClasses.inputWithLabel} ${cssClasses.flexColHstartVstart}`}
                    >
                      <p className={cssClasses.txt584}>IFSC Code</p>
                      <div
                        className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
                      >
                        <div
                          className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}
                        >
                       

{/* 
<CustomInput
  value={bankDetails.ifscCode || ""}
  // label={"IFSC Code"}
  // mandatory={true}
  disabled={helperText.bankDetailsIsVerified || profileData.approvalStatus !== "rejected"} // ✅ same pattern as RERA
  greenTick={helperText.bankDetailsIsVerified}
  isLoading={isLoadingIfSC}
  placeholder="IFSC Code"
  helperText={helperText.isIfscCode}
  handleChange={(newValue) => {
    const code = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    newValue = newValue.trimStart();

    if (newValue === "") {
      helperText.isIfscCode = "Please Enter IFSC Code";
    } else {
      helperText.isIfscCode = "";
    }

    if (newValue.length <= 11) {
      setBankDetails((pre) => ({
        ...pre,
        ifscCode: newValue,
      }));





      
    // ✅ Additional verification checks before allowing bank verification
    if (
      (cpDetails?.gstApplicable === true || cpDetails?.gstApplicable === "true") &&
      !helperText.gstNumberVerified
    ) {
      errorTost("Please verify GST Number");
      return;
    }
    if (!helperText.reraVerified) {
      errorTost("Please verify RERA Number");
      return;
    }
    if (!helperText.panVerified) {
      errorTost("Please verify PAN Number");
      return;
    }



    

      if (newValue.length === 11 && code.test(newValue)) {
        helperText.isIfscCode = "verifying...";
        checkBankDetails(bankDetails.accountNumber, newValue);
      } else if (newValue.length === 11) {
        helperText.bankDetailsIsVerified = false;
        helperText.isIfscCode = "Please Enter Valid IFSC code";
      }
    }
  }}
/> */}



{/* <CustomInput
  value={bankDetails.ifscCode || ""}
  inputType="label"
  position="end"
  labelText={
    profileData.approvalStatus === "rejected" && !helperText.bankDetailsIsVerified
      ? "Verify"
      : ""
  }
  // mandatory={true}
  disabled={helperText.bankDetailsIsVerified || profileData.approvalStatus !== "rejected"} // ✅ same pattern as RERA
  greenTick={helperText.bankDetailsIsVerified}
  isLoading={isLoadingIfSC}
  placeholder="IFSC Code"
  helperText={helperText.isIfscCode}
  handleChange={(newValue) => {
    const code = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    newValue = newValue.trimStart();

    if (newValue === "") {
      helperText.isIfscCode = "Please Enter IFSC Code";
    } else {
      helperText.isIfscCode = "";
    }

    if (newValue.length <= 11) {
      setBankDetails((pre) => ({
        ...pre,
        ifscCode: newValue,
      }));

      // ✅ Additional verification checks before allowing bank verification
      if (
        (cpDetails?.gstApplicable === true || cpDetails?.gstApplicable === "true") &&
        !helperText.gstNumberVerified
      ) {
        errorTost("Please verify GST Number");
        return;
      }
      if (!helperText.reraVerified) {
        errorTost("Please verify RERA Number");
        return;
      }
      if (!helperText.panVerified) {
        errorTost("Please verify PAN Number");
        return;
      }

      if (newValue.length === 11 && code.test(newValue)) {
        helperText.isIfscCode = "verifying...";
        checkBankDetails(bankDetails.accountNumber, newValue);
      } else if (newValue.length === 11) {
        helperText.bankDetailsIsVerified = false;
        helperText.isIfscCode = "Please Enter Valid IFSC code";
      }
    }
  }}
  clicked={() => {
    // ✅ Manual verify via button (doesn't change your existing logic)
    if (
      (cpDetails?.gstApplicable === true || cpDetails?.gstApplicable === "true") &&
      !helperText.gstNumberVerified
    ) {
      errorTost("Please verify GST Number");
      return;
    }
    if (!helperText.reraVerified) {
      errorTost("Please verify RERA Number");
      return;
    }
    if (!helperText.panVerified) {
      errorTost("Please verify PAN Number");
      return;
    }

    const ifsc = (bankDetails.ifscCode || "").trim().toUpperCase();
    const code = /^[A-Z]{4}0[A-Z0-9]{6}$/;

    if (!code.test(ifsc)) {
      helperText.bankDetailsIsVerified = false;
      errorTost("Please Enter Valid IFSC code");
      return;
    }
    if (!bankDetails.accountNumber) {
      helperText.bankDetailsIsVerified = false;
      errorTost("Please Enter Account Number");
      return;
    }

    helperText.isIfscCode = "verifying...";
    checkBankDetails(bankDetails.accountNumber, ifsc);
  }}
/> */}



<CustomInput
  value={bankDetails.ifscCode || ""}
  inputType="label"
  position="end"
  labelText={
    canEditProfile(profileData) && !helperText.bankDetailsIsVerified
      ? "Verify"
      : ""
  }
  // mandatory={true}
  disabled={helperText.bankDetailsIsVerified || !canEditProfile(profileData)} // ✅ same pattern as RERA
  greenTick={helperText.bankDetailsIsVerified}
  isLoading={isLoadingIfSC}
  placeholder="IFSC Code"
  helperText={helperText.isIfscCode}
  handleChange={(newValue) => {
    const code = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    newValue = newValue.trimStart();

    if (newValue === "") {
      helperText.isIfscCode = "Please Enter IFSC Code";
    } else {
      helperText.isIfscCode = "";
    }

    if (newValue.length <= 11) {
      setBankDetails((pre) => ({
        ...pre,
        ifscCode: newValue,
      }));

      // ✅ keep your pre-checks (unchanged)
      if (
        (cpDetails?.gstApplicable === true || cpDetails?.gstApplicable === "true") &&
        !helperText.gstNumberVerified
      ) {
        errorTost("Please verify GST Number");
        return;
      }
      if (!helperText.reraVerified) {
        errorTost("Please verify RERA Number");
        return;
      }
      if (!helperText.panVerified) {
        errorTost("Please verify PAN Number");
        return;
      }

      // 🧹 removed auto-verify call here (no checkBankDetails)
      // keep invalid message if 11 chars but wrong format
      if (newValue.length === 11 && !code.test(newValue)) {
        helperText.bankDetailsIsVerified = false;
        helperText.isIfscCode = "Please Enter Valid IFSC code";
      }
    }
  }}
  clicked={() => {
    // ✅ manual verify only from here
    if (
      (cpDetails?.gstApplicable === true || cpDetails?.gstApplicable === "true") &&
      !helperText.gstNumberVerified
    ) {
      errorTost("Please verify GST Number");
      return;
    }
    if (!helperText.reraVerified) {
      errorTost("Please verify RERA Number");
      return;
    }
    if (!helperText.panVerified) {
      errorTost("Please verify PAN Number");
      return;
    }

    const ifsc = (bankDetails.ifscCode || "").trim().toUpperCase();
    const code = /^[A-Z]{4}0[A-Z0-9]{6}$/;

    if (!code.test(ifsc)) {
      helperText.bankDetailsIsVerified = false;
      errorTost("Please Enter Valid IFSC code");
      return;
    }
    if (!bankDetails.accountNumber) {
      helperText.bankDetailsIsVerified = false;
      errorTost("Please Enter Account Number");
      return;
    }

    helperText.isIfscCode = "verifying...";
    checkBankDetails(bankDetails.accountNumber, ifsc);
  }}
/>






                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`${cssClasses.inputFields} ${cssClasses.flexRowVstartHstart}`}
                >
                  <div
                    className={`${cssClasses.inputField} ${cssClasses.flexColHstartVstart}`}
                  >
                    <div
                      className={`${cssClasses.inputWithLabel} ${cssClasses.flexColHstartVstart}`}
                    >
                      <p className={cssClasses.txt584}>
                        Bank Account Holder Name
                      </p>
                      <div
                        className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
                      >
                        <div
                          className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}
                        >
                          {/* <CustomInput
                            value={bankDetails.holderName}
                            // label={"Account Holder Name"}
                            // mandatory={true}
                            handleChange={(newValue) => {
                              newValue = newValue.trimStart();
                              var alphabet = /^[A-Z*\sa-z]*$/;
                              if (newValue.match(alphabet) || newValue === "") {
                                if (newValue.length <= 40) {
                                  setBankDetails((pre) => {
                                    pre.holderName = newValue;
                                    return Object.assign({}, pre);
                                  });
                                }
                              }

                              // if (newValue === "") {
                              //   helperText.isHolderName = "Please Enter Holder Name";
                              // } else {
                              //   helperText.isHolderName = "";
                              // }
                            }}
                            placeholder="Account Holder Name"
                            inputType="label"
                            helperText={helperText.isHolderName}
                            disabled={true}
                          /> */}



<CustomInput
  value={bankDetails.holderName || ""}
  placeholder="Account Holder Name"
  inputType="label"
  helperText={helperText.isHolderName}
  disabled={true} // stays read-only unless you want it editable
  handleChange={(newValue) => {
    newValue = newValue.trimStart();
    const alphabet = /^[A-Z*\sa-z]*$/;

    if (newValue.match(alphabet) || newValue === "") {
      if (newValue.length <= 40) {
        setBankDetails((pre) => ({
          ...pre,
          holderName: newValue,
        }));
      }
    }
  }}
/>



                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`${cssClasses.inputField1} ${cssClasses.flexColHstartVstart}`}
                  >
                    <div
                      className={`${cssClasses.inputWithLabel} ${cssClasses.flexColHstartVstart}`}
                    >
                      <p className={cssClasses.txt584}>Bank Branch</p>
                      <div
                        className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
                      >
                        <div
                          className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}
                        >
                          <CustomInput
                            value={profileData.bankBranchName}
                            handleChange={(newValue) => {
                              if (newValue === "") {
                                setHelperText({
                                  ...helperText,
                                  bankBranchName: "Please Enter Branch Name",
                                });
                              } else {
                                setHelperText({
                                  ...helperText,
                                  bankBranchName: "",
                                });
                              }
                              setProfileData({
                                ...profileData,
                                bankBranchName: newValue,
                              });
                            }}
                            inputType="label"
                            disabled={
                              !canEditProfile(loggedInUser.user)
                            }
                            helperText={helperText.bankBranchName}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* This is used for cp Phone */}
                <div
                  className={`${cssClasses.inputField3} ${cssClasses.flexColHstartVstart}`}
                >
                  <div
                    className={`${cssClasses.inputWithLabel1} ${cssClasses.flexColHstartVstart}`}
                  >
                    <div
                      className={`${cssClasses.inputWithLabel} ${cssClasses.flexColHstartVstart}`}
                    >
                      <p className={cssClasses.txt584}>
                        Phone Number <span style={{ color: "red" }}> *</span>
                      </p>
                      <div
                        className={`${cssClasses.input} ${cssClasses.flexRowVcenterHstart} ${cssClasses.clipContents}`}
                      >
                        <div
                          style={{ position: "relative", top: "0rem" }}
                          className={`${cssClasses.content1} ${cssClasses.flexRowVcenterHstart}`}
                        >
                          <PhoneInput
                            //  style={{
                            //   width: '50%'
                            // }}
                            defaultCountry="IN"
                            value={
                              loggedInUser?.user?.contactNumber?.toString()
                                .length === 10
                                ? "+91" + loggedInUser.user.contactNumber
                                : "+" + loggedInUser.user.contactNumber
                            }
                            placeholder="Enter phone number"
                            disabled={
                              showOtp ||
                              resendButton ||
                              helperText.disableContactNumber ||
                              !canEditProfile(loggedInUser.user)
                            }
                            onChange={(phone) => {
                              // console.log(phone);
                              if (phone !== undefined) {
                                // setVerifiedPhoneNumber(false);
                                if (phone.length >= 1) {
                                  if (isValidPhoneNumber(phone) === false) {
                                    // setVerifiedPhoneNumber(false);
                                    setHelperText((pre) => {
                                      pre.isPhoneNumber =
                                        "Please Enter valid Phone Number";
                                      return { ...pre };
                                    });
                                    // setShowOtp(false);
                                  } else {
                                    setHelperText((pre) => {
                                      pre.isPhoneNumber = "verifying...";
                                      return { ...pre };
                                    });
                                    const newPhoneNumber2 = parseInt(
                                      phone.substring(1)
                                    );
                                    console.log(
                                      oldPhoneNumber,
                                      newPhoneNumber2
                                    );
                                    if (oldPhoneNumber !== newPhoneNumber2) {
                                      IsNumberBlackListed(phone);
                                    } else {
                                      setHelperText((pre) => {
                                        pre.isPhoneNumber = "";
                                        return { ...pre };
                                      });
                                    }
                                    // if (
                                    //   personDetail.phoneNumber.substring(0, 3) === "+91"
                                    // ) {
                                    //   setIsInterNational(false);
                                    // } else {
                                    //   setIsInterNational(true);
                                    // }
                                  }
                                }
                              } else {
                                setHelperText((pre) => {
                                  pre.isPhoneNumber =
                                    "Please Enter  Phone Number";
                                  return { ...pre };
                                });

                                // setShowOtp(false);
                              }
                              console.log(phone);
                              setNewPhoneNumber(phone);
                            }}
                          />
                          {/* <p
                style={{ color: "red", fontSize: "1.4rem", lineHeight: "1.66" }}
              >
                {helperText.isPhoneNumber}
              </p> */}
                          {helperText.isPhoneNumber === "" &&
                            verifiedPhoneNumber.current === false &&
                            otptimer === false &&
                            showOtp === false &&
                            profileData.contactNumber !== "" &&
                            !helperText.disableContactNumber &&
                            helperText.onChangePhoneNumber && (
                              <div
                                className={cssClasses.verifyOtp}
                                onClick={() => {
                                  smsApiCall();
                                }}
                              >
                                Verify Otp
                              </div>
                            )}

                          {verifiedPhoneNumber.current === false &&
                            showOtp === true &&
                            resendButton === true && (
                              <div
                                className={cssClasses.verifyOtp}
                                onClick={() => {
                                  setHelperText((pre) => {
                                    pre.isPhoneNumber = "";
                                    return { ...pre };
                                  });
                                  if (resendButton) {
                                    smsApiCall();
                                    // successTost("Otp has been sent");
                                  } else {
                                    console.log("Please wait for 3 min");
                                  }
                                }}
                              >
                                Resend Otp
                              </div>
                            )}
                          {verifiedPhoneNumber.current === false &&
                            showOtp === true &&
                            resendButton === false && (
                              <div className={cssClasses.resendOtp}>
                                {" "}
                                Resend Otp in{" "}
                                {/* <Countdown date={startDate.current+ 180000} renderer={renderer} /> */}
                                <CountdownTimer
                                  startFrom={180}
                                  onComplete={() => {
                                    setResendButton(true);
                                  }}
                                  timeFormatter={(time) => {
                                    return (
                                      <span>
                                        {`0${Math.floor(time / 60)}`.slice(-2)}:
                                        {`0${time % 60}`.slice(-2)}
                                      </span>
                                    );
                                  }}
                                />
                              </div>
                            )}
                          {helperText.isPhoneNumber === "" &&
                            verifiedPhoneNumber.current &&
                            otptimer === false && (
                              <div className={cssClasses.verifyOtp}>
                                <CheckCircleSharpIcon
                                  style={{
                                    fontSize: "2.5rem",
                                    marginRight: "1rem",
                                  }}
                                  color={"success"}
                                />
                              </div>
                            )}
                          {showOtp && (
                            <div className={cssClasses.otpContainer}>
                              <input
                                className={cssClasses.otpInput}
                                name="otp1"
                                type="text"
                                autoComplete="off"
                                value={state.otp1}
                                // onKeyPress={keyPressed}
                                onChange={(e) => optChange("otp1", e)}
                                tabIndex="1"
                                maxLength="1"
                                onKeyUp={(e) => inputfocus(e)}
                                id="opt-0"
                              />
                              <input
                                name="otp2"
                                type="text"
                                autoComplete="off"
                                className={cssClasses.otpInput}
                                value={state.otp2}
                                onChange={(e) => optChange("otp2", e)}
                                tabIndex="2"
                                maxLength="1"
                                onKeyUp={(e) => inputfocus(e)}
                                id="opt-1"
                              />
                              <input
                                name="otp3"
                                type="text"
                                autoComplete="off"
                                className={cssClasses.otpInput}
                                value={state.otp3}
                                onChange={(e) => optChange("otp3", e)}
                                tabIndex="3"
                                maxLength="1"
                                onKeyUp={(e) => inputfocus(e)}
                                id="opt-2"
                              />
                              <input
                                name="otp4"
                                type="text"
                                autoComplete="off"
                                className={cssClasses.otpInput}
                                value={state.otp4}
                                onChange={(e) => optChange("otp4", e)}
                                tabIndex="4"
                                maxLength="1"
                                onKeyUp={(e) => inputfocus(e)}
                                id="opt-3"
                              />

                              <div>
                                <Button
                                  tabIndex={5}
                                  style={{
                                    color: "#ffffff",
                                    backgroundColor: "#155EEF",
                                    fontSize: "1.4rem",
                                    lineHeight: "2rem",
                                  }}
                                  btnName={"Submit OTP"}
                                  clicked={submitOtp}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <p
                        style={{
                          color: "red",
                          fontSize: "1.4rem",
                          lineHeight: "1.66",
                        }}
                      >
                        {helperText.isPhoneNumber}
                      </p>
                    </div>
                  </div>
                </div>
                {/* This is used for cp email */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <div className={cssClasses.wrapperEmail}>
                    <div style={{ width: "100%", textAlign: "left" }}>
                      <CustomInput
                      
                        value={newEmailId}
                        label={"Email1"}
                        mandatory={true}
                        inputType={"label"}
                        position={"end"}
                        greenTick={verifiedEmail.current === true}
                        labelText={emailLabelText}
                        disabled={
                          showEmailOtp ||
                          helperText.disableEmail ||
                          !canEditProfile(profileData)
                        }
                        clicked={(e) => {
                          console.log(e);
                          if (e === "Send Otp") {
                            sendOtpToVerifyEmail(e);
                          } else if (e === "Resend Otp") {
                            sendOtpToVerifyEmail(e);
                          }
                        }}
                        handleChange={(newValue) => {
                          verifiedEmail.current = false;
                          console.log({ newValue });
                          setEmailLabelText("");
                          newValue = newValue.trimStart();
                          const emailIDCond = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                          if (!newValue.trim()) {
                            setEmailLabelText("");
                            helperText.email = "Please Enter Email Id";
                          } else if (!newValue.match(emailIDCond)) {
                            setEmailLabelText("");
                            helperText.email =
                              "Please Enter Email in Proper Format";
                          } else {
                            setEmailLabelText("");
                            helperText.email = "verifying...";
                            if (
                              newValue !== "" &&
                              loggedInUser.user.email !== newValue
                            ) {
                              setEmailLabelText("");
                              checkEmailExists(newValue);
                            } else if (newValue === "") {
                              console.log("hii");
                              setEmailLabelText("");
                            } else {
                              helperText.email = "";
                              setEmailLabelText("");
                            }
                          }
                          if (newValue.length <= 100) {
                            setEmailId(newValue);
                          }
                        }}
                        placeholder="Enter contact person Email"
                        helperText={helperText.email}
                        // isLoading={isLoadingEmail}
                      />
                    </div>
                    {otptimerEmail && (
                      <div
                        className={cssClasses.resendOtp}
                        style={{ width: "100%" }}
                      >
                        {" "}
                        Resend Otp in{" "}
                        <CountdownTimer
                          startFrom={180}
                          onComplete={() => {
                            setEmailLabelText("Resend Otp");
                            setOtpTimerEmail(false);
                          }}
                          timeFormatter={(time) => {
                            return (
                              <span>
                                {`0${Math.floor(time / 60)}`.slice(-2)}:
                                {`0${time % 60}`.slice(-2)}
                              </span>
                            );
                          }}
                        />
                      </div>
                    )}
                    {showEmailOtp && (
                      <div className={cssClasses.otpContainer}>
                        <input
                          className={cssClasses.otpInputEmail}
                          name="otp1"
                          type="text"
                          autoComplete="off"
                          value={emailState.otp1}
                          // onKeyPress={keyPressed}
                          onChange={(e) => optEmailChange("otp1", e)}
                          tabIndex="1"
                          maxLength="1"
                          onKeyUp={(e) => inputfocus(e)}
                          id="opt-0"
                        />
                        <input
                          name="otp2"
                          type="text"
                          autoComplete="off"
                          className={cssClasses.otpInputEmail}
                          value={emailState.otp2}
                          onChange={(e) => optEmailChange("otp2", e)}
                          tabIndex="2"
                          maxLength="1"
                          onKeyUp={(e) => inputfocus(e)}
                          id="opt-1"
                        />
                        <input
                          name="otp3"
                          type="text"
                          autoComplete="off"
                          className={cssClasses.otpInputEmail}
                          value={emailState.otp3}
                          onChange={(e) => optEmailChange("otp3", e)}
                          tabIndex="3"
                          maxLength="1"
                          onKeyUp={(e) => inputfocus(e)}
                          id="opt-2"
                        />
                        <input
                          name="otp4"
                          type="text"
                          autoComplete="off"
                          className={cssClasses.otpInputEmail}
                          value={emailState.otp4}
                          onChange={(e) => optEmailChange("otp4", e)}
                          tabIndex="4"
                          maxLength="1"
                          onKeyUp={(e) => inputfocus(e)}
                          id="opt-3"
                        />

                        <div>
                          <Button
                            tabIndex={5}
                            style={{
                              color: "#ffffff",
                              backgroundColor: "#155EEF",
                              fontSize: "1.4rem",
                              lineHeight: "2rem",
                            }}
                            btnName={"Submit OTP"}
                            clicked={submitEmailOtp}
                          />
                        </div>
                      </div>
                    )}
                  </div>

                  {/* {verifiedEmail.current&&(
              <div>
                   <Button
                      tabIndex={5}
                      style={{
                        color: "#ffffff",
                        backgroundColor: "#155EEF",
                        fontSize: "1.4rem",
                        lineHeight: "2rem",
                      }}
                      btnName={"Update"}
                      clicked={()=>{
                        // Update Query Remaining
                        let obj={
                          email:updateProfile.email
                        }
                        updateLeadPersonTable(loggedInUser?.personId?.personId,obj).then((response)=>{
                          console.log({response});
                          successTost('Email updated successfully');
                          obj={
                            ...loggedInUser.personId,
                            email: updateProfile.email
                          }
                          dispatch(
                            actions.authLogin({
                              ...loggedInUser,
                              personId:obj,
                            }));
                        }).catch((err)=>{
                          console.log(err);
                        });
                        setHelperText((pre)=>{
                          pre.disableEmail=true;
                          return {...pre}
                        });
                        // setVerifiedEmail(false);
                        verifiedEmail.current=false;
                      }}
                    />
              </div>
            )} */}
                </div>
              </>
            )}
          </div>
        </div>
        {canEditProfile(loggedInUser.user) ? (
          <div
            className={`${cssClasses.sectionFooter} ${cssClasses.flexColHcenterVstart}`}
          >
            <div
              className={`${cssClasses.content5} ${cssClasses.flexRowVcenterHend}`}
            >
              <div
                className={`${cssClasses.actions} ${cssClasses.flexRowVcenterHend}`}
              >
                <Button
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#155EEF",
                    width: "auto",
                    fontSize: "1.4rem",
                    lineHeight: "2rem",
                  }}
                  clicked={
                    profileData.type === "CP"
                      ? () =>
                          updateProfileDataCP(profileData.cpId, oldPan, oldRera)
                      : () => updateProfileDataFOS(profileData.fosId)
                  }
                  btnName={"Save Changes"}
                  loaderColor={"#fff"}
                />
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      {showAlertForEmailUpdate && (
        <ConfirmationAlert
          confirm={(e) => {
            console.log("e --> ", e);
            if (e === "confirmed") {
              setShowAlertForEmailUpdate(false);
              logoutUser();
            }
          }}
          // buttonTitle={"Done"}
          returnRespButton={"Done"}
          // close={() => {
          //   setSentEmail(false);
          // }}
          title={"Verify Email"}
          subTitle={`An link has been sent to your new  registered email-id for confirmation. Click on the link and  Please login through your new email-id`}
          open={showAlertForEmailUpdate}
        />
      )}
    </div>
    
  );
 
};

export default Profile;
